(function(){try{if(typeof document<`u`){var e=document.createElement(`style`);e.appendChild(document.createTextNode(`.modal .modal-close-button{display:block;margin-left:auto;margin-right:auto}.hidden-item{display:none}.button-area{display:flex;justify-content:flex-end;gap:var(--spacing-inset-size-lg);padding:var(--spacing-inset-size-lg);background-color:var(--color-neutral-background)}.message-area{padding:var(--spacing-inset-size-lg);padding-top:2px;font-size:var(--font-size-default);padding-bottom:var(--spacing-inset-size-2xl);display:flex;flex-direction:column;gap:var(--spacing-inset-size-sm)}.abi-modal-header{padding:0!important}.abi-modal-container .abi-modal-content{padding:0!important;margin:0!important;border-radius:var(--border-radius-md)}.abi-modal-header-title{padding:var(--spacing-inset-size-lg)!important;padding-bottom:var(--spacing-inset-size-sm)!important}`)),document.head.appendChild(e)}}catch(e){console.error(`vite-plugin-css-injected-by-js`,e)}})();/*
Copyright (C) Anheuser-Busch InBev SA/NV. ALL RIGHTS RESERVED.

This software product is a proprietary product of Anheuser-Busch Inbev SA/NV (the "Company") and all right, title, and interest in and to the software product, including all associated intellectual property rights, are and shall remain exclusively with the Company. All rights in or to the software product are licensed, not sold. All rights not licensed are reserved.

This software product is governed by the End User License Agreement provided with the software product.

*/
import { a as e, c as t, i as n, l as r, n as i, r as a, s as o, t as s, u as c } from "./hooks-BzNInuAU.js";
import l, { Suspense as u, createContext as d, createElement as f, forwardRef as p, useCallback as m, useContext as h, useEffect as g, useImperativeHandle as _, useMemo as v, useRef as y, useState as b } from "react";
import { Fragment as x, jsx as S, jsxs as C } from "react/jsx-runtime";
import "react-router-dom";
import w from "react-dom";
import { useTranslation as T } from "react-i18next";
//#region src/roles/MsalRoleContext.tsx
var E = d([]), D = ({ accounts: e, msalInstance: t, roles: n, children: r }) => {
	let i = v(() => (() => {
		try {
			let n = e?.[0] ?? t?.getAllAccounts()[0];
			if (!n?.idTokenClaims) return null;
			if (n?.idTokenClaims && !n.idTokenClaims.roles) throw Error("User does not have roles");
			return n?.idTokenClaims?.roles;
		} catch (e) {
			console.warn(e);
		}
		return null;
	})() ?? n ?? [], [
		e,
		t,
		n
	]);
	return /* @__PURE__ */ S(E.Provider, {
		value: i,
		children: r
	});
}, O = d(null), k = ({ permissions: e, roleMapping: t, children: n }) => {
	let r = v(() => ({
		permissions: e,
		roleMapping: t
	}), [e, t]);
	return /* @__PURE__ */ S(O.Provider, {
		value: r,
		children: n
	});
}, A = (e) => {
	let t = h(E), n = h(O);
	if (!n) return console.warn("PermissionContext is not set. Make sure you've wrapped your component with PermissionProvider."), !1;
	let { permissions: r, roleMapping: i } = n;
	return !r || !i ? (console.warn("PermissionContext is not fully set. Make sure you've provided both permissions and roleMapping."), !1) : t ? t.some((t) => {
		let n = i[t];
		return r[n]?.[e] === !0;
	}) : (console.warn("MsalRoleContext is not set. Make sure you've wrapped your component with MsalRoleProvider."), !1);
}, j = {
	BVL: "App.All.Brewery.Bldv",
	BLDV: "App.All.Brewery.Bldv",
	CRE: "App.All.Brewery.Cre",
	CVL: "App.All.Brewery.Crtv",
	CRTV: "App.All.Brewery.Crtv",
	COL: "App.All.Brewery.Cob",
	EDM: "App.All.Brewery.Edm",
	FCL: "App.All.Brewery.Fcl",
	FFD: "App.All.Brewery.Ffd",
	HAL: "App.All.Brewery.Hfx",
	HTN: "App.All.Brewery.Htn",
	JAX: "App.All.Brewery.Jksv",
	JKSV: "App.All.Brewery.Jksv",
	LA: "App.All.Brewery.Lab",
	LON: "App.All.Brewery.Ldn",
	MER: "App.All.Brewery.Mer",
	MERR: "App.All.Brewery.Mer",
	NWK: "App.All.Brewery.Nwk",
	STL: "App.All.Brewery.Slb",
	MTL: "App.All.Brewery.Mtl",
	RPB: "App.All.Brewery.RPB",
	STJ: "App.All.Brewery.Stj",
	WMS: "App.All.Brewery.Wms"
}, M = ({ canDoItForAll: e, canDoItForOwnBrewery: t, brewery: n }) => {
	let r = A(e), i = A(t), a = h(E);
	if (r) return !0;
	if (i && n) {
		let e = j[n];
		return e ? a.some((t) => t === e) : !1;
	}
	return !1;
}, N = () => {
	let e = A;
	return m((t) => e(t), [e]);
}, P = (e, t) => (n) => (r) => A(e) ? /* @__PURE__ */ S(n, { ...r }) : t, F = d({ getToken: async () => null }), I = ({ msalInstance: e, fallbackInteraction: n, children: i }) => {
	let a = m(async (i) => {
		if (!e) return null;
		let a = {
			scopes: i,
			account: e.getAllAccounts()[0]
		};
		try {
			return (await e.acquireTokenSilent(a)).accessToken;
		} catch (a) {
			if (a instanceof r && a.errorCode === "interaction_in_progress") return null;
			if (a instanceof c || a instanceof r) try {
				return n === t.Redirect ? (await e.acquireTokenRedirect({ scopes: i }), null) : (await e.acquireTokenPopup({ scopes: i })).accessToken;
			} catch (e) {
				return console.error("Failed to acquire token interactively:", e), null;
			}
			return console.error("Failed to acquire token:", a), null;
		}
	}, [e, n]), o = v(() => ({ getToken: a }), [a]);
	return /* @__PURE__ */ S(F.Provider, {
		value: o,
		children: i
	});
}, L = d(void 0), R = ({ children: e }) => {
	let [t, n] = b({ roles: [] }), r = v(() => ({
		user: t,
		setUser: n
	}), [t]);
	return /* @__PURE__ */ S(L.Provider, {
		value: r,
		children: e
	});
}, z = ({ children: e, scopes: n, tokenFallbackInteraction: r }) => {
	let { accounts: o, instance: s } = a(), c = {
		scopes: [...n],
		state: `${window.location.pathname}`
	};
	return /* @__PURE__ */ S(i, {
		interactionType: t.Redirect,
		authenticationRequest: c,
		children: /* @__PURE__ */ S(I, {
			msalInstance: s,
			fallbackInteraction: r,
			children: /* @__PURE__ */ S(D, {
				accounts: o,
				msalInstance: s,
				children: e
			})
		})
	});
}, ee = (e) => /* @__PURE__ */ S(n, {
	instance: s(e.clientId, e.tenantId, h(L), e.cacheLocation),
	children: /* @__PURE__ */ S(z, {
		cacheLocation: e.cacheLocation,
		clientId: e.clientId,
		scopes: e.scopes,
		tenantId: e.tenantId,
		tokenFallbackInteraction: e.tokenFallbackInteraction,
		children: e.children
	})
}), B = "16px", V = ({ className: e, width: t = B, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V10.2929L5.35355 8.14645C5.15829 7.95118 4.84171 7.95118 4.64645 8.14645C4.45118 8.34171 4.45118 8.65829 4.64645 8.85355L7.64645 11.8536C7.84171 12.0488 8.15829 12.0488 8.35355 11.8536L11.3536 8.85355C11.5488 8.65829 11.5488 8.34171 11.3536 8.14645C11.1583 7.95118 10.8417 7.95118 10.6464 8.14645L8.5 10.2929V4.5Z" })
	});
};
V.category = "Shape Arrows";
var te = "16px", ne = ({ className: e, width: t = te, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 11.5C8.5 11.7761 8.27614 12 8 12C7.72386 12 7.5 11.7761 7.5 11.5V5.70711L5.35355 7.85355C5.15829 8.04882 4.84171 8.04882 4.64645 7.85355C4.45118 7.65829 4.45118 7.34171 4.64645 7.14645L7.64645 4.14645C7.84171 3.95118 8.15829 3.95118 8.35355 4.14645L11.3536 7.14645C11.5488 7.34171 11.5488 7.65829 11.3536 7.85355C11.1583 8.04882 10.8417 8.04882 10.6464 7.85355L8.5 5.70711V11.5Z" })
	});
};
ne.category = "Shape Arrows";
var H = "16px", re = ({ className: e, width: t = H, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8ZM8.5 11.5C8.5 11.7761 8.27614 12 8 12C7.72386 12 7.5 11.7761 7.5 11.5V5.70711L5.35355 7.85355C5.15829 8.04882 4.84171 8.04882 4.64645 7.85355C4.45118 7.65829 4.45118 7.34171 4.64645 7.14645L7.64645 4.14645C7.84171 3.95118 8.15829 3.95118 8.35355 4.14645L11.3536 7.14645C11.5488 7.34171 11.5488 7.65829 11.3536 7.85355C11.1583 8.04882 10.8417 8.04882 10.6464 7.85355L8.5 5.70711V11.5Z" })
	});
};
re.category = "Shape Arrows";
var ie = "16px", ae = ({ className: e, width: t = ie, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V10.2929L5.35355 8.14645C5.15829 7.95118 4.84171 7.95118 4.64645 8.14645C4.45118 8.34171 4.45118 8.65829 4.64645 8.85355L7.64645 11.8536C7.84171 12.0488 8.15829 12.0488 8.35355 11.8536L11.3536 8.85355C11.5488 8.65829 11.5488 8.34171 11.3536 8.14645C11.1583 7.95118 10.8417 7.95118 10.6464 8.14645L8.5 10.2929V4.5Z" })
	});
};
ae.category = "Shape Arrows";
var oe = "16px", U = ({ className: e, width: t = oe, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM8.5 4.5V10.2929L10.6464 8.14645C10.8417 7.95118 11.1583 7.95118 11.3536 8.14645C11.5488 8.34171 11.5488 8.65829 11.3536 8.85355L8.35355 11.8536C8.15829 12.0488 7.84171 12.0488 7.64645 11.8536L4.64645 8.85355C4.45118 8.65829 4.45118 8.34171 4.64645 8.14645C4.84171 7.95118 5.15829 7.95118 5.35355 8.14645L7.5 10.2929V4.5C7.5 4.22386 7.72386 4 8 4C8.27614 4 8.5 4.22386 8.5 4.5Z" })
	});
};
U.category = "Shape Arrows";
var se = "16px", ce = ({ className: e, width: t = se, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11.5 7.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H5.70711L7.85355 10.6464C8.04882 10.8417 8.04882 11.1583 7.85355 11.3536C7.65829 11.5488 7.34171 11.5488 7.14645 11.3536L4.14645 8.35355C3.95118 8.15829 3.95118 7.84171 4.14645 7.64645L7.14645 4.64645C7.34171 4.45118 7.65829 4.45118 7.85355 4.64645C8.04882 4.84171 8.04882 5.15829 7.85355 5.35355L5.70711 7.5H11.5Z" })
	});
};
ce.category = "Shape Arrows";
var le = "16px", ue = ({ className: e, width: t = le, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM11.5 7.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H5.70711L7.85355 10.6464C8.04882 10.8417 8.04882 11.1583 7.85355 11.3536C7.65829 11.5488 7.34171 11.5488 7.14645 11.3536L4.14645 8.35355C3.95118 8.15829 3.95118 7.84171 4.14645 7.64645L7.14645 4.64645C7.34171 4.45118 7.65829 4.45118 7.85355 4.64645C8.04882 4.84171 8.04882 5.15829 7.85355 5.35355L5.70711 7.5H11.5Z" })
	});
};
ue.category = "Shape Arrows";
var de = "16px", fe = ({ className: e, width: t = de, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM11.5 7.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H5.70711L7.85355 10.6464C8.04882 10.8417 8.04882 11.1583 7.85355 11.3536C7.65829 11.5488 7.34171 11.5488 7.14645 11.3536L4.14645 8.35355C3.95118 8.15829 3.95118 7.84171 4.14645 7.64645L7.14645 4.64645C7.34171 4.45118 7.65829 4.45118 7.85355 4.64645C8.04882 4.84171 8.04882 5.15829 7.85355 5.35355L5.70711 7.5H11.5Z" })
	});
};
fe.category = "Shape Arrows";
var pe = "16px", W = ({ className: e, width: t = pe, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14ZM11.5 7.5H5.70711L7.85355 5.35355C8.04882 5.15829 8.04882 4.84171 7.85355 4.64645C7.65829 4.45118 7.34171 4.45118 7.14645 4.64645L4.14645 7.64645C3.95118 7.84171 3.95118 8.15829 4.14645 8.35355L7.14645 11.3536C7.34171 11.5488 7.65829 11.5488 7.85355 11.3536C8.04882 11.1583 8.04882 10.8417 7.85355 10.6464L5.70711 8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5Z" })
	});
};
W.category = "Shape Arrows";
var me = "16px", he = ({ className: e, width: t = me, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM8.5 11.5C8.5 11.7761 8.27614 12 8 12C7.72386 12 7.5 11.7761 7.5 11.5V5.70711L5.35355 7.85355C5.15829 8.04882 4.84171 8.04882 4.64645 7.85355C4.45118 7.65829 4.45118 7.34171 4.64645 7.14645L7.64645 4.14645C7.84171 3.95118 8.15829 3.95118 8.35355 4.14645L11.3536 7.14645C11.5488 7.34171 11.5488 7.65829 11.3536 7.85355C11.1583 8.04882 10.8417 8.04882 10.6464 7.85355L8.5 5.70711V11.5Z" })
	});
};
he.category = "Shape Arrows";
var ge = "16px", _e = ({ className: e, width: t = ge, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 16C0.895431 16 0 15.1046 0 14V2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2ZM8.5 11.5V5.70711L10.6464 7.85355C10.8417 8.04882 11.1583 8.04882 11.3536 7.85355C11.5488 7.65829 11.5488 7.34171 11.3536 7.14645L8.35355 4.14645C8.15829 3.95118 7.84171 3.95118 7.64645 4.14645L4.64645 7.14645C4.45118 7.34171 4.45118 7.65829 4.64645 7.85355C4.84171 8.04882 5.15829 8.04882 5.35355 7.85355L7.5 5.70711V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5Z" })
	});
};
_e.category = "Shape Arrows";
var ve = "16px", ye = ({ className: e, width: t = ve, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM4.5 7.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H10.2929L8.14645 10.6464C7.95118 10.8417 7.95118 11.1583 8.14645 11.3536C8.34171 11.5488 8.65829 11.5488 8.85355 11.3536L11.8536 8.35355C12.0488 8.15829 12.0488 7.84171 11.8536 7.64645L8.85355 4.64645C8.65829 4.45118 8.34171 4.45118 8.14645 4.64645C7.95118 4.84171 7.95118 5.15829 8.14645 5.35355L10.2929 7.5H4.5Z" })
	});
};
ye.category = "Shape Arrows";
var be = "16px", xe = ({ className: e, width: t = be, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM4.5 7.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H10.2929L8.14645 10.6464C7.95118 10.8417 7.95118 11.1583 8.14645 11.3536C8.34171 11.5488 8.65829 11.5488 8.85355 11.3536L11.8536 8.35355C12.0488 8.15829 12.0488 7.84171 11.8536 7.64645L8.85355 4.64645C8.65829 4.45118 8.34171 4.45118 8.14645 4.64645C7.95118 4.84171 7.95118 5.15829 8.14645 5.35355L10.2929 7.5H4.5Z" })
	});
};
xe.category = "Shape Arrows";
var Se = "16px", Ce = ({ className: e, width: t = Se, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM4.5 7.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H10.2929L8.14645 10.6464C7.95118 10.8417 7.95118 11.1583 8.14645 11.3536C8.34171 11.5488 8.65829 11.5488 8.85355 11.3536L11.8536 8.35355C12.0488 8.15829 12.0488 7.84171 11.8536 7.64645L8.85355 4.64645C8.65829 4.45118 8.34171 4.45118 8.14645 4.64645C7.95118 4.84171 7.95118 5.15829 8.14645 5.35355L10.2929 7.5H4.5Z" })
	});
};
Ce.category = "Shape Arrows";
var we = "16px", Te = ({ className: e, width: t = we, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M0 14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2C0.895431 0 0 0.895431 0 2V14ZM4.5 7.5H10.2929L8.14645 5.35355C7.95118 5.15829 7.95118 4.84171 8.14645 4.64645C8.34171 4.45118 8.65829 4.45118 8.85355 4.64645L11.8536 7.64645C12.0488 7.84171 12.0488 8.15829 11.8536 8.35355L8.85355 11.3536C8.65829 11.5488 8.34171 11.5488 8.14645 11.3536C7.95118 11.1583 7.95118 10.8417 8.14645 10.6464L10.2929 8.5H4.5C4.22386 8.5 4 8.27614 4 8C4 7.72386 4.22386 7.5 4.5 7.5Z" })
	});
};
Te.category = "Shape Arrows";
var Ee = "16px", G = ({ className: e, width: t = Ee, height: n, color: r, isLight: i = !1, paths: a, viewBox: o = "0 0 16 16", children: s }) => {
	let c = r ?? (i ? "#FFFFFF" : "#000000"), l = {
		width: typeof t == "number" ? `${t}px` : t,
		height: typeof n == "number" ? `${n}px` : n ?? "auto"
	}, u = [];
	return a && (u = Array.isArray(a) ? a : [a]), S("svg", {
		style: l,
		className: e,
		fill: c,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: o,
		children: s ?? u.map((e) => S("path", { d: e }, e))
	});
}, De = (e) => S(G, Object.assign({}, e, { paths: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM10.0962 10.8033C10.2915 10.9986 10.608 10.9986 10.8033 10.8033C10.9986 10.608 10.9986 10.2914 10.8033 10.0962L6.70711 5.99999L9.47483 5.99999C9.75098 5.99999 9.97484 5.77614 9.97484 5.49999C9.97484 5.22385 9.75098 4.99999 9.47483 4.99999L5.5 4.99999C5.22386 4.99999 5 5.22385 5 5.49999L5 9.47487C5 9.75101 5.22386 9.97487 5.5 9.97487C5.77614 9.97487 6 9.75101 6 9.47487L6 6.7071L10.0962 10.8033Z" }));
De.category = "Shape Arrows";
var Oe = "16px", ke = ({ className: e, width: t = Oe, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM10.0962 10.8033C10.2915 10.9986 10.608 10.9986 10.8033 10.8033C10.9986 10.608 10.9986 10.2914 10.8033 10.0962L6.70711 5.99999L9.47483 5.99999C9.75098 5.99999 9.97484 5.77614 9.97484 5.49999C9.97484 5.22385 9.75098 4.99999 9.47483 4.99999L5.5 4.99999C5.22386 4.99999 5 5.22385 5 5.49999L5 9.47487C5 9.75101 5.22386 9.97487 5.5 9.97487C5.77614 9.97487 6 9.75101 6 9.47487L6 6.7071L10.0962 10.8033Z" })
	});
};
ke.category = "Shape Arrows";
var Ae = "16px", je = ({ className: e, width: t = Ae, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM10.0962 10.8033C10.2915 10.9986 10.608 10.9986 10.8033 10.8033C10.9986 10.608 10.9986 10.2914 10.8033 10.0962L6.70711 5.99999L9.47483 5.99999C9.75098 5.99999 9.97484 5.77614 9.97484 5.49999C9.97484 5.22385 9.75098 4.99999 9.47483 4.99999L5.5 4.99999C5.22386 4.99999 5 5.22385 5 5.49999L5 9.47487C5 9.75101 5.22386 9.97487 5.5 9.97487C5.77614 9.97487 6 9.75101 6 9.47487L6 6.7071L10.0962 10.8033Z" })
	});
};
je.category = "Shape Arrows";
var Me = "16px", Ne = ({ className: e, width: t = Me, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM10.0962 10.8033L6 6.7071L6 9.47487C6 9.75101 5.77614 9.97487 5.5 9.97487C5.22386 9.97487 5 9.75101 5 9.47487L5 5.49999C5 5.22385 5.22386 4.99999 5.5 4.99999L9.47483 4.99999C9.75098 4.99999 9.97484 5.22385 9.97484 5.49999C9.97484 5.77614 9.75098 5.99999 9.47483 5.99999L6.70711 5.99999L10.8033 10.0962C10.9986 10.2914 10.9986 10.608 10.8033 10.8033C10.608 10.9986 10.2915 10.9986 10.0962 10.8033Z" })
	});
};
Ne.category = "Shape Arrows";
var Pe = "16px", Fe = ({ className: e, width: t = Pe, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.85354 10.8033C5.65828 10.9986 5.3417 10.9986 5.14644 10.8033C4.95117 10.608 4.95117 10.2914 5.14644 10.0962L9.24263 5.99999L6.4749 5.99999C6.19876 5.99999 5.9749 5.77614 5.9749 5.49999C5.9749 5.22385 6.19876 4.99999 6.4749 4.99999L10.4497 4.99999C10.7259 4.99999 10.9497 5.22385 10.9497 5.49999V9.47487C10.9497 9.75101 10.7259 9.97487 10.4497 9.97487C10.1736 9.97487 9.94974 9.75101 9.94974 9.47487L9.94974 6.7071L5.85354 10.8033Z" })
	});
};
Fe.category = "Shape Arrows";
var Ie = "16px", Le = ({ className: e, width: t = Ie, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM5.9038 10.8033C5.70854 10.9986 5.39196 10.9986 5.1967 10.8033C5.00144 10.608 5.00144 10.2914 5.1967 10.0962L9.29289 5.99999L6.52517 5.99999C6.24902 5.99999 6.02516 5.77614 6.02516 5.49999C6.02516 5.22385 6.24902 4.99999 6.52517 4.99999L10.5 4.99999C10.7761 4.99999 11 5.22385 11 5.49999V9.47487C11 9.75101 10.7761 9.97487 10.5 9.97487C10.2239 9.97487 10 9.75101 10 9.47487L10 6.7071L5.9038 10.8033Z" })
	});
};
Le.category = "Shape Arrows";
var Re = "16px", ze = ({ className: e, width: t = Re, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM5.85354 10.8033C5.65828 10.9986 5.3417 10.9986 5.14644 10.8033C4.95117 10.608 4.95117 10.2914 5.14644 10.0962L9.24263 5.99999L6.4749 5.99999C6.19876 5.99999 5.9749 5.77614 5.9749 5.49999C5.9749 5.22385 6.19876 4.99999 6.4749 4.99999L10.4497 4.99999C10.7259 4.99999 10.9497 5.22385 10.9497 5.49999V9.47487C10.9497 9.75101 10.7259 9.97487 10.4497 9.97487C10.1736 9.97487 9.94974 9.75101 9.94974 9.47487L9.94974 6.7071L5.85354 10.8033Z" })
	});
};
ze.category = "Shape Arrows";
var Be = "16px", Ve = ({ className: e, width: t = Be, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M14 0C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2C0 0.895431 0.895431 0 2 0H14ZM5.9038 10.8033L10 6.7071L10 9.47487C10 9.75101 10.2239 9.97487 10.5 9.97487C10.7761 9.97487 11 9.75101 11 9.47487V5.49999C11 5.22385 10.7761 4.99999 10.5 4.99999L6.52517 4.99999C6.24902 4.99999 6.02516 5.22385 6.02516 5.49999C6.02516 5.77614 6.24902 5.99999 6.52517 5.99999L9.29289 5.99999L5.1967 10.0962C5.00144 10.2914 5.00144 10.608 5.1967 10.8033C5.39196 10.9986 5.70854 10.9986 5.9038 10.8033Z" })
	});
};
Ve.category = "Shape Arrows";
var He = "16px", Ue = ({ className: e, width: t = He, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.85354 5.14645C5.65828 4.95118 5.3417 4.95118 5.14644 5.14645C4.95117 5.34171 4.95117 5.65829 5.14644 5.85355L9.24263 9.94975L6.4749 9.94974C6.19876 9.94974 5.9749 10.1736 5.9749 10.4497C5.9749 10.7259 6.19876 10.9497 6.4749 10.9497L10.4497 10.9497C10.7259 10.9497 10.9497 10.7259 10.9497 10.4497V6.47487C10.9497 6.19872 10.7259 5.97487 10.4497 5.97487C10.1736 5.97487 9.94974 6.19872 9.94974 6.47487L9.94974 9.24264L5.85354 5.14645Z" })
	});
};
Ue.category = "Shape Arrows";
var We = "16px", Ge = ({ className: e, width: t = We, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM5.9038 5.19671C5.70854 5.00145 5.39196 5.00145 5.1967 5.19671C5.00144 5.39197 5.00144 5.70855 5.1967 5.90382L9.29289 10L6.52517 10C6.24902 10 6.02516 10.2239 6.02516 10.5C6.02516 10.7761 6.24902 11 6.52517 11L10.5 11C10.7761 11 11 10.7762 11 10.5V6.52513C11 6.24899 10.7761 6.02513 10.5 6.02513C10.2239 6.02513 10 6.24899 10 6.52513L10 9.2929L5.9038 5.19671Z" })
	});
};
Ge.category = "Shape Arrows";
var Ke = "16px", qe = ({ className: e, width: t = Ke, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM5.85354 5.14645C5.65828 4.95118 5.3417 4.95118 5.14644 5.14645C4.95117 5.34171 4.95117 5.65829 5.14644 5.85355L9.24263 9.94975L6.4749 9.94974C6.19876 9.94974 5.9749 10.1736 5.9749 10.4497C5.9749 10.7259 6.19876 10.9497 6.4749 10.9497L10.4497 10.9497C10.7259 10.9497 10.9497 10.7259 10.9497 10.4497V6.47487C10.9497 6.19872 10.7259 5.97487 10.4497 5.97487C10.1736 5.97487 9.94974 6.19872 9.94974 6.47487L9.94974 9.24264L5.85354 5.14645Z" })
	});
};
qe.category = "Shape Arrows";
var Je = "16px", Ye = ({ className: e, width: t = Je, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M14 16C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14ZM5.9038 5.19671L10 9.2929L10 6.52513C10 6.24899 10.2239 6.02513 10.5 6.02513C10.7761 6.02513 11 6.24899 11 6.52513V10.5C11 10.7762 10.7761 11 10.5 11L6.52517 11C6.24902 11 6.02516 10.7761 6.02516 10.5C6.02516 10.2239 6.24902 10 6.52517 10L9.29289 10L5.1967 5.90382C5.00144 5.70855 5.00144 5.39197 5.1967 5.19671C5.39196 5.00145 5.70854 5.00145 5.9038 5.19671Z" })
	});
};
Ye.category = "Shape Arrows";
var Xe = "16px", Ze = ({ className: e, width: t = Xe, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM10.0962 5.14645C10.2915 4.95118 10.608 4.95118 10.8033 5.14645C10.9986 5.34171 10.9986 5.65829 10.8033 5.85355L6.70711 9.94975L9.47483 9.94974C9.75098 9.94974 9.97484 10.1736 9.97484 10.4497C9.97484 10.7259 9.75098 10.9497 9.47483 10.9497L5.5 10.9497C5.22386 10.9497 5 10.7259 5 10.4497L5 6.47487C5 6.19872 5.22386 5.97487 5.5 5.97487C5.77614 5.97487 6 6.19872 6 6.47487L6 9.24264L10.0962 5.14645Z" })
	});
};
Ze.category = "Shape Arrows";
var Qe = "16px", $e = ({ className: e, width: t = Qe, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8ZM10.0962 5.19671C10.2915 5.00145 10.608 5.00145 10.8033 5.19671C10.9986 5.39197 10.9986 5.70855 10.8033 5.90382L6.70711 10L9.47483 10C9.75098 10 9.97484 10.2239 9.97484 10.5C9.97484 10.7761 9.75098 11 9.47483 11L5.5 11C5.22386 11 5 10.7762 5 10.5V6.52513C5 6.24899 5.22386 6.02513 5.5 6.02513C5.77614 6.02513 6 6.24899 6 6.52513L6 9.2929L10.0962 5.19671Z" })
	});
};
$e.category = "Shape Arrows";
var et = "16px", tt = ({ className: e, width: t = et, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM10.0962 5.14645C10.2915 4.95118 10.608 4.95118 10.8033 5.14645C10.9986 5.34171 10.9986 5.65829 10.8033 5.85355L6.70711 9.94975L9.47483 9.94974C9.75098 9.94974 9.97484 10.1736 9.97484 10.4497C9.97484 10.7259 9.75098 10.9497 9.47483 10.9497L5.5 10.9497C5.22386 10.9497 5 10.7259 5 10.4497L5 6.47487C5 6.19872 5.22386 5.97487 5.5 5.97487C5.77614 5.97487 6 6.19872 6 6.47487L6 9.24264L10.0962 5.14645Z" })
	});
};
tt.category = "Shape Arrows";
var nt = "16px", rt = ({ className: e, width: t = nt, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 16C0.895431 16 0 15.1046 0 14V2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2ZM10.0962 5.19671L6 9.2929L6 6.52513C6 6.24899 5.77614 6.02513 5.5 6.02513C5.22386 6.02513 5 6.24899 5 6.52513L5 10.5C5 10.7762 5.22386 11 5.5 11L9.47483 11C9.75098 11 9.97484 10.7761 9.97484 10.5C9.97484 10.2239 9.75098 10 9.47483 10L6.70711 10L10.8033 5.90382C10.9986 5.70855 10.9986 5.39197 10.8033 5.19671C10.608 5.00145 10.2915 5.00145 10.0962 5.19671Z" })
	});
};
rt.category = "Shape Arrows";
var it = "16px", at = ({ className: e, width: t = it, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M3.5 6C3.22386 6 3 6.22386 3 6.5V14.5C3 14.7761 3.22386 15 3.5 15H12.5C12.7761 15 13 14.7761 13 14.5V6.5C13 6.22386 12.7761 6 12.5 6H10.5C10.2239 6 10 5.77614 10 5.5C10 5.22386 10.2239 5 10.5 5H12.5C13.3284 5 14 5.67157 14 6.5V14.5C14 15.3284 13.3284 16 12.5 16H3.5C2.67157 16 2 15.3284 2 14.5V6.5C2 5.67157 2.67157 5 3.5 5H5.5C5.77614 5 6 5.22386 6 5.5C6 5.77614 5.77614 6 5.5 6H3.5Z" }), S("path", { d: "M7.64645 0.146447C7.84171 -0.0488155 8.15829 -0.0488155 8.35355 0.146447L11.3536 3.14645C11.5488 3.34171 11.5488 3.65829 11.3536 3.85355C11.1583 4.04882 10.8417 4.04882 10.6464 3.85355L8.5 1.70711V10.5C8.5 10.7761 8.27614 11 8 11C7.72386 11 7.5 10.7761 7.5 10.5V1.70711L5.35355 3.85355C5.15829 4.04882 4.84171 4.04882 4.64645 3.85355C4.45118 3.65829 4.45118 3.34171 4.64645 3.14645L7.64645 0.146447Z" })]
	});
};
at.category = "Box Arrows";
var ot = "16px", st = ({ className: e, width: t = ot, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M3.5 10C3.22386 10 3 9.77614 3 9.5V1.5C3 1.22386 3.22386 1 3.5 1H12.5C12.7761 1 13 1.22386 13 1.5V9.5C13 9.77614 12.7761 10 12.5 10H10.5C10.2239 10 10 10.2239 10 10.5C10 10.7761 10.2239 11 10.5 11H12.5C13.3284 11 14 10.3284 14 9.5V1.5C14 0.671574 13.3284 0 12.5 0H3.5C2.67157 0 2 0.671573 2 1.5V9.5C2 10.3284 2.67157 11 3.5 11H5.5C5.77614 11 6 10.7761 6 10.5C6 10.2239 5.77614 10 5.5 10H3.5Z" }), S("path", { d: "M7.64645 4.14645C7.84171 3.95118 8.15829 3.95118 8.35355 4.14645L11.3536 7.14645C11.5488 7.34171 11.5488 7.65829 11.3536 7.85355C11.1583 8.04882 10.8417 8.04882 10.6464 7.85355L8.5 5.70711V14.5C8.5 14.7761 8.27614 15 8 15C7.72386 15 7.5 14.7761 7.5 14.5V5.70711L5.35355 7.85355C5.15829 8.04882 4.84171 8.04882 4.64645 7.85355C4.45118 7.65829 4.45118 7.34171 4.64645 7.14645L7.64645 4.14645Z" })]
	});
};
st.category = "Box Arrows";
var ct = "16px", lt = ({ className: e, width: t = ct, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M3.5 10C3.22386 10 3 9.77614 3 9.5V1.5C3 1.22386 3.22386 1 3.5 1H12.5C12.7761 1 13 1.22386 13 1.5V9.5C13 9.77614 12.7761 10 12.5 10H10.5C10.2239 10 10 10.2239 10 10.5C10 10.7761 10.2239 11 10.5 11H12.5C13.3284 11 14 10.3284 14 9.5V1.5C14 0.671574 13.3284 0 12.5 0H3.5C2.67157 0 2 0.671573 2 1.5V9.5C2 10.3284 2.67157 11 3.5 11H5.5C5.77614 11 6 10.7761 6 10.5C6 10.2239 5.77614 10 5.5 10H3.5Z" }), S("path", { d: "M7.64645 15.8536C7.84171 16.0488 8.15829 16.0488 8.35355 15.8536L11.3536 12.8536C11.5488 12.6583 11.5488 12.3417 11.3536 12.1464C11.1583 11.9512 10.8417 11.9512 10.6464 12.1464L8.5 14.2929V5.5C8.5 5.22386 8.27614 5 8 5C7.72386 5 7.5 5.22386 7.5 5.5V14.2929L5.35355 12.1464C5.15829 11.9512 4.84171 11.9512 4.64645 12.1464C4.45118 12.3417 4.45118 12.6583 4.64645 12.8536L7.64645 15.8536Z" })]
	});
};
lt.category = "Box Arrows";
var ut = "16px", dt = ({ className: e, width: t = ut, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M3.5 6C3.22386 6 3 6.22386 3 6.5V14.5C3 14.7761 3.22386 15 3.5 15H12.5C12.7761 15 13 14.7761 13 14.5V6.5C13 6.22386 12.7761 6 12.5 6H10.5C10.2239 6 10 5.77614 10 5.5C10 5.22386 10.2239 5 10.5 5H12.5C13.3284 5 14 5.67157 14 6.5V14.5C14 15.3284 13.3284 16 12.5 16H3.5C2.67157 16 2 15.3284 2 14.5V6.5C2 5.67157 2.67157 5 3.5 5H5.5C5.77614 5 6 5.22386 6 5.5C6 5.77614 5.77614 6 5.5 6H3.5Z" }), S("path", { d: "M7.64645 11.8536C7.84171 12.0488 8.15829 12.0488 8.35355 11.8536L11.3536 8.85355C11.5488 8.65829 11.5488 8.34171 11.3536 8.14645C11.1583 7.95118 10.8417 7.95118 10.6464 8.14645L8.5 10.2929V1.5C8.5 1.22386 8.27614 1 8 1C7.72386 1 7.5 1.22386 7.5 1.5V10.2929L5.35355 8.14645C5.15829 7.95118 4.84171 7.95118 4.64645 8.14645C4.45118 8.34171 4.45118 8.65829 4.64645 8.85355L7.64645 11.8536Z" })]
	});
};
dt.category = "Box Arrows";
var ft = "16px", pt = ({ className: e, width: t = ft, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M10 3.5C10 3.22386 9.77614 3 9.5 3L1.5 3C1.22386 3 1 3.22386 1 3.5V12.5C1 12.7761 1.22386 13 1.5 13H9.5C9.77614 13 10 12.7761 10 12.5V10.5C10 10.2239 10.2239 10 10.5 10C10.7761 10 11 10.2239 11 10.5V12.5C11 13.3284 10.3284 14 9.5 14H1.5C0.671574 14 0 13.3284 0 12.5V3.5C0 2.67157 0.671573 2 1.5 2L9.5 2C10.3284 2 11 2.67157 11 3.5V5.5C11 5.77614 10.7761 6 10.5 6C10.2239 6 10 5.77614 10 5.5V3.5Z" }), S("path", { d: "M4.14645 8.35355C3.95118 8.15829 3.95118 7.84171 4.14645 7.64645L7.14645 4.64645C7.34171 4.45118 7.65829 4.45118 7.85355 4.64645C8.04882 4.84171 8.04882 5.15829 7.85355 5.35355L5.70711 7.5L14.5 7.5C14.7761 7.5 15 7.72386 15 8C15 8.27614 14.7761 8.5 14.5 8.5H5.70711L7.85355 10.6464C8.04882 10.8417 8.04882 11.1583 7.85355 11.3536C7.65829 11.5488 7.34171 11.5488 7.14645 11.3536L4.14645 8.35355Z" })]
	});
};
pt.category = "Box Arrows";
var mt = "16px", ht = ({ className: e, width: t = mt, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M4 8C4 7.72386 4.22386 7.5 4.5 7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H4.5C4.22386 8.5 4 8.27614 4 8Z" })
	});
};
ht.category = "Alerts, Warnings, and Signs";
var gt = "16px", _t = ({ className: e, width: t = gt, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M8 4C8.27614 4 8.5 4.22386 8.5 4.5V7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H8.5V11.5C8.5 11.7761 8.27614 12 8 12C7.72386 12 7.5 11.7761 7.5 11.5V8.5H4.5C4.22386 8.5 4 8.27614 4 8C4 7.72386 4.22386 7.5 4.5 7.5H7.5V4.5C7.5 4.22386 7.72386 4 8 4Z" })
	});
};
_t.category = "Alerts, Warnings, and Signs";
var vt = "16px", yt = ({ className: e, width: t = vt, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 8C2 7.72386 2.22386 7.5 2.5 7.5H13.5C13.7761 7.5 14 7.72386 14 8C14 8.27614 13.7761 8.5 13.5 8.5H2.5C2.22386 8.5 2 8.27614 2 8Z" })
	});
};
yt.category = "Alerts, Warnings, and Signs";
var bt = "16px", xt = ({ className: e, width: t = bt, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" }), S("path", { d: "M4 8C4 7.72386 4.22386 7.5 4.5 7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H4.5C4.22386 8.5 4 8.27614 4 8Z" })]
	});
};
xt.category = "Alerts, Warnings, and Signs";
var St = "16px", Ct = ({ className: e, width: t = St, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM4.5 7.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H4.5Z" })
	});
};
Ct.category = "Alerts, Warnings, and Signs";
var wt = "16px", Tt = ({ className: e, width: t = wt, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M14 1C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V2C1 1.44772 1.44772 1 2 1H14ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2Z" }), S("path", { d: "M4 8C4 7.72386 4.22386 7.5 4.5 7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H4.5C4.22386 8.5 4 8.27614 4 8Z" })]
	});
};
Tt.category = "Alerts, Warnings, and Signs";
var Et = "16px", Dt = ({ className: e, width: t = Et, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM4.5 7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H4.5C4.22386 8.5 4 8.27614 4 8C4 7.72386 4.22386 7.5 4.5 7.5Z" })
	});
};
Dt.category = "Alerts, Warnings, and Signs";
var Ot = "16px", kt = ({ className: e, width: t = Ot, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M8 0C7.82427 0 7.6498 0.00567341 7.47676 0.0168556L7.54125 1.01477C7.69284 1.00498 7.8458 1 8 1C8.1542 1 8.30716 1.00498 8.45875 1.01477L8.52324 0.0168556C8.3502 0.00567344 8.17573 0 8 0Z" }),
			S("path", { d: "M6.43925 0.152261C6.09355 0.220651 5.75582 0.311314 5.42763 0.422694L5.74901 1.36965C6.03585 1.2723 6.33106 1.19304 6.63332 1.13325L6.43925 0.152261Z" }),
			S("path", { d: "M10.5724 0.422694C10.2442 0.311314 9.90645 0.220651 9.56075 0.152262L9.36668 1.13325C9.66894 1.19304 9.96415 1.2723 10.251 1.36965L10.5724 0.422694Z" }),
			S("path", { d: "M12.4453 1.34778C12.1561 1.1542 11.8536 0.978938 11.5394 0.823676L11.0964 1.72021C11.3712 1.856 11.6359 2.00932 11.889 2.17874L12.4453 1.34778Z" }),
			S("path", { d: "M4.46063 0.823676C4.14639 0.978938 3.84387 1.1542 3.55472 1.34778L4.11104 2.17874C4.36411 2.00932 4.62878 1.856 4.9036 1.72021L4.46063 0.823676Z" }),
			S("path", { d: "M2.72505 1.98531C2.46271 2.21556 2.21556 2.46271 1.98531 2.72505L2.73689 3.38469C2.93852 3.15496 3.15496 2.93852 3.38469 2.73689L2.72505 1.98531Z" }),
			S("path", { d: "M14.0147 2.72505C13.7844 2.46271 13.5373 2.21556 13.275 1.98531L12.6153 2.73689C12.845 2.93852 13.0615 3.15496 13.2631 3.38469L14.0147 2.72505Z" }),
			S("path", { d: "M15.1763 4.46063C15.0211 4.14639 14.8458 3.84387 14.6522 3.55472L13.8213 4.11104C13.9907 4.36411 14.144 4.62878 14.2798 4.9036L15.1763 4.46063Z" }),
			S("path", { d: "M1.34778 3.55472C1.1542 3.84387 0.978938 4.14639 0.823676 4.46063L1.72021 4.9036C1.856 4.62878 2.00932 4.36411 2.17874 4.11104L1.34778 3.55472Z" }),
			S("path", { d: "M0.422694 5.42763C0.311314 5.75582 0.220651 6.09355 0.152262 6.43925L1.13325 6.63332C1.19304 6.33106 1.2723 6.03585 1.36965 5.74901L0.422694 5.42763Z" }),
			S("path", { d: "M15.8477 6.43925C15.7793 6.09355 15.6887 5.75582 15.5773 5.42763L14.6304 5.74901C14.7277 6.03585 14.807 6.33106 14.8668 6.63332L15.8477 6.43925Z" }),
			S("path", { d: "M0.0168556 7.47676C0.00567344 7.6498 0 7.82427 0 8C0 8.17573 0.00567341 8.3502 0.0168556 8.52324L1.01477 8.45875C1.00498 8.30716 1 8.1542 1 8C1 7.8458 1.00498 7.69284 1.01477 7.54125L0.0168556 7.47676Z" }),
			S("path", { d: "M16 8C16 7.82427 15.9943 7.6498 15.9831 7.47676L14.9852 7.54125C14.995 7.69284 15 7.8458 15 8C15 8.1542 14.995 8.30716 14.9852 8.45875L15.9831 8.52324C15.9943 8.3502 16 8.17573 16 8Z" }),
			S("path", { d: "M0.152261 9.56075C0.220651 9.90645 0.311314 10.2442 0.422694 10.5724L1.36965 10.251C1.2723 9.96415 1.19304 9.66894 1.13325 9.36668L0.152261 9.56075Z" }),
			S("path", { d: "M15.5773 10.5724C15.6887 10.2442 15.7793 9.90645 15.8477 9.56075L14.8668 9.36668C14.807 9.66894 14.7277 9.96415 14.6304 10.251L15.5773 10.5724Z" }),
			S("path", { d: "M0.823676 11.5394C0.978938 11.8536 1.1542 12.1561 1.34778 12.4453L2.17874 11.889C2.00932 11.6359 1.856 11.3712 1.72021 11.0964L0.823676 11.5394Z" }),
			S("path", { d: "M14.6522 12.4453C14.8458 12.1561 15.0211 11.8536 15.1763 11.5394L14.2798 11.0964C14.144 11.3712 13.9907 11.6359 13.8213 11.889L14.6522 12.4453Z" }),
			S("path", { d: "M1.98531 13.275C2.21556 13.5373 2.46271 13.7844 2.72505 14.0147L3.38469 13.2631C3.15496 13.0615 2.93852 12.845 2.73689 12.6153L1.98531 13.275Z" }),
			S("path", { d: "M13.275 14.0147C13.5373 13.7844 13.7844 13.5373 14.0147 13.275L13.2631 12.6153C13.0615 12.845 12.845 13.0615 12.6153 13.2631L13.275 14.0147Z" }),
			S("path", { d: "M11.5394 15.1763C11.8536 15.0211 12.1561 14.8458 12.4453 14.6522L11.889 13.8213C11.6359 13.9907 11.3712 14.144 11.0964 14.2798L11.5394 15.1763Z" }),
			S("path", { d: "M3.55472 14.6522C3.84387 14.8458 4.14639 15.0211 4.46063 15.1763L4.9036 14.2798C4.62878 14.144 4.36411 13.9907 4.11104 13.8213L3.55472 14.6522Z" }),
			S("path", { d: "M5.42763 15.5773C5.75582 15.6887 6.09355 15.7793 6.43925 15.8477L6.63332 14.8668C6.33106 14.807 6.03585 14.7277 5.74901 14.6304L5.42763 15.5773Z" }),
			S("path", { d: "M9.56075 15.8477C9.90645 15.7793 10.2442 15.6887 10.5724 15.5773L10.251 14.6304C9.96415 14.7277 9.66894 14.807 9.36668 14.8668L9.56075 15.8477Z" }),
			S("path", { d: "M7.47676 15.9831C7.6498 15.9943 7.82427 16 8 16C8.17573 16 8.3502 15.9943 8.52324 15.9831L8.45875 14.9852C8.30716 14.995 8.1542 15 8 15C7.8458 15 7.69284 14.995 7.54125 14.9852L7.47676 15.9831Z" }),
			S("path", { d: "M4.5 7.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H4.5Z" })
		]
	});
};
kt.category = "Alerts, Warnings, and Signs";
var At = "16px", jt = ({ className: e, width: t = At, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M2.5 0C2.33368 0 2.17067 0.0163118 2.01264 0.0475742L2.20671 1.02856C2.30117 1.00988 2.39918 1 2.5 1H2.95833V0H2.5Z" }),
			S("path", { d: "M4.79167 0H3.875V1H4.79167V0Z" }),
			S("path", { d: "M6.625 0H5.70833V1H6.625V0Z" }),
			S("path", { d: "M8.45833 0H7.54167V1H8.45833V0Z" }),
			S("path", { d: "M10.2917 0H9.375V1H10.2917V0Z" }),
			S("path", { d: "M12.125 0H11.2083V1H12.125V0Z" }),
			S("path", { d: "M13.5 0H13.0417V1H13.5C13.6008 1 13.6988 1.00988 13.7933 1.02856L13.9874 0.0475741C13.8293 0.0163118 13.6663 0 13.5 0Z" }),
			S("path", { d: "M15.5786 1.11061C15.3962 0.838196 15.1618 0.603761 14.8894 0.421385L14.3331 1.25235C14.4969 1.36201 14.638 1.50314 14.7476 1.66693L15.5786 1.11061Z" }),
			S("path", { d: "M1.11061 0.421385C0.838196 0.603761 0.603761 0.838196 0.421385 1.11061L1.25235 1.66693C1.36201 1.50314 1.50314 1.36201 1.66693 1.25235L1.11061 0.421385Z" }),
			S("path", { d: "M16 2.5C16 2.33368 15.9837 2.17067 15.9524 2.01264L14.9714 2.20671C14.9901 2.30117 15 2.39918 15 2.5V2.95833H16V2.5Z" }),
			S("path", { d: "M0.0475741 2.01264C0.0163118 2.17067 0 2.33368 0 2.5V2.95833H1V2.5C1 2.39918 1.00988 2.30117 1.02856 2.20671L0.0475741 2.01264Z" }),
			S("path", { d: "M0 3.875V4.79167H1V3.875H0Z" }),
			S("path", { d: "M16 4.79167V3.875H15V4.79167H16Z" }),
			S("path", { d: "M0 5.70833V6.625H1V5.70833H0Z" }),
			S("path", { d: "M16 6.625V5.70833H15V6.625H16Z" }),
			S("path", { d: "M0 7.54167V8.45833H1V7.54167H0Z" }),
			S("path", { d: "M15 8.45833H16V7.54167H15V8.45833Z" }),
			S("path", { d: "M0 9.375V10.2917H1V9.375H0Z" }),
			S("path", { d: "M16 10.2917V9.375H15V10.2917H16Z" }),
			S("path", { d: "M0 11.2083V12.125H1V11.2083H0Z" }),
			S("path", { d: "M16 12.125V11.2083H15V12.125H16Z" }),
			S("path", { d: "M0 13.0417V13.5C0 13.6663 0.0163118 13.8293 0.0475742 13.9874L1.02856 13.7933C1.00988 13.6988 1 13.6008 1 13.5V13.0417H0Z" }),
			S("path", { d: "M16 13.5V13.0417H15V13.5C15 13.6008 14.9901 13.6988 14.9714 13.7933L15.9524 13.9874C15.9837 13.8293 16 13.6663 16 13.5Z" }),
			S("path", { d: "M0.421385 14.8894C0.603761 15.1618 0.838196 15.3962 1.11061 15.5786L1.66693 14.7476C1.50314 14.638 1.36201 14.4969 1.25235 14.3331L0.421385 14.8894Z" }),
			S("path", { d: "M14.8894 15.5786C15.1618 15.3962 15.3962 15.1618 15.5786 14.8894L14.7476 14.3331C14.638 14.4969 14.4969 14.638 14.3331 14.7476L14.8894 15.5786Z" }),
			S("path", { d: "M2.01264 15.9524C2.17067 15.9837 2.33368 16 2.5 16H2.95833V15H2.5C2.39918 15 2.30117 14.9901 2.20671 14.9714L2.01264 15.9524Z" }),
			S("path", { d: "M13.5 16C13.6663 16 13.8293 15.9837 13.9874 15.9524L13.7933 14.9714C13.6988 14.9901 13.6008 15 13.5 15H13.0417V16H13.5Z" }),
			S("path", { d: "M3.875 16H4.79167V15H3.875V16Z" }),
			S("path", { d: "M5.70833 16H6.625V15H5.70833V16Z" }),
			S("path", { d: "M7.54167 16H8.45833V15H7.54167V16Z" }),
			S("path", { d: "M9.375 16H10.2917V15H9.375V16Z" }),
			S("path", { d: "M11.2083 16H12.125V15H11.2083V16Z" }),
			S("path", { d: "M4.5 7.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H4.5Z" })
		]
	});
};
jt.category = "Alerts, Warnings, and Signs";
var Mt = "16px", Nt = ({ className: e, width: t = Mt, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M8 2C8.27614 2 8.5 2.22386 8.5 2.5V7.5H13.5C13.7761 7.5 14 7.72386 14 8C14 8.27614 13.7761 8.5 13.5 8.5H8.5V13.5C8.5 13.7761 8.27614 14 8 14C7.72386 14 7.5 13.7761 7.5 13.5V8.5H2.5C2.22386 8.5 2 8.27614 2 8C2 7.72386 2.22386 7.5 2.5 7.5H7.5V2.5C7.5 2.22386 7.72386 2 8 2Z" })
	});
};
Nt.category = "Alerts, Warnings, and Signs";
var Pt = "16px", Ft = ({ className: e, width: t = Pt, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" }), S("path", { d: "M8 4C8.27614 4 8.5 4.22386 8.5 4.5V7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H8.5V11.5C8.5 11.7761 8.27614 12 8 12C7.72386 12 7.5 11.7761 7.5 11.5V8.5H4.5C4.22386 8.5 4 8.27614 4 8C4 7.72386 4.22386 7.5 4.5 7.5H7.5V4.5C7.5 4.22386 7.72386 4 8 4Z" })]
	});
};
Ft.category = "Alerts, Warnings, and Signs";
var It = "16px", Lt = ({ className: e, width: t = It, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z" })
	});
};
Lt.category = "Alerts, Warnings, and Signs";
var Rt = "16px", zt = ({ className: e, width: t = Rt, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M14 1C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V2C1 1.44772 1.44772 1 2 1H14ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2Z" }), S("path", { d: "M8 4C8.27614 4 8.5 4.22386 8.5 4.5V7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H8.5V11.5C8.5 11.7761 8.27614 12 8 12C7.72386 12 7.5 11.7761 7.5 11.5V8.5H4.5C4.22386 8.5 4 8.27614 4 8C4 7.72386 4.22386 7.5 4.5 7.5H7.5V4.5C7.5 4.22386 7.72386 4 8 4Z" })]
	});
};
zt.category = "Alerts, Warnings, and Signs";
var Bt = "16px", Vt = ({ className: e, width: t = Bt, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM8.5 4.5V7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H8.5V11.5C8.5 11.7761 8.27614 12 8 12C7.72386 12 7.5 11.7761 7.5 11.5V8.5H4.5C4.22386 8.5 4 8.27614 4 8C4 7.72386 4.22386 7.5 4.5 7.5H7.5V4.5C7.5 4.22386 7.72386 4 8 4C8.27614 4 8.5 4.22386 8.5 4.5Z" }), ";"]
	});
};
Vt.category = "Alerts, Warnings, and Signs";
var Ht = "16px", Ut = ({ className: e, width: t = Ht, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M8 0C7.82427 0 7.6498 0.00567341 7.47676 0.0168556L7.54125 1.01477C7.69284 1.00498 7.8458 1 8 1C8.1542 1 8.30716 1.00498 8.45875 1.01477L8.52324 0.0168556C8.3502 0.00567344 8.17573 0 8 0Z" }),
			S("path", { d: "M6.43925 0.152261C6.09355 0.220651 5.75582 0.311314 5.42763 0.422694L5.74901 1.36965C6.03585 1.2723 6.33106 1.19304 6.63332 1.13325L6.43925 0.152261Z" }),
			S("path", { d: "M10.5724 0.422694C10.2442 0.311314 9.90645 0.220651 9.56075 0.152262L9.36668 1.13325C9.66894 1.19304 9.96415 1.2723 10.251 1.36965L10.5724 0.422694Z" }),
			S("path", { d: "M12.4453 1.34778C12.1561 1.1542 11.8536 0.978938 11.5394 0.823676L11.0964 1.72021C11.3712 1.856 11.6359 2.00932 11.889 2.17874L12.4453 1.34778Z" }),
			S("path", { d: "M4.46063 0.823676C4.14639 0.978938 3.84387 1.1542 3.55472 1.34778L4.11104 2.17874C4.36411 2.00932 4.62878 1.856 4.9036 1.72021L4.46063 0.823676Z" }),
			S("path", { d: "M2.72505 1.98531C2.46271 2.21556 2.21556 2.46271 1.98531 2.72505L2.73689 3.38469C2.93852 3.15496 3.15496 2.93852 3.38469 2.73689L2.72505 1.98531Z" }),
			S("path", { d: "M14.0147 2.72505C13.7844 2.46271 13.5373 2.21556 13.275 1.98531L12.6153 2.73689C12.845 2.93852 13.0615 3.15496 13.2631 3.38469L14.0147 2.72505Z" }),
			S("path", { d: "M15.1763 4.46063C15.0211 4.14639 14.8458 3.84387 14.6522 3.55472L13.8213 4.11104C13.9907 4.36411 14.144 4.62878 14.2798 4.9036L15.1763 4.46063Z" }),
			S("path", { d: "M1.34778 3.55472C1.1542 3.84387 0.978938 4.14639 0.823676 4.46063L1.72021 4.9036C1.856 4.62878 2.00932 4.36411 2.17874 4.11104L1.34778 3.55472Z" }),
			S("path", { d: "M0.422694 5.42763C0.311314 5.75582 0.220651 6.09355 0.152262 6.43925L1.13325 6.63332C1.19304 6.33106 1.2723 6.03585 1.36965 5.74901L0.422694 5.42763Z" }),
			S("path", { d: "M15.8477 6.43925C15.7793 6.09355 15.6887 5.75582 15.5773 5.42763L14.6304 5.74901C14.7277 6.03585 14.807 6.33106 14.8668 6.63332L15.8477 6.43925Z" }),
			S("path", { d: "M0.0168556 7.47676C0.00567344 7.6498 0 7.82427 0 8C0 8.17573 0.00567341 8.3502 0.0168556 8.52324L1.01477 8.45875C1.00498 8.30716 1 8.1542 1 8C1 7.8458 1.00498 7.69284 1.01477 7.54125L0.0168556 7.47676Z" }),
			S("path", { d: "M16 8C16 7.82427 15.9943 7.6498 15.9831 7.47676L14.9852 7.54125C14.995 7.69284 15 7.8458 15 8C15 8.1542 14.995 8.30716 14.9852 8.45875L15.9831 8.52324C15.9943 8.3502 16 8.17573 16 8Z" }),
			S("path", { d: "M0.152261 9.56075C0.220651 9.90645 0.311314 10.2442 0.422694 10.5724L1.36965 10.251C1.2723 9.96415 1.19304 9.66894 1.13325 9.36668L0.152261 9.56075Z" }),
			S("path", { d: "M15.5773 10.5724C15.6887 10.2442 15.7793 9.90645 15.8477 9.56075L14.8668 9.36668C14.807 9.66894 14.7277 9.96415 14.6304 10.251L15.5773 10.5724Z" }),
			S("path", { d: "M0.823676 11.5394C0.978938 11.8536 1.1542 12.1561 1.34778 12.4453L2.17874 11.889C2.00932 11.6359 1.856 11.3712 1.72021 11.0964L0.823676 11.5394Z" }),
			S("path", { d: "M14.6522 12.4453C14.8458 12.1561 15.0211 11.8536 15.1763 11.5394L14.2798 11.0964C14.144 11.3712 13.9907 11.6359 13.8213 11.889L14.6522 12.4453Z" }),
			S("path", { d: "M1.98531 13.275C2.21556 13.5373 2.46271 13.7844 2.72505 14.0147L3.38469 13.2631C3.15496 13.0615 2.93852 12.845 2.73689 12.6153L1.98531 13.275Z" }),
			S("path", { d: "M13.275 14.0147C13.5373 13.7844 13.7844 13.5373 14.0147 13.275L13.2631 12.6153C13.0615 12.845 12.845 13.0615 12.6153 13.2631L13.275 14.0147Z" }),
			S("path", { d: "M11.5394 15.1763C11.8536 15.0211 12.1561 14.8458 12.4453 14.6522L11.889 13.8213C11.6359 13.9907 11.3712 14.144 11.0964 14.2798L11.5394 15.1763Z" }),
			S("path", { d: "M3.55472 14.6522C3.84387 14.8458 4.14639 15.0211 4.46063 15.1763L4.9036 14.2798C4.62878 14.144 4.36411 13.9907 4.11104 13.8213L3.55472 14.6522Z" }),
			S("path", { d: "M5.42763 15.5773C5.75582 15.6887 6.09355 15.7793 6.43925 15.8477L6.63332 14.8668C6.33106 14.807 6.03585 14.7277 5.74901 14.6304L5.42763 15.5773Z" }),
			S("path", { d: "M9.56075 15.8477C9.90645 15.7793 10.2442 15.6887 10.5724 15.5773L10.251 14.6304C9.96415 14.7277 9.66894 14.807 9.36668 14.8668L9.56075 15.8477Z" }),
			S("path", { d: "M7.47676 15.9831C7.6498 15.9943 7.82427 16 8 16C8.17573 16 8.3502 15.9943 8.52324 15.9831L8.45875 14.9852C8.30716 14.995 8.1542 15 8 15C7.8458 15 7.69284 14.995 7.54125 14.9852L7.47676 15.9831Z" }),
			S("path", { d: "M8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z" })
		]
	});
};
Ut.category = "Alerts, Warnings, and Signs";
var Wt = "16px", Gt = ({ className: e, width: t = Wt, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.5 4.00195H8.61023C10.3203 4.00195 11.351 4.97461 11.351 6.46289C11.351 7.59961 10.6837 8.40234 9.85551 8.70117L11.5 12H9.98064L8.52085 8.92383H6.83466V12H5.5V4.00195ZM6.83466 5.0918V7.86914H8.38381C9.37885 7.86914 9.9568 7.40625 9.9568 6.50977C9.9568 5.5957 9.36097 5.0918 8.41956 5.0918H6.83466Z" })
	});
};
Gt.category = "Sort and Filter";
var Kt = "16px", qt = ({ className: e, width: t = Kt, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.14648 4.99219C6.93359 4.99219 6.21875 5.91211 6.21875 7.49414V8.55469C6.21875 10.125 6.92188 11.0156 8.14648 11.0156C9.125 11.0156 9.78711 10.4297 9.875 9.59766H11.1699V9.69141C11.0703 11.1387 9.81641 12.1582 8.14062 12.1582C6.04883 12.1582 4.87109 10.8223 4.87109 8.55469V7.48242C4.87109 5.2207 6.07227 3.84375 8.14062 3.84375C9.82227 3.84375 11.0762 4.89844 11.1699 6.41602V6.50391H9.875C9.78711 5.625 9.10742 4.99219 8.14648 4.99219Z" })
	});
};
qt.category = "Sort and Filter";
var Jt = "16px", Yt = ({ className: e, width: t = Jt, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.40808 5.88916C4.57751 5.88916 4.08972 6.53076 4.08972 7.64258V8.38525C4.08972 9.49268 4.56873 10.1123 5.40808 10.1123C6.09802 10.1123 6.54626 9.67725 6.5946 9.06201H7.74158V9.17627C7.68445 10.3232 6.71326 11.1143 5.39929 11.1143C3.7865 11.1143 2.88123 10.0859 2.88123 8.38525V7.63818C2.88123 5.9375 3.79529 4.88721 5.39929 4.88721C6.71765 4.88721 7.68884 5.7002 7.74158 6.88672V6.99658H6.5946C6.54626 6.35938 6.08923 5.88916 5.40808 5.88916ZM10.8116 5.88916C9.98103 5.88916 9.49324 6.53076 9.49324 7.64258V8.38525C9.49324 9.49268 9.97224 10.1123 10.8116 10.1123C11.5015 10.1123 11.9498 9.67725 11.9981 9.06201H13.1451V9.17627C13.088 10.3232 12.1168 11.1143 10.8028 11.1143C9.19001 11.1143 8.28474 10.0859 8.28474 8.38525V7.63818C8.28474 5.9375 9.1988 4.88721 10.8028 4.88721C12.1212 4.88721 13.0924 5.7002 13.1451 6.88672V6.99658H11.9981C11.9498 6.35938 11.4927 5.88916 10.8116 5.88916Z" })
	});
};
Yt.category = "Sort and Filter";
var Xt = "16px", Zt = ({ className: e, width: t = Xt, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.5 4.00195H8.46197C10.0447 4.00195 11 5.10352 11 6.58594C11 8.08008 10.0334 9.16406 8.45067 9.16406H6.78314V12H5.5V4.00195ZM8.26978 8.07422C9.1629 8.07422 9.68859 7.5293 9.68859 6.58594C9.68859 5.64258 9.1629 5.10352 8.26978 5.10352H6.77749V8.07422H8.26978Z" })
	});
};
Zt.category = "Sort and Filter";
var Qt = "16px", $t = ({ className: e, width: t = Qt, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11 4.00195V12H9.66992V8.45508H6.33008V12H5V4.00195H6.33008V7.32422H9.66992V4.00195H11Z" }), S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11 4.00195V12H9.66992V8.45508H6.33008V12H5V4.00195H6.33008V7.32422H9.66992V4.00195H11Z" })]
	});
};
$t.category = "Sort and Filter";
var en = "16px", tn = ({ className: e, width: t = en, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M7.98828 12.1582C6.13672 12.1582 5.04688 10.5879 5.04688 8.16797V7.83984C5.04688 5.43164 6.14844 3.84375 8.01172 3.84375C9.86914 3.84375 10.9473 5.41406 10.9473 7.83984V8.16797C10.9473 10.5762 9.8457 12.1582 7.98828 12.1582ZM8 4.95117C6.99219 4.95117 6.37109 6.04102 6.37109 7.8457V8.15625C6.37109 9.9668 6.99805 11.0508 8 11.0508C9.00195 11.0508 9.62305 9.96094 9.62305 8.15625V7.8457C9.62305 6.04688 9.00195 4.95117 8 4.95117Z" }), S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8Z" })]
	});
};
tn.category = "Sort and Filter";
var nn = "16px", rn = ({ className: e, width: t = nn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM9.2832 4.00195V12H7.9707V5.33789H7.90625L6.07227 6.65625V5.38477L7.9707 4.00195H9.2832Z" })
	});
};
rn.category = "Sort and Filter";
var an = "16px", on = ({ className: e, width: t = an, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM6.64648 6.24023V6.31055H5.375V6.24609C5.375 5.0332 6.25391 3.84375 8.01172 3.84375C9.59375 3.84375 10.625 4.79297 10.625 6.05859C10.625 7.06096 10.0256 7.72616 9.33829 8.48895C9.30643 8.52431 9.27438 8.55988 9.24219 8.5957L7.26758 10.8164V10.8926H10.7656V12H5.42188V11.168L8.39258 7.875C8.82617 7.40039 9.29492 6.86719 9.29492 6.16992C9.29492 5.42578 8.73828 4.93359 7.98242 4.93359C7.13867 4.93359 6.64648 5.54883 6.64648 6.24023Z" })
	});
};
on.category = "Sort and Filter";
var sn = "16px", cn = ({ className: e, width: t = sn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M7.91797 8.41406H7.03906V7.3418H7.87695C8.65625 7.3418 9.22461 6.82031 9.21875 6.10547C9.21875 5.39648 8.65625 4.91016 7.87109 4.91016C7.08008 4.91016 6.55859 5.4082 6.52344 5.96484H5.27539C5.31055 4.82812 6.22461 3.84961 7.90039 3.84375C9.49414 3.83203 10.5078 4.72852 10.5371 5.90625C10.5605 7.04297 9.65234 7.68164 9.05469 7.78125V7.85156C9.75781 7.92188 10.7656 8.49023 10.7891 9.76758C10.8125 11.2266 9.51172 12.1641 7.85938 12.1641C6.1543 12.1641 5.15234 11.1973 5.10547 10.0195H6.33008C6.38867 10.6172 7.00977 11.0801 7.87109 11.0859C8.84375 11.0918 9.4707 10.5234 9.45898 9.73242C9.45312 8.95312 8.83789 8.41406 7.91797 8.41406Z" }), S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8Z" })]
	});
};
cn.category = "Sort and Filter";
var ln = "16px", un = ({ className: e, width: t = ln, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M7.51866 5.0572C7.73836 4.70539 7.958 4.35367 8.17578 4.00195H10.1094V9.33398H11.1172V10.4414H10.1094V12H8.84961V10.4414H4.97656V9.32227C5.7465 7.89506 6.63305 6.47538 7.51866 5.0572ZM6.22461 9.28125V9.33398H8.84961V5.0625H8.78516C7.91797 6.39258 6.99805 7.86914 6.22461 9.28125Z" }), S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8Z" })]
	});
};
un.category = "Sort and Filter";
var dn = "16px", fn = ({ className: e, width: t = dn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8ZM16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8ZM7.99414 12.1582C6.42383 12.1582 5.33984 11.2559 5.27539 10.043H6.51172C6.65234 10.7637 7.34375 11.0742 8.04102 11.0742C8.83203 11.0742 9.61133 10.4766 9.61133 9.39258C9.61133 8.42578 8.87891 7.82227 8.0293 7.82227C7.26172 7.82227 6.78711 8.27344 6.59375 8.63086H5.44531L5.79102 4.00195H10.4961V5.10352H6.875L6.68164 7.44727H6.74609C6.91602 7.18945 7.46094 6.76758 8.35742 6.76758C9.74023 6.76758 10.918 7.71094 10.918 9.35156C10.918 11.0391 9.73438 12.1582 7.99414 12.1582Z" })
	});
};
fn.category = "Sort and Filter";
var pn = "16px", mn = ({ className: e, width: t = pn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.21094 3.85547C9.82227 3.85547 10.7246 4.8457 10.7832 5.75391H9.49414C9.39453 5.39648 8.98438 4.93945 8.18164 4.93945C7.10352 4.93945 6.36523 6.0293 6.37695 7.97461H6.45898C6.6875 7.42969 7.31445 6.82031 8.43945 6.82031C9.69336 6.82031 10.9473 7.69922 10.9473 9.375C10.9473 11.1445 9.72852 12.1582 8.09961 12.1582C7.16797 12.1582 6.25977 11.8301 5.69141 10.9043C5.32227 10.3008 5.09375 9.44531 5.09375 8.26172C5.09375 5.25 6.3418 3.85547 8.21094 3.85547ZM8.11133 7.86328C7.19141 7.86328 6.54688 8.51367 6.54688 9.43945C6.54688 10.4707 7.25 11.0742 8.10547 11.0742C8.97266 11.0742 9.6582 10.541 9.6582 9.44531C9.6582 8.38477 8.91406 7.86328 8.11133 7.86328Z" })
	});
};
mn.category = "Sort and Filter";
var hn = "16px", gn = ({ className: e, width: t = hn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.36914 5.10938V4.00195H10.6777V5.15039L7.41992 12H6.02539L9.3418 5.17969V5.10938H5.36914Z" })
	});
};
gn.category = "Sort and Filter";
var _n = "16px", vn = ({ className: e, width: t = _n, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM10.9707 9.80273C10.9707 11.1973 9.75195 12.1582 7.98242 12.1582C6.21875 12.1582 5.0293 11.2031 5.0293 9.81445C5.0293 8.54297 5.97852 7.96289 6.67578 7.81055V7.74609C6.05469 7.55273 5.3457 7.00781 5.3457 5.96484C5.3457 4.74023 6.43555 3.84375 8.00586 3.84375C9.57617 3.84375 10.6602 4.74023 10.6602 5.96484C10.6602 7.02539 9.92188 7.55859 9.32422 7.74609V7.81055C10.0273 7.96289 10.9707 8.55469 10.9707 9.80273ZM6.62305 6.09375C6.62305 6.83203 7.20898 7.34766 8.00586 7.34766C8.80273 7.34766 9.38281 6.83203 9.38281 6.09375C9.38281 5.36133 8.80273 4.86328 8.00586 4.86328C7.20898 4.86328 6.62305 5.36133 6.62305 6.09375ZM6.3418 9.73828C6.3418 10.5762 7.0625 11.1504 8.00586 11.1504C8.94922 11.1504 9.66406 10.5762 9.66406 9.73828C9.66406 8.89453 8.94922 8.31445 8.00586 8.31445C7.0625 8.31445 6.3418 8.89453 6.3418 9.73828Z" })
	});
};
vn.category = "Sort and Filter";
var yn = "16px", bn = ({ className: e, width: t = yn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM7.77734 12.1465C6.18359 12.1465 5.35156 11.2559 5.25781 10.3477H6.55273C6.65234 10.7051 7.0918 11.0684 7.80078 11.0684C9.16016 11.0684 9.68164 9.71484 9.63477 8.04492H9.55859C9.32422 8.67188 8.68555 9.22852 7.625 9.22852C6.23047 9.22852 5.05859 8.26758 5.05859 6.5625C5.05859 4.85156 6.30078 3.83203 7.92969 3.83203C9.44141 3.83203 10.9004 4.69922 10.9004 7.8457C10.9004 10.6816 9.88086 12.1465 7.77734 12.1465ZM7.89453 8.17383C8.70312 8.17383 9.42969 7.64648 9.42969 6.58008C9.42969 5.51367 8.76172 4.9043 7.87109 4.9043C7.0332 4.9043 6.35352 5.51953 6.35352 6.5625C6.35352 7.63477 7.0625 8.17383 7.89453 8.17383Z" })
	});
};
bn.category = "Sort and Filter";
var xn = "16px", Sn = ({ className: e, width: t = xn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.5 4.00195V12H6.83466V8.92383H8.52085L9.98064 12H11.5L9.85551 8.70117C10.6837 8.40234 11.351 7.59961 11.351 6.46289C11.351 4.97461 10.3203 4.00195 8.61023 4.00195H5.5ZM6.83466 5.0918V7.86914H8.38381C9.37885 7.86914 9.9568 7.40625 9.9568 6.50977C9.9568 5.5957 9.36097 5.0918 8.41956 5.0918H6.83466Z" })
	});
};
Sn.category = "Sort and Filter";
var Cn = "16px", wn = ({ className: e, width: t = Cn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.14648 4.99219C9.10742 4.99219 9.78711 5.625 9.875 6.50391H11.1699V6.41602C11.0762 4.89844 9.82227 3.84375 8.14062 3.84375C6.07227 3.84375 4.87109 5.2207 4.87109 7.48242V8.55469C4.87109 10.8223 6.04883 12.1582 8.14062 12.1582C9.81641 12.1582 11.0703 11.1387 11.1699 9.69141V9.59766H9.875C9.78711 10.4297 9.125 11.0156 8.14648 11.0156C6.92188 11.0156 6.21875 10.125 6.21875 8.55469V7.49414C6.21875 5.91211 6.93359 4.99219 8.14648 4.99219Z" })
	});
};
wn.category = "Sort and Filter";
var Tn = "16px", En = ({ className: e, width: t = Tn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.40808 5.88916C6.08923 5.88916 6.54626 6.35938 6.5946 6.99658H7.74158V6.88672C7.68884 5.7002 6.71765 4.88721 5.39929 4.88721C3.79529 4.88721 2.88123 5.9375 2.88123 7.63818V8.38525C2.88123 10.0859 3.7865 11.1143 5.39929 11.1143C6.71326 11.1143 7.68445 10.3232 7.74158 9.17627V9.06201H6.5946C6.54626 9.67725 6.09802 10.1123 5.40808 10.1123C4.56873 10.1123 4.08972 9.49268 4.08972 8.38525V7.64258C4.08972 6.53076 4.57751 5.88916 5.40808 5.88916ZM10.8116 5.88916C11.4927 5.88916 11.9498 6.35938 11.9981 6.99658H13.1451V6.88672C13.0924 5.7002 12.1212 4.88721 10.8028 4.88721C9.1988 4.88721 8.28474 5.9375 8.28474 7.63818V8.38525C8.28474 10.0859 9.19001 11.1143 10.8028 11.1143C12.1168 11.1143 13.088 10.3232 13.1451 9.17627V9.06201H11.9981C11.9498 9.67725 11.5015 10.1123 10.8116 10.1123C9.97224 10.1123 9.49324 9.49268 9.49324 8.38525V7.64258C9.49324 6.53076 9.98103 5.88916 10.8116 5.88916Z" })
	});
};
En.category = "Sort and Filter";
var Dn = "16px", On = ({ className: e, width: t = Dn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.5 4.00195V12H6.78314V9.16406H8.45067C10.0334 9.16406 11 8.08008 11 6.58594C11 5.10352 10.0447 4.00195 8.46197 4.00195H5.5ZM8.26978 8.07422C9.1629 8.07422 9.68859 7.5293 9.68859 6.58594C9.68859 5.64258 9.1629 5.10352 8.26978 5.10352H6.77749V8.07422H8.26978Z" })
	});
};
On.category = "Sort and Filter";
var kn = "16px", An = ({ className: e, width: t = kn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11 4.00195H9.66992V7.32422H6.33008V4.00195H5V12H6.33008V8.45508H9.66992V12H11V4.00195Z" })
	});
};
An.category = "Sort and Filter";
var jn = "16px", Mn = ({ className: e, width: t = jn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M8 4.95117C6.99219 4.95117 6.37109 6.04102 6.37109 7.8457V8.15625C6.37109 9.9668 6.99805 11.0508 8 11.0508C9.00195 11.0508 9.62305 9.96094 9.62305 8.15625V7.8457C9.62305 6.04688 9.00195 4.95117 8 4.95117Z" }), S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM7.98828 12.1582C9.8457 12.1582 10.9473 10.5762 10.9473 8.16797V7.83984C10.9473 5.41406 9.86914 3.84375 8.01172 3.84375C6.14844 3.84375 5.04688 5.43164 5.04688 7.83984V8.16797C5.04688 10.5879 6.13672 12.1582 7.98828 12.1582Z" })]
	});
};
Mn.category = "Sort and Filter";
var Nn = "16px", Pn = ({ className: e, width: t = Nn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM9.2832 4.00195H7.9707L6.07227 5.38477V6.65625L7.90625 5.33789H7.9707V12H9.2832V4.00195Z" })
	});
};
Pn.category = "Sort and Filter";
var Fn = "16px", In = ({ className: e, width: t = Fn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM6.64648 6.24023C6.64648 5.54883 7.13867 4.93359 7.98242 4.93359C8.73828 4.93359 9.29492 5.42578 9.29492 6.16992C9.29492 6.86719 8.82617 7.40039 8.39258 7.875L5.42188 11.168V12H10.7656V10.8926H7.26758V10.8164L9.24219 8.5957C9.27438 8.55988 9.30643 8.52431 9.33829 8.48895C10.0256 7.72616 10.625 7.06096 10.625 6.05859C10.625 4.79297 9.59375 3.84375 8.01172 3.84375C6.25391 3.84375 5.375 5.0332 5.375 6.24609V6.31055H6.64648V6.24023Z" })
	});
};
In.category = "Sort and Filter";
var Ln = "16px", Rn = ({ className: e, width: t = Ln, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM7.91797 8.41406C8.83789 8.41406 9.45312 8.95312 9.45898 9.73242C9.4707 10.5234 8.84375 11.0918 7.87109 11.0859C7.00977 11.0801 6.38867 10.6172 6.33008 10.0195H5.10547C5.15234 11.1973 6.1543 12.1641 7.85938 12.1641C9.51172 12.1641 10.8125 11.2266 10.7891 9.76758C10.7656 8.49023 9.75781 7.92188 9.05469 7.85156V7.78125C9.65234 7.68164 10.5605 7.04297 10.5371 5.90625C10.5078 4.72852 9.49414 3.83203 7.90039 3.84375C6.22461 3.84961 5.31055 4.82812 5.27539 5.96484H6.52344C6.55859 5.4082 7.08008 4.91016 7.87109 4.91016C8.65625 4.91016 9.21875 5.39648 9.21875 6.10547C9.22461 6.82031 8.65625 7.3418 7.87695 7.3418H7.03906V8.41406H7.91797Z" })
	});
};
Rn.category = "Sort and Filter";
var zn = "16px", Bn = ({ className: e, width: t = zn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM7.51866 5.0572C6.63305 6.47538 5.7465 7.89506 4.97656 9.32227V10.4414H8.84961V12H10.1094V10.4414H11.1172V9.33398H10.1094V4.00195H8.17578C7.958 4.35367 7.73836 4.70539 7.51866 5.0572ZM6.22461 9.28125V9.33398H8.84961V5.0625H8.78516C7.91797 6.39258 6.99805 7.86914 6.22461 9.28125Z" })
	});
};
Bn.category = "Sort and Filter";
var Vn = "16px", Hn = ({ className: e, width: t = Vn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM7.99414 12.1582C9.73438 12.1582 10.918 11.0391 10.918 9.35156C10.918 7.71094 9.74023 6.76758 8.35742 6.76758C7.46094 6.76758 6.91602 7.18945 6.74609 7.44727H6.68164L6.875 5.10352H10.4961V4.00195H5.79102L5.44531 8.63086H6.59375C6.78711 8.27344 7.26172 7.82227 8.0293 7.82227C8.87891 7.82227 9.61133 8.42578 9.61133 9.39258C9.61133 10.4766 8.83203 11.0742 8.04102 11.0742C7.34375 11.0742 6.65234 10.7637 6.51172 10.043H5.27539C5.33984 11.2559 6.42383 12.1582 7.99414 12.1582Z" })
	});
};
Hn.category = "Sort and Filter";
var Un = "16px", Wn = ({ className: e, width: t = Un, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.21094 3.85547C6.3418 3.85547 5.09375 5.25 5.09375 8.26172C5.09375 9.44531 5.32227 10.3008 5.69141 10.9043C6.25977 11.8301 7.16797 12.1582 8.09961 12.1582C9.72852 12.1582 10.9473 11.1445 10.9473 9.375C10.9473 7.69922 9.69336 6.82031 8.43945 6.82031C7.31445 6.82031 6.6875 7.42969 6.45898 7.97461H6.37695C6.36523 6.0293 7.10352 4.93945 8.18164 4.93945C8.98438 4.93945 9.39453 5.39648 9.49414 5.75391H10.7832C10.7246 4.8457 9.82227 3.85547 8.21094 3.85547ZM8.11133 7.86328C7.19141 7.86328 6.54688 8.51367 6.54688 9.43945C6.54688 10.4707 7.25 11.0742 8.10547 11.0742C8.97266 11.0742 9.6582 10.541 9.6582 9.44531C9.6582 8.38477 8.91406 7.86328 8.11133 7.86328Z" })
	});
};
Wn.category = "Sort and Filter";
var Gn = "16px", Kn = ({ className: e, width: t = Gn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.36914 5.10938H9.3418V5.17969L6.02539 12H7.41992L10.6777 5.15039V4.00195H5.36914V5.10938Z" })
	});
};
Kn.category = "Sort and Filter";
var qn = "16px", Jn = ({ className: e, width: t = qn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM10.9707 9.80273C10.9707 8.55469 10.0273 7.96289 9.32422 7.81055V7.74609C9.92188 7.55859 10.6602 7.02539 10.6602 5.96484C10.6602 4.74023 9.57617 3.84375 8.00586 3.84375C6.43555 3.84375 5.3457 4.74023 5.3457 5.96484C5.3457 7.00781 6.05469 7.55273 6.67578 7.74609V7.81055C5.97852 7.96289 5.0293 8.54297 5.0293 9.81445C5.0293 11.2031 6.21875 12.1582 7.98242 12.1582C9.75195 12.1582 10.9707 11.1973 10.9707 9.80273ZM6.62305 6.09375C6.62305 6.83203 7.20898 7.34766 8.00586 7.34766C8.80273 7.34766 9.38281 6.83203 9.38281 6.09375C9.38281 5.36133 8.80273 4.86328 8.00586 4.86328C7.20898 4.86328 6.62305 5.36133 6.62305 6.09375ZM6.3418 9.73828C6.3418 10.5762 7.0625 11.1504 8.00586 11.1504C8.94922 11.1504 9.66406 10.5762 9.66406 9.73828C9.66406 8.89453 8.94922 8.31445 8.00586 8.31445C7.0625 8.31445 6.3418 8.89453 6.3418 9.73828Z" })
	});
};
Jn.category = "Sort and Filter";
var Yn = "16px", Xn = ({ className: e, width: t = Yn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM7.77734 12.1465C9.88086 12.1465 10.9004 10.6816 10.9004 7.8457C10.9004 4.69922 9.44141 3.83203 7.92969 3.83203C6.30078 3.83203 5.05859 4.85156 5.05859 6.5625C5.05859 8.26758 6.23047 9.22852 7.625 9.22852C8.68555 9.22852 9.32422 8.67188 9.55859 8.04492H9.63477C9.68164 9.71484 9.16016 11.0684 7.80078 11.0684C7.0918 11.0684 6.65234 10.7051 6.55273 10.3477H5.25781C5.35156 11.2559 6.18359 12.1465 7.77734 12.1465ZM7.89453 8.17383C8.70312 8.17383 9.42969 7.64648 9.42969 6.58008C9.42969 5.51367 8.76172 4.9043 7.87109 4.9043C7.0332 4.9043 6.35352 5.51953 6.35352 6.5625C6.35352 7.63477 7.0625 8.17383 7.89453 8.17383Z" })
	});
};
Xn.category = "Sort and Filter";
var Zn = "16px", Qn = ({ className: e, width: t = Zn, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M5.5 4.00195H8.61023C10.3203 4.00195 11.351 4.97461 11.351 6.46289C11.351 7.59961 10.6837 8.40234 9.85551 8.70117L11.5 12H9.98064L8.52085 8.92383H6.83466V12H5.5V4.00195ZM6.83466 5.0918V7.86914H8.38381C9.37885 7.86914 9.9568 7.40625 9.9568 6.50977C9.9568 5.5957 9.36097 5.0918 8.41956 5.0918H6.83466Z" }), S("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2Z" })]
	});
};
Qn.category = "Sort and Filter";
var $n = "16px", er = ({ className: e, width: t = $n, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M8.14648 4.99219C6.93359 4.99219 6.21875 5.91211 6.21875 7.49414V8.55469C6.21875 10.125 6.92188 11.0156 8.14648 11.0156C9.125 11.0156 9.78711 10.4297 9.875 9.59766H11.1699V9.69141C11.0703 11.1387 9.81641 12.1582 8.14062 12.1582C6.04883 12.1582 4.87109 10.8223 4.87109 8.55469V7.48242C4.87109 5.2207 6.07227 3.84375 8.14062 3.84375C9.82227 3.84375 11.0762 4.89844 11.1699 6.41602V6.50391H9.875C9.78711 5.625 9.10742 4.99219 8.14648 4.99219Z" }), S("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2Z" })]
	});
};
er.category = "Sort and Filter";
var tr = "16px", nr = ({ className: e, width: t = tr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM5.40808 5.88916C4.57751 5.88916 4.08972 6.53076 4.08972 7.64258V8.38525C4.08972 9.49268 4.56873 10.1123 5.40808 10.1123C6.09802 10.1123 6.54626 9.67725 6.5946 9.06201H7.74158V9.17627C7.68445 10.3232 6.71326 11.1143 5.39929 11.1143C3.7865 11.1143 2.88123 10.0859 2.88123 8.38525V7.63818C2.88123 5.9375 3.79529 4.88721 5.39929 4.88721C6.71765 4.88721 7.68884 5.7002 7.74158 6.88672V6.99658H6.5946C6.54626 6.35938 6.08923 5.88916 5.40808 5.88916ZM10.8116 5.88916C9.98103 5.88916 9.49324 6.53076 9.49324 7.64258V8.38525C9.49324 9.49268 9.97224 10.1123 10.8116 10.1123C11.5015 10.1123 11.9498 9.67725 11.9981 9.06201H13.1451V9.17627C13.088 10.3232 12.1168 11.1143 10.8028 11.1143C9.19001 11.1143 8.28474 10.0859 8.28474 8.38525V7.63818C8.28474 5.9375 9.1988 4.88721 10.8028 4.88721C12.1212 4.88721 13.0924 5.7002 13.1451 6.88672V6.99658H11.9981C11.9498 6.35938 11.4927 5.88916 10.8116 5.88916Z" }), S("path", { d: "M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM5.40808 5.88916C4.57751 5.88916 4.08972 6.53076 4.08972 7.64258V8.38525C4.08972 9.49268 4.56873 10.1123 5.40808 10.1123C6.09802 10.1123 6.54626 9.67725 6.5946 9.06201H7.74158V9.17627C7.68445 10.3232 6.71326 11.1143 5.39929 11.1143C3.7865 11.1143 2.88123 10.0859 2.88123 8.38525V7.63818C2.88123 5.9375 3.79529 4.88721 5.39929 4.88721C6.71765 4.88721 7.68884 5.7002 7.74158 6.88672V6.99658H6.5946C6.54626 6.35938 6.08923 5.88916 5.40808 5.88916ZM10.8116 5.88916C9.98103 5.88916 9.49324 6.53076 9.49324 7.64258V8.38525C9.49324 9.49268 9.97224 10.1123 10.8116 10.1123C11.5015 10.1123 11.9498 9.67725 11.9981 9.06201H13.1451V9.17627C13.088 10.3232 12.1168 11.1143 10.8028 11.1143C9.19001 11.1143 8.28474 10.0859 8.28474 8.38525V7.63818C8.28474 5.9375 9.1988 4.88721 10.8028 4.88721C12.1212 4.88721 13.0924 5.7002 13.1451 6.88672V6.99658H11.9981C11.9498 6.35938 11.4927 5.88916 10.8116 5.88916Z" })]
	});
};
nr.category = "Sort and Filter";
var rr = "16px", ir = ({ className: e, width: t = rr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M5.5 4.00195H8.46197C10.0447 4.00195 11 5.10352 11 6.58594C11 8.08008 10.0334 9.16406 8.45067 9.16406H6.78314V12H5.5V4.00195ZM8.26978 8.07422C9.1629 8.07422 9.68859 7.5293 9.68859 6.58594C9.68859 5.64258 9.1629 5.10352 8.26978 5.10352H6.77749V8.07422H8.26978Z" }), S("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2Z" })]
	});
};
ir.category = "Sort and Filter";
var ar = "16px", or = ({ className: e, width: t = ar, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M11 4.00195V12H9.66992V8.45508H6.33008V12H5V4.00195H6.33008V7.32422H9.66992V4.00195H11Z" }), S("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2Z" })]
	});
};
or.category = "Sort and Filter";
var sr = "16px", cr = ({ className: e, width: t = sr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M7.98828 12.1582C6.13672 12.1582 5.04688 10.5879 5.04688 8.16797V7.83984C5.04688 5.43164 6.14844 3.84375 8.01172 3.84375C9.86914 3.84375 10.9473 5.41406 10.9473 7.83984V8.16797C10.9473 10.5762 9.8457 12.1582 7.98828 12.1582ZM8 4.95117C6.99219 4.95117 6.37109 6.04102 6.37109 7.8457V8.15625C6.37109 9.9668 6.99805 11.0508 8 11.0508C9.00195 11.0508 9.62305 9.96094 9.62305 8.15625V7.8457C9.62305 6.04688 9.00195 4.95117 8 4.95117Z" }), S("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2Z" })]
	});
};
cr.category = "Sort and Filter";
var lr = "16px", ur = ({ className: e, width: t = lr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M9.2832 4.00195V12H7.9707V5.33789H7.90625L6.07227 6.65625V5.38477L7.9707 4.00195H9.2832Z" }), S("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2Z" })]
	});
};
ur.category = "Sort and Filter";
var dr = "16px", fr = ({ className: e, width: t = dr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M6.64648 6.24023V6.31055H5.375V6.24609C5.375 5.0332 6.25391 3.84375 8.01172 3.84375C9.59375 3.84375 10.625 4.79297 10.625 6.05859C10.625 7.06096 10.0256 7.72616 9.33829 8.48895C9.30643 8.52431 9.27438 8.55988 9.24219 8.5957L7.26758 10.8164V10.8926H10.7656V12H5.42188V11.168L8.39258 7.875C8.82617 7.40039 9.29492 6.86719 9.29492 6.16992C9.29492 5.42578 8.73828 4.93359 7.98242 4.93359C7.13867 4.93359 6.64648 5.54883 6.64648 6.24023Z" }), S("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2Z" })]
	});
};
fr.category = "Sort and Filter";
var pr = "16px", mr = ({ className: e, width: t = pr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M7.91797 8.41406H7.03906V7.3418H7.87695C8.65625 7.3418 9.22461 6.82031 9.21875 6.10547C9.21875 5.39648 8.65625 4.91016 7.87109 4.91016C7.08008 4.91016 6.55859 5.4082 6.52344 5.96484H5.27539C5.31055 4.82812 6.22461 3.84961 7.90039 3.84375C9.49414 3.83203 10.5078 4.72852 10.5371 5.90625C10.5605 7.04297 9.65234 7.68164 9.05469 7.78125V7.85156C9.75781 7.92188 10.7656 8.49023 10.7891 9.76758C10.8125 11.2266 9.51172 12.1641 7.85938 12.1641C6.1543 12.1641 5.15234 11.1973 5.10547 10.0195H6.33008C6.38867 10.6172 7.00977 11.0801 7.87109 11.0859C8.84375 11.0918 9.4707 10.5234 9.45898 9.73242C9.45312 8.95312 8.83789 8.41406 7.91797 8.41406Z" }), S("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2Z" })]
	});
};
mr.category = "Sort and Filter";
var hr = "16px", gr = ({ className: e, width: t = hr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M7.51866 5.0572C7.73836 4.70539 7.958 4.35367 8.17578 4.00195H10.1094V9.33398H11.1172V10.4414H10.1094V12H8.84961V10.4414H4.97656V9.32227C5.7465 7.89506 6.63305 6.47538 7.51866 5.0572ZM6.22461 9.28125V9.33398H8.84961V5.0625H8.78516C7.91797 6.39258 6.99805 7.86914 6.22461 9.28125Z" }), S("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2Z" })]
	});
};
gr.category = "Sort and Filter";
var _r = "16px", vr = ({ className: e, width: t = _r, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M7.99414 12.1582C6.42383 12.1582 5.33984 11.2559 5.27539 10.043H6.51172C6.65234 10.7637 7.34375 11.0742 8.04102 11.0742C8.83203 11.0742 9.61133 10.4766 9.61133 9.39258C9.61133 8.42578 8.87891 7.82227 8.0293 7.82227C7.26172 7.82227 6.78711 8.27344 6.59375 8.63086H5.44531L5.79102 4.00195H10.4961V5.10352H6.875L6.68164 7.44727H6.74609C6.91602 7.18945 7.46094 6.76758 8.35742 6.76758C9.74023 6.76758 10.918 7.71094 10.918 9.35156C10.918 11.0391 9.73438 12.1582 7.99414 12.1582Z" }), S("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2Z" })]
	});
};
vr.category = "Sort and Filter";
var yr = "16px", br = ({ className: e, width: t = yr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M8.21094 3.85547C9.82227 3.85547 10.7246 4.8457 10.7832 5.75391H9.49414C9.39453 5.39648 8.98438 4.93945 8.18164 4.93945C7.10352 4.93945 6.36523 6.0293 6.37695 7.97461H6.45898C6.6875 7.42969 7.31445 6.82031 8.43945 6.82031C9.69336 6.82031 10.9473 7.69922 10.9473 9.375C10.9473 11.1445 9.72852 12.1582 8.09961 12.1582C7.16797 12.1582 6.25977 11.8301 5.69141 10.9043C5.32227 10.3008 5.09375 9.44531 5.09375 8.26172C5.09375 5.25 6.3418 3.85547 8.21094 3.85547ZM8.11133 7.86328C7.19141 7.86328 6.54688 8.51367 6.54688 9.43945C6.54688 10.4707 7.25 11.0742 8.10547 11.0742C8.97266 11.0742 9.6582 10.541 9.6582 9.44531C9.6582 8.38477 8.91406 7.86328 8.11133 7.86328Z" }), S("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2Z" })]
	});
};
br.category = "Sort and Filter";
var xr = "16px", Sr = ({ className: e, width: t = xr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M5.36914 5.10938V4.00195H10.6777V5.15039L7.41992 12H6.02539L9.3418 5.17969V5.10938H5.36914Z" }), S("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2Z" })]
	});
};
Sr.category = "Sort and Filter";
var Cr = "16px", wr = ({ className: e, width: t = Cr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M10.9707 9.80273C10.9707 11.1973 9.75195 12.1582 7.98242 12.1582C6.21875 12.1582 5.0293 11.2031 5.0293 9.81445C5.0293 8.54297 5.97852 7.96289 6.67578 7.81055V7.74609C6.05469 7.55273 5.3457 7.00781 5.3457 5.96484C5.3457 4.74023 6.43555 3.84375 8.00586 3.84375C9.57617 3.84375 10.6602 4.74023 10.6602 5.96484C10.6602 7.02539 9.92188 7.55859 9.32422 7.74609V7.81055C10.0273 7.96289 10.9707 8.55469 10.9707 9.80273ZM6.62305 6.09375C6.62305 6.83203 7.20898 7.34766 8.00586 7.34766C8.80273 7.34766 9.38281 6.83203 9.38281 6.09375C9.38281 5.36133 8.80273 4.86328 8.00586 4.86328C7.20898 4.86328 6.62305 5.36133 6.62305 6.09375ZM6.3418 9.73828C6.3418 10.5762 7.0625 11.1504 8.00586 11.1504C8.94922 11.1504 9.66406 10.5762 9.66406 9.73828C9.66406 8.89453 8.94922 8.31445 8.00586 8.31445C7.0625 8.31445 6.3418 8.89453 6.3418 9.73828Z" }), S("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2Z" })]
	});
};
wr.category = "Sort and Filter";
var Tr = "16px", Er = ({ className: e, width: t = Tr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M7.77734 12.1465C6.18359 12.1465 5.35156 11.2559 5.25781 10.3477H6.55273C6.65234 10.7051 7.0918 11.0684 7.80078 11.0684C9.16016 11.0684 9.68164 9.71484 9.63477 8.04492H9.55859C9.32422 8.67188 8.68555 9.22852 7.625 9.22852C6.23047 9.22852 5.05859 8.26758 5.05859 6.5625C5.05859 4.85156 6.30078 3.83203 7.92969 3.83203C9.44141 3.83203 10.9004 4.69922 10.9004 7.8457C10.9004 10.6816 9.88086 12.1465 7.77734 12.1465ZM7.89453 8.17383C8.70312 8.17383 9.42969 7.64648 9.42969 6.58008C9.42969 5.51367 8.76172 4.9043 7.87109 4.9043C7.0332 4.9043 6.35352 5.51953 6.35352 6.5625C6.35352 7.63477 7.0625 8.17383 7.89453 8.17383Z" }), S("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2Z" })]
	});
};
Er.category = "Sort and Filter";
var Dr = "16px", Or = ({ className: e, width: t = Dr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M6.83466 5.0918V7.86914H8.38381C9.37885 7.86914 9.9568 7.40625 9.9568 6.50977C9.9568 5.5957 9.36097 5.0918 8.41956 5.0918H6.83466Z" }), S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM5.5 4.00195H8.61023C10.3203 4.00195 11.351 4.97461 11.351 6.46289C11.351 7.59961 10.6837 8.40234 9.85551 8.70117L11.5 12H9.98064L8.52085 8.92383H6.83466V12H5.5V4.00195Z" })]
	});
};
Or.category = "Sort and Filter";
var kr = "16px", Ar = ({ className: e, width: t = kr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM8.14648 4.99219C6.93359 4.99219 6.21875 5.91211 6.21875 7.49414V8.55469C6.21875 10.125 6.92188 11.0156 8.14648 11.0156C9.125 11.0156 9.78711 10.4297 9.875 9.59766H11.1699V9.69141C11.0703 11.1387 9.81641 12.1582 8.14062 12.1582C6.04883 12.1582 4.87109 10.8223 4.87109 8.55469V7.48242C4.87109 5.2207 6.07227 3.84375 8.14062 3.84375C9.82227 3.84375 11.0762 4.89844 11.1699 6.41602V6.50391H9.875C9.78711 5.625 9.10742 4.99219 8.14648 4.99219Z" })
	});
};
Ar.category = "Sort and Filter";
var jr = "16px", Mr = ({ className: e, width: t = jr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM5.40808 5.88916C4.57751 5.88916 4.08972 6.53076 4.08972 7.64258V8.38525C4.08972 9.49268 4.56873 10.1123 5.40808 10.1123C6.09802 10.1123 6.54626 9.67725 6.5946 9.06201H7.74158V9.17627C7.68445 10.3232 6.71326 11.1143 5.39929 11.1143C3.7865 11.1143 2.88123 10.0859 2.88123 8.38525V7.63818C2.88123 5.9375 3.79529 4.88721 5.39929 4.88721C6.71765 4.88721 7.68884 5.7002 7.74158 6.88672V6.99658H6.5946C6.54626 6.35938 6.08923 5.88916 5.40808 5.88916ZM10.8116 5.88916C9.98103 5.88916 9.49324 6.53076 9.49324 7.64258V8.38525C9.49324 9.49268 9.97224 10.1123 10.8116 10.1123C11.5015 10.1123 11.9498 9.67725 11.9981 9.06201H13.1451V9.17627C13.088 10.3232 12.1168 11.1143 10.8028 11.1143C9.19001 11.1143 8.28474 10.0859 8.28474 8.38525V7.63818C8.28474 5.9375 9.1988 4.88721 10.8028 4.88721C12.1212 4.88721 13.0924 5.7002 13.1451 6.88672V6.99658H11.9981C11.9498 6.35938 11.4927 5.88916 10.8116 5.88916Z" })
	});
};
Mr.category = "Sort and Filter";
var Nr = "16px", Pr = ({ className: e, width: t = Nr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M8.26978 8.07422C9.1629 8.07422 9.68859 7.5293 9.68859 6.58594C9.68859 5.64258 9.1629 5.10352 8.26978 5.10352H6.77749V8.07422H8.26978Z" }), S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM5.5 4.00195H8.46197C10.0447 4.00195 11 5.10352 11 6.58594C11 8.08008 10.0334 9.16406 8.45067 9.16406H6.78314V12H5.5V4.00195Z" })]
	});
};
Pr.category = "Sort and Filter";
var Fr = "16px", Ir = ({ className: e, width: t = Fr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM11 4.00195V12H9.66992V8.45508H6.33008V12H5V4.00195H6.33008V7.32422H9.66992V4.00195H11Z" })
	});
};
Ir.category = "Sort and Filter";
var Lr = "16px", Rr = ({ className: e, width: t = Lr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M8 4.95117C6.99219 4.95117 6.37109 6.04102 6.37109 7.8457V8.15625C6.37109 9.9668 6.99805 11.0508 8 11.0508C9.00195 11.0508 9.62305 9.96094 9.62305 8.15625V7.8457C9.62305 6.04688 9.00195 4.95117 8 4.95117Z" }), S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM7.98828 12.1582C6.13672 12.1582 5.04688 10.5879 5.04688 8.16797V7.83984C5.04688 5.43164 6.14844 3.84375 8.01172 3.84375C9.86914 3.84375 10.9473 5.41406 10.9473 7.83984V8.16797C10.9473 10.5762 9.8457 12.1582 7.98828 12.1582Z" })]
	});
};
Rr.category = "Sort and Filter";
var zr = "16px", Br = ({ className: e, width: t = zr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM9.2832 4.00195V12H7.9707V5.33789H7.90625L6.07227 6.65625V5.38477L7.9707 4.00195H9.2832Z" })
	});
};
Br.category = "Sort and Filter";
var Vr = "16px", Hr = ({ className: e, width: t = Vr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM6.64648 6.24023V6.31055H5.375V6.24609C5.375 5.0332 6.25391 3.84375 8.01172 3.84375C9.59375 3.84375 10.625 4.79297 10.625 6.05859C10.625 7.06096 10.0256 7.72616 9.33829 8.48895C9.30643 8.52431 9.27438 8.55988 9.24219 8.5957L7.26758 10.8164V10.8926H10.7656V12H5.42188V11.168L8.39258 7.875C8.82617 7.40039 9.29492 6.86719 9.29492 6.16992C9.29492 5.42578 8.73828 4.93359 7.98242 4.93359C7.13867 4.93359 6.64648 5.54883 6.64648 6.24023Z" })
	});
};
Hr.category = "Sort and Filter";
var Ur = "16px", Wr = ({ className: e, width: t = Ur, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM7.91797 8.41406H7.03906V7.3418H7.87695C8.65625 7.3418 9.22461 6.82031 9.21875 6.10547C9.21875 5.39648 8.65625 4.91016 7.87109 4.91016C7.08008 4.91016 6.55859 5.4082 6.52344 5.96484H5.27539C5.31055 4.82812 6.22461 3.84961 7.90039 3.84375C9.49414 3.83203 10.5078 4.72852 10.5371 5.90625C10.5605 7.04297 9.65234 7.68164 9.05469 7.78125V7.85156C9.75781 7.92188 10.7656 8.49023 10.7891 9.76758C10.8125 11.2266 9.51172 12.1641 7.85938 12.1641C6.1543 12.1641 5.15234 11.1973 5.10547 10.0195H6.33008C6.38867 10.6172 7.00977 11.0801 7.87109 11.0859C8.84375 11.0918 9.4707 10.5234 9.45898 9.73242C9.45312 8.95312 8.83789 8.41406 7.91797 8.41406Z" })
	});
};
Wr.category = "Sort and Filter";
var Gr = "16px", Kr = ({ className: e, width: t = Gr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M6.22461 9.28125V9.33398H8.84961V5.0625H8.78516C7.91797 6.39258 6.99805 7.86914 6.22461 9.28125Z" }), S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM7.51866 5.0572C7.73836 4.70539 7.958 4.35367 8.17578 4.00195H10.1094V9.33398H11.1172V10.4414H10.1094V12H8.84961V10.4414H4.97656V9.32227C5.7465 7.89506 6.63305 6.47538 7.51866 5.0572Z" })]
	});
};
Kr.category = "Sort and Filter";
var qr = "16px", Jr = ({ className: e, width: t = qr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM7.99414 12.1582C6.42383 12.1582 5.33984 11.2559 5.27539 10.043H6.51172C6.65234 10.7637 7.34375 11.0742 8.04102 11.0742C8.83203 11.0742 9.61133 10.4766 9.61133 9.39258C9.61133 8.42578 8.87891 7.82227 8.0293 7.82227C7.26172 7.82227 6.78711 8.27344 6.59375 8.63086H5.44531L5.79102 4.00195H10.4961V5.10352H6.875L6.68164 7.44727H6.74609C6.91602 7.18945 7.46094 6.76758 8.35742 6.76758C9.74023 6.76758 10.918 7.71094 10.918 9.35156C10.918 11.0391 9.73438 12.1582 7.99414 12.1582Z" })
	});
};
Jr.category = "Sort and Filter";
var Yr = "16px", Xr = ({ className: e, width: t = Yr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M8.11133 7.86328C7.19141 7.86328 6.54688 8.51367 6.54688 9.43945C6.54688 10.4707 7.25 11.0742 8.10547 11.0742C8.97266 11.0742 9.6582 10.541 9.6582 9.44531C9.6582 8.38477 8.91406 7.86328 8.11133 7.86328Z" }), S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM8.21094 3.85547C9.82227 3.85547 10.7246 4.8457 10.7832 5.75391H9.49414C9.39453 5.39648 8.98438 4.93945 8.18164 4.93945C7.10352 4.93945 6.36523 6.0293 6.37695 7.97461H6.45898C6.6875 7.42969 7.31445 6.82031 8.43945 6.82031C9.69336 6.82031 10.9473 7.69922 10.9473 9.375C10.9473 11.1445 9.72852 12.1582 8.09961 12.1582C7.16797 12.1582 6.25977 11.8301 5.69141 10.9043C5.32227 10.3008 5.09375 9.44531 5.09375 8.26172C5.09375 5.25 6.3418 3.85547 8.21094 3.85547Z" })]
	});
};
Xr.category = "Sort and Filter";
var Zr = "16px", Qr = ({ className: e, width: t = Zr, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM5.36914 5.10938V4.00195H10.6777V5.15039L7.41992 12H6.02539L9.3418 5.17969V5.10938H5.36914Z" })
	});
};
Qr.category = "Sort and Filter";
var $r = "16px", ei = ({ className: e, width: t = $r, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M6.62305 6.09375C6.62305 6.83203 7.20898 7.34766 8.00586 7.34766C8.80273 7.34766 9.38281 6.83203 9.38281 6.09375C9.38281 5.36133 8.80273 4.86328 8.00586 4.86328C7.20898 4.86328 6.62305 5.36133 6.62305 6.09375Z" }),
			S("path", { d: "M6.3418 9.73828C6.3418 10.5762 7.0625 11.1504 8.00586 11.1504C8.94922 11.1504 9.66406 10.5762 9.66406 9.73828C9.66406 8.89453 8.94922 8.31445 8.00586 8.31445C7.0625 8.31445 6.3418 8.89453 6.3418 9.73828Z" }),
			S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM10.9707 9.80273C10.9707 11.1973 9.75195 12.1582 7.98242 12.1582C6.21875 12.1582 5.0293 11.2031 5.0293 9.81445C5.0293 8.54297 5.97852 7.96289 6.67578 7.81055V7.74609C6.05469 7.55273 5.3457 7.00781 5.3457 5.96484C5.3457 4.74023 6.43555 3.84375 8.00586 3.84375C9.57617 3.84375 10.6602 4.74023 10.6602 5.96484C10.6602 7.02539 9.92188 7.55859 9.32422 7.74609V7.81055C10.0273 7.96289 10.9707 8.55469 10.9707 9.80273Z" })
		]
	});
};
ei.category = "Sort and Filter";
var ti = "16px", ni = ({ className: e, width: t = ti, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M7.89453 8.17383C8.70312 8.17383 9.42969 7.64648 9.42969 6.58008C9.42969 5.51367 8.76172 4.9043 7.87109 4.9043C7.0332 4.9043 6.35352 5.51953 6.35352 6.5625C6.35352 7.63477 7.0625 8.17383 7.89453 8.17383Z" }), S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM7.77734 12.1465C6.18359 12.1465 5.35156 11.2559 5.25781 10.3477H6.55273C6.65234 10.7051 7.0918 11.0684 7.80078 11.0684C9.16016 11.0684 9.68164 9.71484 9.63477 8.04492H9.55859C9.32422 8.67188 8.68555 9.22852 7.625 9.22852C6.23047 9.22852 5.05859 8.26758 5.05859 6.5625C5.05859 4.85156 6.30078 3.83203 7.92969 3.83203C9.44141 3.83203 10.9004 4.69922 10.9004 7.8457C10.9004 10.6816 9.88086 12.1465 7.77734 12.1465Z" })]
	});
};
ni.category = "Sort and Filter";
var ri = "16px", ii = ({ className: e, width: t = ri, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645Z" })
	});
};
ii.category = "Alerts, Warnings, and Signs";
var ai = "16px", oi = ({ className: e, width: t = ai, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M13.8536 2.14645C14.0488 2.34171 14.0488 2.65829 13.8536 2.85355L2.85355 13.8536C2.65829 14.0488 2.34171 14.0488 2.14645 13.8536C1.95118 13.6583 1.95118 13.3417 2.14645 13.1464L13.1464 2.14645C13.3417 1.95118 13.6583 1.95118 13.8536 2.14645Z" })
	});
};
oi.category = "Alerts, Warnings, and Signs";
var si = "16px", ci = ({ className: e, width: t = si, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" }),
			S("path", { d: "M11.3536 4.64645C11.1583 4.45118 10.8417 4.45118 10.6464 4.64645L4.64645 10.6464C4.45118 10.8417 4.45118 11.1583 4.64645 11.3536C4.84171 11.5488 5.15829 11.5488 5.35355 11.3536L11.3536 5.35355C11.5488 5.15829 11.5488 4.84171 11.3536 4.64645Z" }),
			S("path", { d: "M15 8C15 11.866 11.866 15 8 15C6.24696 15 4.64443 14.3556 3.41637 13.2907L13.2907 3.41637C14.3556 4.64443 15 6.24696 15 8ZM2.70926 12.5836L12.5836 2.70926C11.3556 1.64441 9.75304 1 8 1C4.13401 1 1 4.13401 1 8C1 9.75304 1.64441 11.3556 2.70926 12.5836ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z" })
		]
	});
};
ci.category = "Alerts, Warnings, and Signs";
var li = "16px", ui = ({ className: e, width: t = li, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11.3536 5.35355C11.5488 5.15829 11.5488 4.84171 11.3536 4.64645C11.1583 4.45118 10.8417 4.45118 10.6464 4.64645L4.64645 10.6464C4.45118 10.8417 4.45118 11.1583 4.64645 11.3536C4.84171 11.5488 5.15829 11.5488 5.35355 11.3536L11.3536 5.35355Z" })
	});
};
ui.category = "Alerts, Warnings, and Signs";
var di = "16px", fi = ({ className: e, width: t = di, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM14.259 1.03387C14.1764 1.01178 14.0896 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.0896 1.01178 14.1764 1.03387 14.259L14.259 1.03387ZM14.9661 1.74098L1.74098 14.9661C1.82359 14.9882 1.91042 15 2 15H14C14.5523 15 15 14.5523 15 14V2C15 1.91042 14.9882 1.82359 14.9661 1.74098Z" })
	});
};
fi.category = "Alerts, Warnings, and Signs";
var pi = "16px", mi = ({ className: e, width: t = pi, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM11.3536 5.35355L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355Z" })
	});
};
mi.category = "Alerts, Warnings, and Signs";
var hi = "16px", gi = ({ className: e, width: t = hi, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645L8 7.29289L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355L8.70711 8L11.3536 10.6464C11.5488 10.8417 11.5488 11.1583 11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536L8 8.70711L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L7.29289 8L4.64645 5.35355C4.45118 5.15829 4.45118 4.84171 4.64645 4.64645Z" })
	});
};
gi.category = "Alerts, Warnings, and Signs";
var _i = "16px", vi = ({ className: e, width: t = _i, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2.14645 2.85355C1.95118 2.65829 1.95118 2.34171 2.14645 2.14645C2.34171 1.95118 2.65829 1.95118 2.85355 2.14645L8 7.29289L13.1464 2.14645C13.3417 1.95118 13.6583 1.95118 13.8536 2.14645C14.0488 2.34171 14.0488 2.65829 13.8536 2.85355L8.70711 8L13.8536 13.1464C14.0488 13.3417 14.0488 13.6583 13.8536 13.8536C13.6583 14.0488 13.3417 14.0488 13.1464 13.8536L8 8.70711L2.85355 13.8536C2.65829 14.0488 2.34171 14.0488 2.14645 13.8536C1.95119 13.6583 1.95119 13.3417 2.14645 13.1464L7.29289 8L2.14645 2.85355Z" })
	});
};
vi.category = "Alerts, Warnings, and Signs";
var yi = "16px", bi = ({ className: e, width: t = yi, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" }), S("path", { d: "M4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645L8 7.29289L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355L8.70711 8L11.3536 10.6464C11.5488 10.8417 11.5488 11.1583 11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536L8 8.70711L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L7.29289 8L4.64645 5.35355C4.45118 5.15829 4.45118 4.84171 4.64645 4.64645Z" })]
	});
};
bi.category = "Alerts, Warnings, and Signs";
var xi = "16px", Si = ({ className: e, width: t = xi, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.35355 4.64645C5.15829 4.45118 4.84171 4.45118 4.64645 4.64645C4.45118 4.84171 4.45118 5.15829 4.64645 5.35355L7.29289 8L4.64645 10.6464C4.45118 10.8417 4.45118 11.1583 4.64645 11.3536C4.84171 11.5488 5.15829 11.5488 5.35355 11.3536L8 8.70711L10.6464 11.3536C10.8417 11.5488 11.1583 11.5488 11.3536 11.3536C11.5488 11.1583 11.5488 10.8417 11.3536 10.6464L8.70711 8L11.3536 5.35355C11.5488 5.15829 11.5488 4.84171 11.3536 4.64645C11.1583 4.45118 10.8417 4.45118 10.6464 4.64645L8 7.29289L5.35355 4.64645Z" })
	});
};
Si.category = "Alerts, Warnings, and Signs";
var Ci = "16px", wi = ({ className: e, width: t = Ci, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M14 1C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V2C1 1.44772 1.44772 1 2 1H14ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2Z" }), S("path", { d: "M4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645L8 7.29289L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355L8.70711 8L11.3536 10.6464C11.5488 10.8417 11.5488 11.1583 11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536L8 8.70711L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L7.29289 8L4.64645 5.35355C4.45118 5.15829 4.45118 4.84171 4.64645 4.64645Z" })]
	});
};
wi.category = "Alerts, Warnings, and Signs";
var Ti = "16px", Ei = ({ className: e, width: t = Ti, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM5.35355 4.64645L8 7.29289L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355L8.70711 8L11.3536 10.6464C11.5488 10.8417 11.5488 11.1583 11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536L8 8.70711L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L7.29289 8L4.64645 5.35355C4.45118 5.15829 4.45118 4.84171 4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645Z" })
	});
};
Ei.category = "Alerts, Warnings, and Signs";
var Di = "16px", Oi = ({ className: e, width: t = Di, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M4.53984 0.146447C4.63361 0.0526784 4.76079 0 4.8934 0H11.1066C11.2392 0 11.3664 0.0526784 11.4602 0.146447L15.8536 4.53984C15.9473 4.63361 16 4.76079 16 4.8934V11.1066C16 11.2392 15.9473 11.3664 15.8536 11.4602L11.4602 15.8536C11.3664 15.9473 11.2392 16 11.1066 16H4.8934C4.76079 16 4.63361 15.9473 4.53984 15.8536L0.146447 11.4602C0.0526784 11.3664 0 11.2392 0 11.1066V4.8934C0 4.76079 0.0526784 4.63361 0.146447 4.53984L4.53984 0.146447ZM5.1005 1L1 5.1005V10.8995L5.10051 15H10.8995L15 10.8995V5.10051L10.8995 1H5.1005Z" }), S("path", { d: "M4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645L8 7.29289L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355L8.70711 8L11.3536 10.6464C11.5488 10.8417 11.5488 11.1583 11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536L8 8.70711L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L7.29289 8L4.64645 5.35355C4.45118 5.15829 4.45118 4.84171 4.64645 4.64645Z" })]
	});
};
Oi.category = "Alerts, Warnings, and Signs";
var ki = "16px", Ai = ({ className: e, width: t = ki, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M11.4602 0.146447C11.3664 0.0526784 11.2392 0 11.1066 0H4.8934C4.76079 0 4.63361 0.0526784 4.53984 0.146447L0.146447 4.53984C0.0526784 4.63361 0 4.76079 0 4.8934V11.1066C0 11.2392 0.0526784 11.3664 0.146447 11.4602L4.53984 15.8536C4.63361 15.9473 4.76079 16 4.8934 16H11.1066C11.2392 16 11.3664 15.9473 11.4602 15.8536L15.8536 11.4602C15.9473 11.3664 16 11.2392 16 11.1066V4.8934C16 4.76079 15.9473 4.63361 15.8536 4.53984L11.4602 0.146447ZM5.35355 4.64645L8 7.29289L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355L8.70711 8L11.3536 10.6464C11.5488 10.8417 11.5488 11.1583 11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536L8 8.70711L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L7.29289 8L4.64645 5.35355C4.45118 5.15829 4.45118 4.84171 4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645Z" })
	});
};
Ai.category = "Alerts, Warnings, and Signs";
var ji = "16px", Mi = ({ className: e, width: t = ji, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M7.98651 15.9999C7.59909 15.9965 7.21271 15.8471 6.91711 15.5515L0.448547 9.08289C-0.149515 8.48483 -0.149517 7.51517 0.448547 6.91711L6.91711 0.448547C7.51517 -0.149515 8.48483 -0.149517 9.08289 0.448547L15.5515 6.91711C15.8471 7.21271 15.9965 7.59909 15.9999 7.98651C16 7.9955 16 8.0045 15.9999 8.01349C15.9965 8.40091 15.8471 8.78729 15.5515 9.08289L9.08289 15.5515C8.78729 15.8471 8.40091 15.9965 8.01349 15.9999C8.0045 16 7.9955 16 7.98651 15.9999ZM7.63904 1.17047L4.76572 4.04379L8 7.27807L11.2343 4.04379L8.36096 1.17047C8.16161 0.971119 7.83839 0.971118 7.63904 1.17047ZM8.72193 8L11.9562 11.2343L14.8295 8.36096C15.0289 8.16161 15.0289 7.83839 14.8295 7.63904L11.9562 4.76572L8.72193 8ZM8 8.72193L4.76572 11.9562L7.63904 14.8295C7.83839 15.0289 8.16161 15.0289 8.36096 14.8295L11.2343 11.9562L8 8.72193ZM7.27807 8L4.04379 4.76572L1.17047 7.63904C0.971119 7.83839 0.971118 8.16161 1.17047 8.36096L4.04379 11.2343L7.27807 8Z" })
	});
};
Mi.category = "Alerts, Warnings, and Signs";
var Ni = "16px", Pi = ({ className: e, width: t = Ni, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M9.04941 0.434679C8.46984 -0.144892 7.53017 -0.144894 6.95059 0.434678L4.0462 3.33907L8 7.29286L11.9538 3.33907L9.04941 0.434679Z" }),
			S("path", { d: "M12.6609 4.04617L8.70711 7.99997L12.6609 11.9538L15.5653 9.04941C16.1449 8.46984 16.1449 7.53017 15.5653 6.95059L12.6609 4.04617Z" }),
			S("path", { d: "M11.9538 12.6609L8 8.70708L4.04617 12.6609L6.95059 15.5653C7.53016 16.1449 8.46983 16.1449 9.04941 15.5653L11.9538 12.6609Z" }),
			S("path", { d: "M3.33907 11.9538L7.29289 7.99997L3.3391 4.04617L0.434679 6.95059C-0.144892 7.53016 -0.144894 8.46983 0.434678 9.04941L3.33907 11.9538Z" })
		]
	});
};
Pi.category = "Alerts, Warnings, and Signs";
var Fi = "16px", Ii = ({ className: e, width: t = Fi, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M8.9307 6.58789L6.63969 6.875L6.55766 7.25586L7.00883 7.33789C7.3018 7.4082 7.36039 7.51367 7.29594 7.80664L6.55766 11.2754C6.3643 12.1719 6.66312 12.5938 7.36625 12.5938C7.91117 12.5938 8.54398 12.3418 8.83109 11.9961L8.91898 11.5801C8.71977 11.7559 8.4268 11.8262 8.23344 11.8262C7.95805 11.8262 7.85844 11.6328 7.92875 11.293L8.9307 6.58789Z" }), S("path", { d: "M9 4.5C9 5.05228 8.55228 5.5 8 5.5C7.44772 5.5 7 5.05228 7 4.5C7 3.94772 7.44772 3.5 8 3.5C8.55228 3.5 9 3.94772 9 4.5Z" })]
	});
};
Ii.category = "Alerts, Warnings, and Signs";
var Li = "16px", Ri = ({ className: e, width: t = Li, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M9.70753 6.07474L6.68433 6.45361L6.57608 6.95619L7.17144 7.06443C7.55804 7.15722 7.63536 7.29639 7.55031 7.68299L6.57608 12.2603C6.32093 13.4433 6.71526 14 7.64309 14C8.36216 14 9.19722 13.6675 9.57608 13.2113L9.69206 12.6624C9.42918 12.8943 9.04258 12.9871 8.78742 12.9871C8.42402 12.9871 8.29258 12.732 8.38536 12.2835L9.70753 6.07474Z" }), S("path", { d: "M9.79897 3.31959C9.79897 4.04838 9.20817 4.63918 8.47938 4.63918C7.75059 4.63918 7.15979 4.04838 7.15979 3.31959C7.15979 2.5908 7.75059 2 8.47938 2C9.20817 2 9.79897 2.5908 9.79897 3.31959Z" })]
	});
};
Ri.category = "Alerts, Warnings, and Signs";
var zi = "16px", Bi = ({ className: e, width: t = zi, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" }),
			S("path", { d: "M8.9307 6.58789L6.63969 6.875L6.55766 7.25586L7.00883 7.33789C7.3018 7.4082 7.36039 7.51367 7.29594 7.80664L6.55766 11.2754C6.3643 12.1719 6.66313 12.5938 7.36625 12.5938C7.91117 12.5938 8.54398 12.3418 8.83109 11.9961L8.91898 11.5801C8.71977 11.7559 8.4268 11.8262 8.23344 11.8262C7.95805 11.8262 7.85844 11.6328 7.92875 11.293L8.9307 6.58789Z" }),
			S("path", { d: "M9 4.5C9 5.05228 8.55229 5.5 8 5.5C7.44772 5.5 7 5.05228 7 4.5C7 3.94772 7.44772 3.5 8 3.5C8.55229 3.5 9 3.94772 9 4.5Z" })
		]
	});
};
Bi.category = "Alerts, Warnings, and Signs";
var Vi = "16px", Hi = ({ className: e, width: t = Vi, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8.9307 6.58789L7.92875 11.293C7.85844 11.6328 7.95805 11.8262 8.23344 11.8262C8.4268 11.8262 8.71977 11.7559 8.91898 11.5801L8.83109 11.9961C8.54398 12.3418 7.91117 12.5938 7.36625 12.5938C6.66313 12.5938 6.3643 12.1719 6.55766 11.2754L7.29594 7.80664C7.36039 7.51367 7.3018 7.4082 7.00883 7.33789L6.55766 7.25586L6.63969 6.875L8.9307 6.58789ZM8 5.5C7.44772 5.5 7 5.05228 7 4.5C7 3.94772 7.44772 3.5 8 3.5C8.55229 3.5 9 3.94772 9 4.5C9 5.05228 8.55229 5.5 8 5.5Z" })
	});
};
Hi.category = "Alerts, Warnings, and Signs";
var Ui = "16px", Wi = ({ className: e, width: t = Ui, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M14 1C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V2C1 1.44772 1.44772 1 2 1H14ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2Z" }),
			S("path", { d: "M8.9307 6.58789L6.63969 6.875L6.55766 7.25586L7.00883 7.33789C7.3018 7.4082 7.36039 7.51367 7.29594 7.80664L6.55766 11.2754C6.3643 12.1719 6.66313 12.5938 7.36625 12.5938C7.91117 12.5938 8.54398 12.3418 8.83109 11.9961L8.91898 11.5801C8.71977 11.7559 8.4268 11.8262 8.23344 11.8262C7.95805 11.8262 7.85844 11.6328 7.92875 11.293L8.9307 6.58789Z" }),
			S("path", { d: "M9 4.5C9 5.05228 8.55229 5.5 8 5.5C7.44772 5.5 7 5.05228 7 4.5C7 3.94772 7.44772 3.5 8 3.5C8.55229 3.5 9 3.94772 9 4.5Z" })
		]
	});
};
Wi.category = "Alerts, Warnings, and Signs";
var Gi = "16px", Ki = ({ className: e, width: t = Gi, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM8.9307 6.58789L6.63969 6.875L6.55766 7.25586L7.00883 7.33789C7.3018 7.4082 7.36039 7.51367 7.29594 7.80664L6.55766 11.2754C6.3643 12.1719 6.66313 12.5938 7.36625 12.5938C7.91117 12.5938 8.54398 12.3418 8.83109 11.9961L8.91898 11.5801C8.71977 11.7559 8.4268 11.8262 8.23344 11.8262C7.95805 11.8262 7.85844 11.6328 7.92875 11.293L8.9307 6.58789ZM8 5.5C8.55229 5.5 9 5.05228 9 4.5C9 3.94772 8.55229 3.5 8 3.5C7.44772 3.5 7 3.94772 7 4.5C7 5.05228 7.44772 5.5 8 5.5Z" })
	});
};
Ki.category = "Alerts, Warnings, and Signs";
var qi = "16px", Ji = ({ className: e, width: t = qi, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M5.255 5.78615C5.24741 5.92237 5.3598 6.03271 5.49623 6.03271H6.32071C6.45878 6.03271 6.56857 5.92013 6.58712 5.78331C6.67607 5.12718 7.12639 4.64893 7.92911 4.64893C8.61466 4.64893 9.24308 4.9917 9.24308 5.81689C9.24308 6.45166 8.86856 6.74365 8.27823 7.18799C7.60538 7.67676 7.07218 8.24805 7.11026 9.1748L7.11323 9.39161C7.11511 9.52833 7.22647 9.63818 7.36321 9.63818H8.17423C8.3123 9.63818 8.42423 9.52625 8.42423 9.38818V9.28271C8.42423 8.56543 8.69718 8.35596 9.43351 7.79736C10.0429 7.33398 10.6776 6.81982 10.6776 5.74072C10.6776 4.22998 9.40177 3.5 8.00528 3.5C6.7382 3.5 5.34953 4.09061 5.255 5.78615ZM6.81192 11.5488C6.81192 12.082 7.23722 12.4756 7.8212 12.4756C8.43058 12.4756 8.84952 12.082 8.84952 11.5488C8.84952 10.9966 8.43058 10.6094 7.8212 10.6094C7.23722 10.6094 6.81192 10.9966 6.81192 11.5488Z" })
	});
};
Ji.category = "Alerts, Warnings, and Signs";
var Yi = "16px", Xi = ({ className: e, width: t = Yi, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M4.47468 5.45798C4.19086 5.45798 3.96062 5.2209 4.00565 4.94068C4.27871 3.24141 5.57505 2 7.82403 2C10.074 2 11.5911 3.36066 11.5911 5.21531C11.5911 6.55864 10.9263 7.5033 9.8013 8.18796C8.70187 8.84662 8.38653 9.30595 8.38653 10.1986V10.2273C8.38653 10.5034 8.16267 10.7273 7.88653 10.7273H7.11622C6.84247 10.7273 6.61962 10.5071 6.61626 10.2334L6.6138 10.0339C6.57119 8.81195 7.09108 8.03196 8.25869 7.3213C9.28994 6.68863 9.65642 6.18597 9.65642 5.29331C9.65642 4.31398 8.89789 3.59466 7.73028 3.59466C6.72137 3.59466 6.01976 4.12397 5.79223 4.99661C5.72583 5.25126 5.51448 5.45798 5.25132 5.45798H4.47468ZM7.49602 14C8.11821 14 8.59108 13.5264 8.59108 12.9091C8.59108 12.2918 8.11821 11.8182 7.49602 11.8182C6.89042 11.8182 6.40926 12.2918 6.40926 12.9091C6.40926 13.5264 6.89042 14 7.49602 14Z" })
	});
};
Xi.category = "Alerts, Warnings, and Signs";
var Zi = "16px", Qi = ({ className: e, width: t = Zi, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" }), S("path", { d: "M5.25511 5.78615C5.24752 5.92237 5.3599 6.03271 5.49634 6.03271H6.32082C6.45889 6.03271 6.56868 5.92013 6.58723 5.78331C6.67618 5.12718 7.1265 4.64893 7.92922 4.64893C8.61477 4.64893 9.24318 4.9917 9.24318 5.81689C9.24318 6.45166 8.86867 6.74365 8.27834 7.18799C7.60549 7.67676 7.07229 8.24805 7.11037 9.1748L7.11334 9.39161C7.11521 9.52833 7.22658 9.63818 7.36332 9.63818H8.17434C8.31241 9.63818 8.42434 9.52625 8.42434 9.38818V9.28271C8.42434 8.56543 8.69729 8.35596 9.43361 7.79736C10.043 7.33398 10.6778 6.81982 10.6778 5.74072C10.6778 4.22998 9.40188 3.5 8.00539 3.5C6.73831 3.5 5.34964 4.09061 5.25511 5.78615ZM6.81203 11.5488C6.81203 12.082 7.23732 12.4756 7.82131 12.4756C8.43068 12.4756 8.84963 12.082 8.84963 11.5488C8.84963 10.9966 8.43068 10.6094 7.82131 10.6094C7.23732 10.6094 6.81203 10.9966 6.81203 11.5488Z" })]
	});
};
Qi.category = "Alerts, Warnings, and Signs";
var $i = "16px", ea = ({ className: e, width: t = $i, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.49634 6.03271H6.32082C6.45889 6.03271 6.56868 5.92013 6.58723 5.78331C6.67618 5.12718 7.1265 4.64893 7.92922 4.64893C8.61477 4.64893 9.24318 4.9917 9.24318 5.81689C9.24318 6.45166 8.86867 6.74365 8.27834 7.18799C7.60549 7.67676 7.07229 8.24805 7.11037 9.1748L7.11334 9.39161C7.11521 9.52833 7.22658 9.63818 7.36332 9.63818H8.17434C8.31241 9.63818 8.42434 9.52625 8.42434 9.38818V9.28271C8.42434 8.56543 8.69729 8.35596 9.43361 7.79736C10.043 7.33398 10.6778 6.81982 10.6778 5.74072C10.6778 4.22998 9.40188 3.5 8.00539 3.5C6.73831 3.5 5.34964 4.09061 5.25511 5.78615C5.24752 5.92237 5.3599 6.03271 5.49634 6.03271ZM7.82131 12.4756C8.43068 12.4756 8.84963 12.082 8.84963 11.5488C8.84963 10.9966 8.43068 10.6094 7.82131 10.6094C7.23732 10.6094 6.81203 10.9966 6.81203 11.5488C6.81203 12.082 7.23732 12.4756 7.82131 12.4756Z" })
	});
};
ea.category = "Alerts, Warnings, and Signs";
var ta = "16px", na = ({ className: e, width: t = ta, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M14 1C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V2C1 1.44772 1.44772 1 2 1H14ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2Z" }), S("path", { d: "M5.25511 5.78615C5.24752 5.92237 5.3599 6.03271 5.49634 6.03271H6.32082C6.45889 6.03271 6.56868 5.92013 6.58723 5.78331C6.67618 5.12718 7.1265 4.64893 7.92922 4.64893C8.61477 4.64893 9.24318 4.9917 9.24318 5.81689C9.24318 6.45166 8.86867 6.74365 8.27834 7.18799C7.60549 7.67676 7.07229 8.24805 7.11037 9.1748L7.11334 9.39161C7.11521 9.52833 7.22658 9.63818 7.36332 9.63818H8.17434C8.31241 9.63818 8.42434 9.52625 8.42434 9.38818V9.28271C8.42434 8.56543 8.69729 8.35596 9.43361 7.79736C10.043 7.33398 10.6778 6.81982 10.6778 5.74072C10.6778 4.22998 9.40188 3.5 8.00539 3.5C6.73831 3.5 5.34964 4.09061 5.25511 5.78615ZM6.81203 11.5488C6.81203 12.082 7.23732 12.4756 7.82131 12.4756C8.43068 12.4756 8.84963 12.082 8.84963 11.5488C8.84963 10.9966 8.43068 10.6094 7.82131 10.6094C7.23732 10.6094 6.81203 10.9966 6.81203 11.5488Z" })]
	});
};
na.category = "Alerts, Warnings, and Signs";
var ra = "16px", ia = ({ className: e, width: t = ra, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM5.49634 6.03271C5.3599 6.03271 5.24752 5.92237 5.25511 5.78615C5.34964 4.09061 6.73831 3.5 8.00539 3.5C9.40188 3.5 10.6778 4.22998 10.6778 5.74072C10.6778 6.81982 10.043 7.33398 9.43361 7.79736C8.69729 8.35596 8.42434 8.56543 8.42434 9.28271V9.38818C8.42434 9.52625 8.31241 9.63818 8.17434 9.63818H7.36332C7.22658 9.63818 7.11521 9.52833 7.11334 9.39161L7.11037 9.1748C7.07229 8.24805 7.60549 7.67676 8.27834 7.18799C8.86867 6.74365 9.24318 6.45166 9.24318 5.81689C9.24318 4.9917 8.61477 4.64893 7.92922 4.64893C7.1265 4.64893 6.67618 5.12718 6.58723 5.78331C6.56868 5.92013 6.45889 6.03271 6.32082 6.03271H5.49634ZM7.82131 12.4756C7.23732 12.4756 6.81203 12.082 6.81203 11.5488C6.81203 10.9966 7.23732 10.6094 7.82131 10.6094C8.43068 10.6094 8.84963 10.9966 8.84963 11.5488C8.84963 12.082 8.43068 12.4756 7.82131 12.4756Z" })
	});
};
ia.category = "Alerts, Warnings, and Signs";
var aa = "16px", oa = ({ className: e, width: t = aa, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M4.53984 0.146447C4.63361 0.0526784 4.76079 0 4.8934 0H11.1066C11.2392 0 11.3664 0.0526784 11.4602 0.146447L15.8536 4.53984C15.9473 4.63361 16 4.76079 16 4.8934V11.1066C16 11.2392 15.9473 11.3664 15.8536 11.4602L11.4602 15.8536C11.3664 15.9473 11.2392 16 11.1066 16H4.8934C4.76079 16 4.63361 15.9473 4.53984 15.8536L0.146447 11.4602C0.0526784 11.3664 0 11.2392 0 11.1066V4.8934C0 4.76079 0.0526784 4.63361 0.146447 4.53984L4.53984 0.146447ZM5.1005 1L1 5.1005V10.8995L5.10051 15H10.8995L15 10.8995V5.10051L10.8995 1H5.1005Z" }), S("path", { d: "M5.25511 5.78615C5.24752 5.92237 5.3599 6.03271 5.49634 6.03271H6.32082C6.45889 6.03271 6.56868 5.92013 6.58723 5.78331C6.67618 5.12718 7.1265 4.64893 7.92922 4.64893C8.61477 4.64893 9.24318 4.9917 9.24318 5.81689C9.24318 6.45166 8.86867 6.74365 8.27834 7.18799C7.60549 7.67676 7.07229 8.24805 7.11037 9.1748L7.11334 9.39161C7.11521 9.52833 7.22658 9.63818 7.36332 9.63818H8.17434C8.31241 9.63818 8.42434 9.52625 8.42434 9.38818V9.28271C8.42434 8.56543 8.69729 8.35596 9.43361 7.79736C10.043 7.33398 10.6778 6.81982 10.6778 5.74072C10.6778 4.22998 9.40188 3.5 8.00539 3.5C6.73831 3.5 5.34964 4.09061 5.25511 5.78615ZM6.81203 11.5488C6.81203 12.082 7.23732 12.4756 7.82131 12.4756C8.43068 12.4756 8.84963 12.082 8.84963 11.5488C8.84963 10.9966 8.43068 10.6094 7.82131 10.6094C7.23732 10.6094 6.81203 10.9966 6.81203 11.5488Z" })]
	});
};
oa.category = "Alerts, Warnings, and Signs";
var sa = "16px", ca = ({ className: e, width: t = sa, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M11.4602 0.146447C11.3664 0.0526784 11.2392 0 11.1066 0H4.8934C4.76079 0 4.63361 0.0526784 4.53984 0.146447L0.146447 4.53984C0.0526784 4.63361 0 4.76079 0 4.8934V11.1066C0 11.2392 0.0526784 11.3664 0.146447 11.4602L4.53984 15.8536C4.63361 15.9473 4.76079 16 4.8934 16H11.1066C11.2392 16 11.3664 15.9473 11.4602 15.8536L15.8536 11.4602C15.9473 11.3664 16 11.2392 16 11.1066V4.8934C16 4.76079 15.9473 4.63361 15.8536 4.53984L11.4602 0.146447ZM5.49634 6.03271C5.3599 6.03271 5.24752 5.92237 5.25511 5.78615C5.34964 4.09061 6.73831 3.5 8.00539 3.5C9.40188 3.5 10.6778 4.22998 10.6778 5.74072C10.6778 6.81982 10.043 7.33398 9.43361 7.79736C8.69729 8.35596 8.42434 8.56543 8.42434 9.28271V9.38818C8.42434 9.52625 8.31241 9.63818 8.17434 9.63818H7.36332C7.22658 9.63818 7.11521 9.52833 7.11334 9.39161L7.11037 9.1748C7.07229 8.24805 7.60549 7.67676 8.27834 7.18799C8.86867 6.74365 9.24318 6.45166 9.24318 5.81689C9.24318 4.9917 8.61477 4.64893 7.92922 4.64893C7.1265 4.64893 6.67618 5.12718 6.58723 5.78331C6.56868 5.92013 6.45889 6.03271 6.32082 6.03271H5.49634ZM7.82131 12.4756C7.23732 12.4756 6.81203 12.082 6.81203 11.5488C6.81203 10.9966 7.23732 10.6094 7.82131 10.6094C8.43068 10.6094 8.84963 10.9966 8.84963 11.5488C8.84963 12.082 8.43068 12.4756 7.82131 12.4756Z" })
	});
};
ca.category = "Alerts, Warnings, and Signs";
var la = "16px", ua = ({ className: e, width: t = la, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M6.95059 0.434678C7.53017 -0.144894 8.46984 -0.144892 9.04941 0.434679L15.5653 6.95059C16.1449 7.53017 16.1449 8.46984 15.5653 9.04941L9.04941 15.5653C8.46983 16.1449 7.53016 16.1449 6.95059 15.5653L0.434678 9.04941C-0.144894 8.46983 -0.144892 7.53016 0.434679 6.95059L6.95059 0.434678ZM8.3498 1.13428C8.15661 0.941093 7.84339 0.941093 7.6502 1.13428L1.13428 7.6502C0.941093 7.84339 0.941093 8.15661 1.13428 8.3498L7.6502 14.8657C7.84339 15.0589 8.15661 15.0589 8.3498 14.8657L14.8657 8.3498C15.0589 8.15661 15.0589 7.84339 14.8657 7.6502L8.3498 1.13428Z" }), S("path", { d: "M5.25511 5.78615C5.24752 5.92237 5.3599 6.03271 5.49634 6.03271H6.32082C6.45889 6.03271 6.56868 5.92013 6.58723 5.78331C6.67618 5.12718 7.1265 4.64893 7.92922 4.64893C8.61477 4.64893 9.24318 4.9917 9.24318 5.81689C9.24318 6.45166 8.86867 6.74365 8.27834 7.18799C7.60549 7.67676 7.07229 8.24805 7.11037 9.1748L7.11334 9.39161C7.11521 9.52833 7.22658 9.63818 7.36332 9.63818H8.17434C8.31241 9.63818 8.42434 9.52625 8.42434 9.38818V9.28271C8.42434 8.56543 8.69729 8.35596 9.43361 7.79736C10.043 7.33398 10.6778 6.81982 10.6778 5.74072C10.6778 4.22998 9.40188 3.5 8.00539 3.5C6.73831 3.5 5.34964 4.09061 5.25511 5.78615ZM6.81203 11.5488C6.81203 12.082 7.23733 12.4756 7.82131 12.4756C8.43069 12.4756 8.84963 12.082 8.84963 11.5488C8.84963 10.9966 8.43069 10.6094 7.82131 10.6094C7.23733 10.6094 6.81203 10.9966 6.81203 11.5488Z" })]
	});
};
ua.category = "Alerts, Warnings, and Signs";
var da = "16px", fa = ({ className: e, width: t = da, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M9.04941 0.434679C8.46984 -0.144892 7.53017 -0.144894 6.95059 0.434678L0.434679 6.95059C-0.144892 7.53016 -0.144894 8.46983 0.434678 9.04941L6.95059 15.5653C7.53016 16.1449 8.46983 16.1449 9.04941 15.5653L15.5653 9.04941C16.1449 8.46984 16.1449 7.53017 15.5653 6.95059L9.04941 0.434679ZM5.49634 6.03268C5.3599 6.03268 5.24752 5.92234 5.25511 5.78612C5.34964 4.09058 6.73831 3.49997 8.00539 3.49997C9.40188 3.49997 10.6778 4.22995 10.6778 5.74069C10.6778 6.81979 10.043 7.33395 9.43361 7.79733C8.69729 8.35593 8.42434 8.5654 8.42434 9.28268V9.38815C8.42434 9.52622 8.31241 9.63815 8.17434 9.63815H7.36332C7.22658 9.63815 7.11521 9.5283 7.11334 9.39158L7.11037 9.17477C7.07229 8.24802 7.60549 7.67673 8.27834 7.18796C8.86867 6.74362 9.24318 6.45163 9.24318 5.81686C9.24318 4.99167 8.61477 4.6489 7.92922 4.6489C7.1265 4.6489 6.67618 5.12715 6.58723 5.78328C6.56868 5.9201 6.45889 6.03268 6.32082 6.03268H5.49634ZM7.82131 12.4756C7.23732 12.4756 6.81203 12.082 6.81203 11.5488C6.81203 10.9966 7.23732 10.6093 7.82131 10.6093C8.43068 10.6093 8.84963 10.9966 8.84963 11.5488C8.84963 12.082 8.43068 12.4756 7.82131 12.4756Z" })
	});
};
fa.category = "Alerts, Warnings, and Signs";
var pa = "16px", ma = ({ className: e, width: t = pa, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M7.00146 11C7.00146 10.4477 7.44918 10 8.00146 10C8.55375 10 9.00146 10.4477 9.00146 11C9.00146 11.5523 8.55375 12 8.00146 12C7.44918 12 7.00146 11.5523 7.00146 11Z" }), S("path", { d: "M7.09943 4.99504C7.04615 4.46228 7.46451 4 7.99992 4C8.53533 4 8.9537 4.46228 8.90042 4.99504L8.54968 8.50248C8.52143 8.78492 8.28377 9 7.99992 9C7.71608 9 7.47842 8.78492 7.45017 8.50248L7.09943 4.99504Z" })]
	});
};
ma.category = "Alerts, Warnings, and Signs";
var ha = "16px", ga = ({ className: e, width: t = ha, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M7.00506 3.0994C6.9462 2.51077 7.40844 2 8 2C8.59156 2 9.0538 2.51077 8.99494 3.0994L8.60741 9.4503C8.5762 9.76236 8.31361 10 8 10C7.68639 10 7.4238 9.76236 7.39259 9.4503L7.00506 3.0994Z" }), S("path", { d: "M7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12Z" })]
	});
};
ga.category = "Alerts, Warnings, and Signs";
var _a = "16px", va = ({ className: e, width: t = _a, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" }),
			S("path", { d: "M7.00154 11C7.00154 10.4477 7.44926 10 8.00154 10C8.55383 10 9.00154 10.4477 9.00154 11C9.00154 11.5523 8.55383 12 8.00154 12C7.44926 12 7.00154 11.5523 7.00154 11Z" }),
			S("path", { d: "M7.0995 4.99504C7.04623 4.46228 7.46459 4 8 4C8.53541 4 8.95377 4.46228 8.9005 4.99504L8.54975 8.50248C8.52151 8.78492 8.28384 9 8 9C7.71616 9 7.47849 8.78492 7.45025 8.50248L7.0995 4.99504Z" })
		]
	});
};
va.category = "Alerts, Warnings, and Signs";
var ya = "16px", ba = ({ className: e, width: t = ya, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8 4C7.46459 4 7.04623 4.46229 7.0995 4.99504L7.45025 8.50248C7.47849 8.78492 7.71616 9 8 9C8.28384 9 8.52151 8.78492 8.54975 8.50248L8.9005 4.99504C8.95377 4.46228 8.53541 4 8 4ZM8.00154 10C7.44926 10 7.00154 10.4477 7.00154 11C7.00154 11.5523 7.44926 12 8.00154 12C8.55383 12 9.00154 11.5523 9.00154 11C9.00154 10.4477 8.55383 10 8.00154 10Z" })
	});
};
ba.category = "Alerts, Warnings, and Signs";
var xa = "16px", Sa = ({ className: e, width: t = xa, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M14 1C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V2C1 1.44772 1.44772 1 2 1H14ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2Z" }),
			S("path", { d: "M7.00154 11C7.00154 10.4477 7.44926 10 8.00154 10C8.55383 10 9.00154 10.4477 9.00154 11C9.00154 11.5523 8.55383 12 8.00154 12C7.44926 12 7.00154 11.5523 7.00154 11Z" }),
			S("path", { d: "M7.0995 4.99504C7.04623 4.46228 7.46459 4 8 4C8.53541 4 8.95377 4.46228 8.9005 4.99504L8.54975 8.50248C8.52151 8.78492 8.28384 9 8 9C7.71616 9 7.47849 8.78492 7.45025 8.50248L7.0995 4.99504Z" })
		]
	});
};
Sa.category = "Alerts, Warnings, and Signs";
var Ca = "16px", wa = ({ className: e, width: t = Ca, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM8 4C8.53541 4 8.95377 4.46228 8.9005 4.99504L8.54975 8.50248C8.52151 8.78492 8.28384 9 8 9C7.71616 9 7.47849 8.78492 7.45025 8.50248L7.0995 4.99504C7.04623 4.46229 7.46459 4 8 4ZM8.00154 10C8.55383 10 9.00154 10.4477 9.00154 11C9.00154 11.5523 8.55383 12 8.00154 12C7.44926 12 7.00154 11.5523 7.00154 11C7.00154 10.4477 7.44926 10 8.00154 10Z" })
	});
};
wa.category = "Alerts, Warnings, and Signs";
var Ta = "16px", Ea = ({ className: e, width: t = Ta, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M4.53984 0.146447C4.63361 0.0526784 4.76079 0 4.8934 0H11.1066C11.2392 0 11.3664 0.0526784 11.4602 0.146447L15.8536 4.53984C15.9473 4.63361 16 4.76079 16 4.8934V11.1066C16 11.2392 15.9473 11.3664 15.8536 11.4602L11.4602 15.8536C11.3664 15.9473 11.2392 16 11.1066 16H4.8934C4.76079 16 4.63361 15.9473 4.53984 15.8536L0.146447 11.4602C0.0526784 11.3664 0 11.2392 0 11.1066V4.8934C0 4.76079 0.0526784 4.63361 0.146447 4.53984L4.53984 0.146447ZM5.1005 1L1 5.1005V10.8995L5.10051 15H10.8995L15 10.8995V5.10051L10.8995 1H5.1005Z" }),
			S("path", { d: "M7.00154 11C7.00154 10.4477 7.44926 10 8.00154 10C8.55383 10 9.00154 10.4477 9.00154 11C9.00154 11.5523 8.55383 12 8.00154 12C7.44926 12 7.00154 11.5523 7.00154 11Z" }),
			S("path", { d: "M7.0995 4.99504C7.04623 4.46228 7.46459 4 8 4C8.53541 4 8.95377 4.46228 8.9005 4.99504L8.54975 8.50248C8.52151 8.78492 8.28384 9 8 9C7.71616 9 7.47849 8.78492 7.45025 8.50248L7.0995 4.99504Z" })
		]
	});
};
Ea.category = "Alerts, Warnings, and Signs";
var Da = "16px", Oa = ({ className: e, width: t = Da, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M11.4602 0.146447C11.3664 0.0526784 11.2392 0 11.1066 0H4.8934C4.76079 0 4.63361 0.0526784 4.53984 0.146447L0.146447 4.53984C0.0526784 4.63361 0 4.76079 0 4.8934V11.1066C0 11.2392 0.0526784 11.3664 0.146447 11.4602L4.53984 15.8536C4.63361 15.9473 4.76079 16 4.8934 16H11.1066C11.2392 16 11.3664 15.9473 11.4602 15.8536L15.8536 11.4602C15.9473 11.3664 16 11.2392 16 11.1066V4.8934C16 4.76079 15.9473 4.63361 15.8536 4.53984L11.4602 0.146447ZM8 4C8.53541 4 8.95377 4.46228 8.9005 4.99504L8.54975 8.50248C8.52151 8.78492 8.28384 9 8 9C7.71616 9 7.47849 8.78492 7.45025 8.50248L7.0995 4.99504C7.04623 4.46229 7.46459 4 8 4ZM8.00154 10C8.55383 10 9.00154 10.4477 9.00154 11C9.00154 11.5523 8.55383 12 8.00154 12C7.44926 12 7.00154 11.5523 7.00154 11C7.00154 10.4477 7.44926 10 8.00154 10Z" })
	});
};
Oa.category = "Alerts, Warnings, and Signs";
var ka = "16px", Aa = ({ className: e, width: t = ka, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M6.95059 0.434678C7.53017 -0.144894 8.46984 -0.144892 9.04941 0.434679L15.5653 6.95059C16.1449 7.53017 16.1449 8.46984 15.5653 9.04941L9.04941 15.5653C8.46983 16.1449 7.53016 16.1449 6.95059 15.5653L0.434678 9.04941C-0.144894 8.46983 -0.144892 7.53016 0.434679 6.95059L6.95059 0.434678ZM8.3498 1.13428C8.15661 0.941093 7.84339 0.941093 7.6502 1.13428L1.13428 7.6502C0.941093 7.84339 0.941093 8.15661 1.13428 8.3498L7.6502 14.8657C7.84339 15.0589 8.15661 15.0589 8.3498 14.8657L14.8657 8.3498C15.0589 8.15661 15.0589 7.84339 14.8657 7.6502L8.3498 1.13428Z" }),
			S("path", { d: "M7.00154 11C7.00154 10.4477 7.44926 10 8.00154 10C8.55383 10 9.00154 10.4477 9.00154 11C9.00154 11.5523 8.55383 12 8.00154 12C7.44926 12 7.00154 11.5523 7.00154 11Z" }),
			S("path", { d: "M7.0995 4.99504C7.04623 4.46228 7.46459 4 8 4C8.53541 4 8.95377 4.46228 8.9005 4.99504L8.54975 8.50248C8.52151 8.78492 8.28384 9 8 9C7.71616 9 7.47849 8.78492 7.45025 8.50248L7.0995 4.99504Z" })
		]
	});
};
Aa.category = "Alerts, Warnings, and Signs";
var ja = "16px", Ma = ({ className: e, width: t = ja, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M9.04941 0.434679C8.46984 -0.144892 7.53017 -0.144894 6.95059 0.434678L0.434679 6.95059C-0.144892 7.53016 -0.144894 8.46983 0.434678 9.04941L6.95059 15.5653C7.53016 16.1449 8.46983 16.1449 9.04941 15.5653L15.5653 9.04941C16.1449 8.46984 16.1449 7.53017 15.5653 6.95059L9.04941 0.434679ZM8 3.99997C8.53541 3.99997 8.95377 4.46225 8.9005 4.99501L8.54975 8.50245C8.52151 8.78489 8.28384 8.99997 8 8.99997C7.71616 8.99997 7.47849 8.78489 7.45025 8.50245L7.0995 4.99501C7.04623 4.46225 7.46459 3.99997 8 3.99997ZM8.00154 9.99997C8.55383 9.99997 9.00154 10.4477 9.00154 11C9.00154 11.5523 8.55383 12 8.00154 12C7.44926 12 7.00154 11.5523 7.00154 11C7.00154 10.4477 7.44926 9.99997 8.00154 9.99997Z" })
	});
};
Ma.category = "Alerts, Warnings, and Signs";
var Na = "16px", Pa = ({ className: e, width: t = Na, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M7.93842 2.0157C7.95578 2.00605 7.97748 2 8.00154 2C8.02561 2 8.04731 2.00605 8.06467 2.0157C8.07966 2.02403 8.09948 2.03926 8.11939 2.07312L14.9763 13.7398C15.012 13.8005 15.0113 13.864 14.9785 13.9231C14.962 13.9528 14.9415 13.9724 14.9238 13.9833C14.909 13.9925 14.8901 14 14.8585 14H1.14459C1.11303 14 1.09404 13.9925 1.07932 13.9833C1.06163 13.9724 1.04106 13.9528 1.02461 13.9231C0.991803 13.864 0.991085 13.8005 1.02675 13.7398L7.8837 2.07312C7.9036 2.03926 7.92343 2.02403 7.93842 2.0157ZM8.98151 1.56642C8.53763 0.811193 7.46546 0.811193 7.02158 1.56642L0.164626 13.2331C-0.292407 14.0107 0.256279 15 1.14459 15H14.8585C15.7468 15 16.2955 14.0107 15.8385 13.2331L8.98151 1.56642Z" }),
			S("path", { d: "M7.00154 12C7.00154 11.4477 7.44926 11 8.00154 11C8.55383 11 9.00154 11.4477 9.00154 12C9.00154 12.5523 8.55383 13 8.00154 13C7.44926 13 7.00154 12.5523 7.00154 12Z" }),
			S("path", { d: "M7.0995 5.99504C7.04623 5.46228 7.46459 5 8 5C8.53541 5 8.95377 5.46228 8.9005 5.99504L8.54975 9.50248C8.52151 9.78492 8.28384 10 8 10C7.71616 10 7.47849 9.78492 7.45025 9.50248L7.0995 5.99504Z" })
		]
	});
};
Pa.category = "Alerts, Warnings, and Signs";
var Fa = "16px", Ia = ({ className: e, width: t = Fa, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M8.98151 1.56642C8.53763 0.811193 7.46546 0.811193 7.02158 1.56642L0.164626 13.2331C-0.292407 14.0107 0.256279 15 1.14459 15H14.8585C15.7468 15 16.2955 14.0107 15.8385 13.2331L8.98151 1.56642ZM8 5C8.53541 5 8.95377 5.46228 8.9005 5.99504L8.54975 9.50248C8.52151 9.78492 8.28384 10 8 10C7.71616 10 7.47849 9.78492 7.45025 9.50248L7.0995 5.99504C7.04623 5.46229 7.46459 5 8 5ZM8.00154 11C8.55383 11 9.00154 11.4477 9.00154 12C9.00154 12.5523 8.55383 13 8.00154 13C7.44926 13 7.00154 12.5523 7.00154 12C7.00154 11.4477 7.44926 11 8.00154 11Z" })
	});
};
Ia.category = "Alerts, Warnings, and Signs";
var La = (e) => S(G, Object.assign({}, e, { paths: "M12.7365 3.96967C13.0255 3.67678 13.4942 3.67678 13.7832 3.96967C14.0687 4.25897 14.0722 4.72582 13.7937 5.01947L7.88025 12.0097C7.87456 12.0169 7.86848 12.0238 7.86205 12.0303C7.573 12.3232 7.10437 12.3232 6.81532 12.0303L3.21678 8.38388C2.92774 8.09099 2.92774 7.61612 3.21678 7.32322C3.50583 7.03033 3.97446 7.03033 4.26351 7.32322L7.31638 10.4167L12.7169 3.9921C12.723 3.98424 12.7295 3.97674 12.7365 3.96967Z" }));
La.category = "Alerts, Warnings, and Signs";
var Ra = (e) => S(G, Object.assign({}, e, { paths: ["M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z", "M10.9697 4.96967C10.9626 4.97674 10.9559 4.98423 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967Z"] }));
Ra.category = "Alerts, Warnings, and Signs";
var za = (e) => S(G, Object.assign({}, e, { paths: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z" }));
za.category = "Alerts, Warnings, and Signs";
var Ba = (e) => C(G, Object.assign({}, e, { children: [S("path", { d: "M14 1C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V2C1 1.44772 1.44772 1 2 1H14ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2Z" }), S("path", { d: "M10.9697 4.96967C11.2626 4.67678 11.7374 4.67678 12.0303 4.96967C12.3196 5.25897 12.3232 5.72582 12.041 6.01947L8.04876 11.0097C8.043 11.0169 8.03685 11.0238 8.03032 11.0303C7.73743 11.3232 7.26256 11.3232 6.96966 11.0303L4.32322 8.38388C4.03032 8.09099 4.03032 7.61612 4.32322 7.32322C4.61611 7.03033 5.09098 7.03033 5.38388 7.32322L7.4774 9.41674L10.9498 4.9921C10.9559 4.98423 10.9626 4.97674 10.9697 4.96967Z" })] }));
Ba.category = "Alerts, Warnings, and Signs";
var Va = "16px", Ha = ({ className: e, width: t = Va, height: n, color: r }) => S("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	className: e,
	fill: r ?? "#FFFFFF",
	viewBox: "0 0 16 16",
	style: {
		width: typeof t == "number" ? `${t}px` : t,
		height: typeof n == "number" ? `${n}px` : n ?? "auto"
	},
	children: S("path", {
		d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM12.0303 4.96967C12.3196 5.25897 12.3232 5.72582 12.041 6.01947L8.04876 11.0097C8.043 11.0169 8.03685 11.0238 8.03032 11.0303C7.73743 11.3232 7.26256 11.3232 6.96966 11.0303L4.32322 8.38388C4.03032 8.09099 4.03032 7.61612 4.32322 7.32322C4.61611 7.03033 5.09098 7.03033 5.38388 7.32322L7.4774 9.41674L10.9498 4.9921C10.9559 4.98424 10.9626 4.97674 10.9697 4.96967C11.2626 4.67678 11.7374 4.67678 12.0303 4.96967Z",
		fill: "black"
	})
});
Ha.category = "Alerts, Warnings, and Signs";
var Ua = "16px", Wa = ({ className: e, width: t = Ua, height: n, color: r }) => C("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	className: e,
	fill: r ?? "#FFFFFF",
	viewBox: "0 0 16 16",
	style: {
		width: typeof t == "number" ? `${t}px` : t,
		height: typeof n == "number" ? `${n}px` : n ?? "auto"
	},
	children: [S("path", {
		d: "M8.96963 4.96967C9.26253 4.67678 9.7374 4.67678 10.0303 4.96967C10.3196 5.25897 10.3231 5.72582 10.0409 6.01947L6.04873 11.0097C6.04297 11.0169 6.03682 11.0238 6.03029 11.0303C5.7374 11.3232 5.26253 11.3232 4.96963 11.0303L2.32319 8.38388C2.03029 8.09099 2.03029 7.61612 2.32319 7.32322C2.61608 7.03033 3.09095 7.03033 3.38385 7.32322L5.47737 9.41674L8.94974 4.9921C8.95592 4.98424 8.96256 4.97674 8.96963 4.96967Z",
		fill: "black"
	}), S("path", {
		d: "M8.04921 10.1099L8.96963 11.0303C9.26253 11.3232 9.7374 11.3232 10.0303 11.0303C10.0368 11.0238 10.043 11.0169 10.0487 11.0097L14.0409 6.01947C14.3231 5.72582 14.3196 5.25897 14.0303 4.96967C13.7374 4.67678 13.2625 4.67678 12.9696 4.96967C12.9626 4.97674 12.9559 4.98424 12.9497 4.9921L9.47737 9.41674L8.99202 8.9314L8.04921 10.1099Z",
		fill: "black"
	})]
});
Wa.category = "UI and Keyboard";
var Ga = "16px", Ka = ({ className: e, width: t = Ga, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 1C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2C15 1.44772 14.5523 1 14 1H9.5C8.94771 1 8.5 1.44772 8.5 2V9.29289L11.1464 6.64645C11.3417 6.45118 11.6583 6.45118 11.8536 6.64645C12.0488 6.84171 12.0488 7.15829 11.8536 7.35355L8.35355 10.8536C8.15829 11.0488 7.84171 11.0488 7.64645 10.8536L4.14645 7.35355C3.95118 7.15829 3.95118 6.84171 4.14645 6.64645C4.34171 6.45118 4.65829 6.45118 4.85355 6.64645L7.5 9.29289V2C7.5 0.895431 8.39543 0 9.5 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.89543 16 0 15.1046 0 14V2C0 0.895431 0.895431 0 2 0H4.5C4.77614 0 5 0.223858 5 0.5C5 0.776142 4.77614 1 4.5 1H2Z" })
	});
};
Ka.category = "UI and Keyboard";
var qa = "16px", Ja = ({ className: e, width: t = qa, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M2 1C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2C15 1.44772 14.5523 1 14 1H9.5C8.94771 1 8.5 1.44772 8.5 2V6.5H10.5C10.7022 6.5 10.8845 6.62182 10.9619 6.80866C11.0393 6.9955 10.9966 7.21055 10.8536 7.35355L8.35355 9.85355C8.15829 10.0488 7.84171 10.0488 7.64645 9.85355L5.14645 7.35355C5.00345 7.21055 4.96067 6.9955 5.03806 6.80866C5.11545 6.62182 5.29777 6.5 5.5 6.5H7.5V2C7.5 0.895431 8.39543 0 9.5 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.89543 16 0 15.1046 0 14V2C0 0.895431 0.895431 0 2 0H4.5C4.77614 0 5 0.223858 5 0.5C5 0.776142 4.77614 1 4.5 1H2Z" })
	});
};
Ja.category = "UI and Keyboard";
var Ya = "16px", Xa = ({ className: e, width: t = Ya, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M7.27043 2.04702C7.6655 1.62561 8.33443 1.6256 8.7295 2.04702L15.0754 8.81596C15.6741 9.45462 15.2213 10.4999 14.3459 10.4999H11.5V13.4999C11.5 14.0522 11.0523 14.4999 10.5 14.4999H5.49997C4.94768 14.4999 4.49997 14.0522 4.49997 13.4999V10.4999H1.65408C0.778643 10.4999 0.325796 9.45462 0.924545 8.81596L7.27043 2.04702ZM14.3458 9.4999L7.99997 2.73096L1.65408 9.4999H4.49997C5.05225 9.4999 5.49997 9.94761 5.49997 10.4999V13.4999H10.5V10.4999C10.5 9.94761 10.9477 9.4999 11.5 9.4999L14.3458 9.4999Z" })
	});
};
Xa.category = "UI and Keyboard";
var Za = "16px", Qa = ({ className: e, width: t = Za, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M7.27043 1.04702C7.6655 0.625605 8.33443 0.625603 8.7295 1.04702L15.0754 7.81596C15.6741 8.45462 15.2213 9.4999 14.3459 9.4999H11.5V10.4999C11.5 11.0522 11.0523 11.4999 10.5 11.4999H5.49997C4.94768 11.4999 4.49997 11.0522 4.49997 10.4999V9.4999H1.65408C0.778643 9.4999 0.325796 8.45462 0.924545 7.81596L7.27043 1.04702ZM14.3458 8.4999L7.99997 1.73096L1.65408 8.4999H4.49997C5.05225 8.4999 5.49997 8.94761 5.49997 9.4999V10.4999H10.5V9.4999C10.5 8.94761 10.9477 8.4999 11.5 8.4999L14.3458 8.4999Z" }), S("path", { d: "M4.5 13.5C4.5 12.9477 4.94772 12.5 5.5 12.5H10.5C11.0523 12.5 11.5 12.9477 11.5 13.5V14.5C11.5 15.0523 11.0523 15.5 10.5 15.5H5.5C4.94771 15.5 4.5 15.0523 4.5 14.5V13.5ZM10.5 13.5H5.5V14.5H10.5V13.5Z" })]
	});
};
Qa.category = "UI and Keyboard";
var $a = "16px", eo = ({ className: e, width: t = $a, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M7.27046 1.04702C7.66553 0.625605 8.33446 0.625603 8.72954 1.04702L15.0754 7.81596C15.6742 8.45462 15.2213 9.4999 14.3459 9.4999H1.65412C0.778676 9.4999 0.32583 8.45462 0.924579 7.81596L7.27046 1.04702ZM14.3459 8.4999L8 1.73096L1.65412 8.4999L14.3459 8.4999Z" }), S("path", { d: "M0.5 11.4999C0.5 10.9476 0.947715 10.4999 1.5 10.4999H14.5C15.0523 10.4999 15.5 10.9476 15.5 11.4999V12.4999C15.5 13.0522 15.0523 13.4999 14.5 13.4999H1.5C0.947715 13.4999 0.5 13.0522 0.5 12.4999V11.4999ZM14.5 11.4999H1.5V12.4999H14.5V11.4999Z" })]
	});
};
eo.category = "UI and Keyboard";
var to = "16px", no = ({ className: e, width: t = to, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M5.82937 5.14645C5.63411 5.34171 5.63411 5.65829 5.82937 5.85355L7.97582 8L5.82937 10.1464C5.63411 10.3417 5.63411 10.6583 5.82937 10.8536C6.02463 11.0488 6.34121 11.0488 6.53648 10.8536L8.68292 8.70711L10.8294 10.8536C11.0246 11.0488 11.3412 11.0488 11.5365 10.8536C11.7317 10.6583 11.7317 10.3417 11.5365 10.1464L9.39003 8L11.5365 5.85355C11.7317 5.65829 11.7317 5.34171 11.5365 5.14645C11.3412 4.95118 11.0246 4.95118 10.8294 5.14645L8.68292 7.29289L6.53648 5.14645C6.34121 4.95118 6.02463 4.95118 5.82937 5.14645Z" }), S("path", { d: "M13.6829 1C14.7875 1 15.6829 1.89543 15.6829 3V13C15.6829 14.1046 14.7875 15 13.6829 15H6.60279C6.01894 15 5.46424 14.7449 5.08428 14.3016L0.240744 8.65079C-0.0802479 8.2763 -0.0802479 7.7237 0.240744 7.34921L5.08428 1.69842C5.46424 1.25513 6.01894 1 6.60279 1H13.6829ZM6.60279 2C6.31087 2 6.03352 2.12756 5.84354 2.34921L1 8L5.84354 13.6508C6.03352 13.8724 6.31087 14 6.60279 14H13.6829C14.2352 14 14.6829 13.5523 14.6829 13V3C14.6829 2.44772 14.2352 2 13.6829 2H6.60279Z" })]
	});
};
no.category = "UI and Keyboard";
var ro = "16px", io = ({ className: e, width: t = ro, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M9.85355 5.14645C10.0488 5.34171 10.0488 5.65829 9.85355 5.85355L7.70711 8L9.85355 10.1464C10.0488 10.3417 10.0488 10.6583 9.85355 10.8536C9.65829 11.0488 9.34171 11.0488 9.14645 10.8536L7 8.70711L4.85355 10.8536C4.65829 11.0488 4.34171 11.0488 4.14645 10.8536C3.95118 10.6583 3.95118 10.3417 4.14645 10.1464L6.29289 8L4.14645 5.85355C3.95118 5.65829 3.95118 5.34171 4.14645 5.14645C4.34171 4.95118 4.65829 4.95118 4.85355 5.14645L7 7.29289L9.14645 5.14645C9.34171 4.95118 9.65829 4.95118 9.85355 5.14645Z" }), S("path", { d: "M2 1C0.895431 1 0 1.89543 0 3V13C0 14.1046 0.89543 15 2 15H9.08013C9.66398 15 10.2187 14.7449 10.5986 14.3016L15.4422 8.65079C15.7632 8.2763 15.7632 7.7237 15.4422 7.34921L10.5986 1.69842C10.2187 1.25513 9.66398 1 9.08013 1H2ZM9.08013 2C9.37206 2 9.6494 2.12756 9.83939 2.34921L14.6829 8L9.83939 13.6508C9.6494 13.8724 9.37206 14 9.08013 14H2C1.44772 14 1 13.5523 1 13V3C1 2.44772 1.44772 2 2 2H9.08013Z" })]
	});
};
io.category = "UI and Keyboard";
var ao = "16px", oo = ({ className: e, width: t = ao, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M8.5 1.5C8.5 0.671573 9.17157 0 10 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2C0 0.895431 0.895431 0 2 0H7.99982C7.68597 0.41783 7.5 0.937197 7.5 1.5V9.29289L4.85355 6.64645C4.65829 6.45118 4.34171 6.45118 4.14645 6.64645C3.95118 6.84171 3.95118 7.15829 4.14645 7.35355L7.64645 10.8536C7.84171 11.0488 8.15829 11.0488 8.35355 10.8536L11.8536 7.35355C12.0488 7.15829 12.0488 6.84171 11.8536 6.64645C11.6583 6.45118 11.3417 6.45118 11.1464 6.64645L8.5 9.29289V1.5Z" })
	});
};
oo.category = "UI and Keyboard";
var so = "16px", co = ({ className: e, width: t = so, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M8.5 1.5C8.5 0.671573 9.17157 0 10 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2C0 0.895431 0.895431 0 2 0H7.99982C7.68597 0.41783 7.5 0.937197 7.5 1.5V7.5H5.5C5.29777 7.5 5.11545 7.62182 5.03806 7.80866C4.96067 7.9955 5.00345 8.21055 5.14645 8.35355L7.64645 10.8536C7.84171 11.0488 8.15829 11.0488 8.35355 10.8536L10.8536 8.35355C10.9966 8.21055 11.0393 7.9955 10.9619 7.80866C10.8845 7.62182 10.7022 7.5 10.5 7.5H8.5V1.5Z" })
	});
};
co.category = "UI and Keyboard";
var lo = "16px", uo = ({ className: e, width: t = lo, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M7.27043 2.04702C7.6655 1.62561 8.33443 1.6256 8.7295 2.04702L15.0754 8.81596C15.6741 9.45462 15.2213 10.4999 14.3459 10.4999H11.5V13.4999C11.5 14.0522 11.0523 14.4999 10.5 14.4999H5.49997C4.94768 14.4999 4.49997 14.0522 4.49997 13.4999V10.4999H1.65408C0.778643 10.4999 0.325796 9.45462 0.924545 8.81596L7.27043 2.04702Z" })
	});
};
uo.category = "UI and Keyboard";
var fo = "16px", po = ({ className: e, width: t = fo, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M7.27043 1.04702C7.6655 0.625605 8.33443 0.625603 8.7295 1.04702L15.0754 7.81596C15.6741 8.45462 15.2213 9.4999 14.3459 9.4999H11.5V10.4999C11.5 11.0522 11.0523 11.4999 10.5 11.4999H5.49997C4.94768 11.4999 4.49997 11.0522 4.49997 10.4999V9.4999H1.65408C0.778643 9.4999 0.325796 8.45462 0.924545 7.81596L7.27043 1.04702Z" }), S("path", { d: "M4.49997 13.4999C4.49997 12.9476 4.94768 12.4999 5.49997 12.4999H10.5C11.0523 12.4999 11.5 12.9476 11.5 13.4999V14.4999C11.5 15.0522 11.0523 15.4999 10.5 15.4999H5.49997C4.94768 15.4999 4.49997 15.0522 4.49997 14.4999V13.4999Z" })]
	});
};
po.category = "UI and Keyboard";
var mo = "16px", ho = ({ className: e, width: t = mo, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M7.27046 1.04702C7.66553 0.625605 8.33446 0.625603 8.72954 1.04702L15.0754 7.81596C15.6742 8.45462 15.2213 9.4999 14.3459 9.4999H1.65412C0.778676 9.4999 0.32583 8.45462 0.924579 7.81596L7.27046 1.04702Z" }), S("path", { d: "M0.5 11.4999C0.5 10.9476 0.947715 10.4999 1.5 10.4999H14.5C15.0523 10.4999 15.5 10.9476 15.5 11.4999V12.4999C15.5 13.0522 15.0523 13.4999 14.5 13.4999H1.5C0.947715 13.4999 0.5 13.0522 0.5 12.4999V11.4999Z" })]
	});
};
ho.category = "UI and Keyboard";
var go = "16px", _o = ({ className: e, width: t = go, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M15.6829 3C15.6829 1.89543 14.7875 1 13.6829 1H6.60279C6.01894 1 5.46424 1.25513 5.08428 1.69842L0.240744 7.34921C-0.0802479 7.7237 -0.0802479 8.2763 0.240744 8.65079L5.08428 14.3016C5.46424 14.7449 6.01894 15 6.60279 15H13.6829C14.7875 15 15.6829 14.1046 15.6829 13V3ZM5.82937 5.85355C5.63411 5.65829 5.63411 5.34171 5.82937 5.14645C6.02463 4.95118 6.34121 4.95118 6.53648 5.14645L8.68292 7.29289L10.8294 5.14645C11.0246 4.95118 11.3412 4.95118 11.5365 5.14645C11.7317 5.34171 11.7317 5.65829 11.5365 5.85355L9.39003 8L11.5365 10.1464C11.7317 10.3417 11.7317 10.6583 11.5365 10.8536C11.3412 11.0488 11.0246 11.0488 10.8294 10.8536L8.68292 8.70711L6.53648 10.8536C6.34121 11.0488 6.02463 11.0488 5.82937 10.8536C5.63411 10.6583 5.63411 10.3417 5.82937 10.1464L7.97582 8L5.82937 5.85355Z" })
	});
};
_o.category = "UI and Keyboard";
var vo = "16px", yo = ({ className: e, width: t = vo, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M0 3C0 1.89543 0.895431 1 2 1H9.08013C9.66398 1 10.2187 1.25513 10.5986 1.69842L15.4422 7.34921C15.7632 7.7237 15.7632 8.2763 15.4422 8.65079L10.5986 14.3016C10.2187 14.7449 9.66398 15 9.08013 15H2C0.89543 15 0 14.1046 0 13V3ZM9.85355 5.85355C10.0488 5.65829 10.0488 5.34171 9.85355 5.14645C9.65829 4.95118 9.34171 4.95118 9.14645 5.14645L7 7.29289L4.85355 5.14645C4.65829 4.95118 4.34171 4.95118 4.14645 5.14645C3.95118 5.34171 3.95118 5.65829 4.14645 5.85355L6.29289 8L4.14645 10.1464C3.95118 10.3417 3.95118 10.6583 4.14645 10.8536C4.34171 11.0488 4.65829 11.0488 4.85355 10.8536L7 8.70711L9.14645 10.8536C9.34171 11.0488 9.65829 11.0488 9.85355 10.8536C10.0488 10.6583 10.0488 10.3417 9.85355 10.1464L7.70711 8L9.85355 5.85355Z" })
	});
};
yo.category = "UI and Keyboard";
var bo = "16px", xo = ({ className: e, width: t = bo, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M13.8536 3.64645C14.0488 3.84171 14.0488 4.15829 13.8536 4.35355L6.85355 11.3536C6.75979 11.4473 6.63261 11.5 6.5 11.5C6.36739 11.5 6.24021 11.4473 6.14645 11.3536L2.64645 7.85355C2.45118 7.65829 2.45118 7.34171 2.64645 7.14645C2.84171 6.95118 3.15829 6.95118 3.35355 7.14645L6.5 10.2929L13.1464 3.64645C13.3417 3.45118 13.6583 3.45118 13.8536 3.64645Z" })
	});
};
xo.category = "UI and Keyboard";
var So = "16px", Co = ({ className: e, width: t = So, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M12.3536 4.35355C12.5488 4.15829 12.5488 3.84171 12.3536 3.64645C12.1583 3.45118 11.8417 3.45118 11.6464 3.64645L5 10.2929L1.85355 7.14645C1.65829 6.95118 1.34171 6.95118 1.14645 7.14645C0.951184 7.34171 0.951184 7.65829 1.14645 7.85355L4.64645 11.3536C4.74021 11.4473 4.86739 11.5 5 11.5C5.13261 11.5 5.25979 11.4473 5.35355 11.3536L12.3536 4.35355Z" }),
			S("path", { d: "M8.14645 11.3536L7.25 10.4571L7.95711 9.75L8.5 10.2929L15.1464 3.64645C15.3417 3.45118 15.6583 3.45118 15.8536 3.64645C16.0488 3.84171 16.0488 4.15829 15.8536 4.35355L8.85355 11.3536C8.75979 11.4473 8.63261 11.5 8.5 11.5C8.36739 11.5 8.24021 11.4473 8.14645 11.3536Z" }),
			S("path", { d: "M5.35355 7.14645L6.25 8.04289L5.54289 8.75L4.64645 7.85355C4.45118 7.65829 4.45118 7.34171 4.64645 7.14645C4.84171 6.95118 5.15829 6.95118 5.35355 7.14645Z" })
		]
	});
};
Co.category = "UI and Keyboard";
var wo = "16px", To = ({ className: e, width: t = wo, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M2.5 8C2.5 4.96243 4.96243 2.5 8 2.5C9.00262 2.5 9.94117 2.76782 10.7496 3.2355C10.9887 3.37377 11.2945 3.29209 11.4328 3.05306C11.5711 2.81403 11.4894 2.50816 11.2504 2.36989C10.2938 1.81654 9.1831 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 7.72386 14.2761 7.5 14 7.5C13.7239 7.5 13.5 7.72386 13.5 8C13.5 11.0376 11.0376 13.5 8 13.5C4.96243 13.5 2.5 11.0376 2.5 8Z" }), S("path", { d: "M15.3536 3.35355C15.5488 3.15829 15.5488 2.84171 15.3536 2.64645C15.1583 2.45118 14.8417 2.45118 14.6464 2.64645L8 9.29289L5.35355 6.64645C5.15829 6.45118 4.84171 6.45118 4.64645 6.64645C4.45118 6.84171 4.45118 7.15829 4.64645 7.35355L7.64645 10.3536C7.84171 10.5488 8.15829 10.5488 8.35355 10.3536L15.3536 3.35355Z" })]
	});
};
To.category = "UI and Keyboard";
var Eo = "16px", Do = ({ className: e, width: t = Eo, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M3 14.5C2.17157 14.5 1.5 13.8284 1.5 13V3C1.5 2.17157 2.17157 1.5 3 1.5H11C11.2761 1.5 11.5 1.72386 11.5 2C11.5 2.27614 11.2761 2.5 11 2.5H3C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V8C13.5 7.72386 13.7239 7.5 14 7.5C14.2761 7.5 14.5 7.72386 14.5 8V13C14.5 13.8284 13.8284 14.5 13 14.5H3Z" }), S("path", { d: "M8.35355 10.3536L15.3536 3.35355C15.5488 3.15829 15.5488 2.84171 15.3536 2.64645C15.1583 2.45118 14.8417 2.45118 14.6464 2.64645L8 9.29289L5.35355 6.64645C5.15829 6.45118 4.84171 6.45118 4.64645 6.64645C4.45118 6.84171 4.45118 7.15829 4.64645 7.35355L7.64645 10.3536C7.84171 10.5488 8.15829 10.5488 8.35355 10.3536Z" })]
	});
};
Do.category = "UI and Keyboard";
var Oo = "16px", ko = ({ className: e, width: t = Oo, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M8 9.5C8.82843 9.5 9.5 8.82843 9.5 8C9.5 7.17157 8.82843 6.5 8 6.5C7.17157 6.5 6.5 7.17157 6.5 8C6.5 8.82843 7.17157 9.5 8 9.5Z" })
	});
};
ko.category = "UI and Keyboard";
var Ao = "16px", jo = ({ className: e, width: t = Ao, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 24 24",
		children: S("path", { d: "M2.25 1.5C1.83579 1.5 1.5 1.83579 1.5 2.25V8.25C1.5 8.66421 1.16421 9 0.75 9C0.335786 9 0 8.66421 0 8.25V2.25C0 1.00736 1.00736 0 2.25 0H8.25C8.66421 0 9 0.335786 9 0.75C9 1.16421 8.66421 1.5 8.25 1.5H2.25ZM15 0.75C15 0.335786 15.3358 0 15.75 0H21.75C22.9926 0 24 1.00736 24 2.25V8.25C24 8.66421 23.6642 9 23.25 9C22.8358 9 22.5 8.66421 22.5 8.25V2.25C22.5 1.83579 22.1642 1.5 21.75 1.5H15.75C15.3358 1.5 15 1.16421 15 0.75ZM0.75 15C1.16421 15 1.5 15.3358 1.5 15.75V21.75C1.5 22.1642 1.83579 22.5 2.25 22.5H8.25C8.66421 22.5 9 22.8358 9 23.25C9 23.6642 8.66421 24 8.25 24H2.25C1.00736 24 0 22.9926 0 21.75V15.75C0 15.3358 0.335786 15 0.75 15ZM23.25 15C23.6642 15 24 15.3358 24 15.75V21.75C24 22.9926 22.9926 24 21.75 24H15.75C15.3358 24 15 23.6642 15 23.25C15 22.8358 15.3358 22.5 15.75 22.5H21.75C22.1642 22.5 22.5 22.1642 22.5 21.75V15.75C22.5 15.3358 22.8358 15 23.25 15Z" })
	});
};
jo.category = "UI and Keyboard";
var Mo = "16px", No = ({ className: e, width: t = Mo, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 24 24",
		children: S("path", { d: "M8.25 0C8.66421 0 9 0.335786 9 0.75V6.75C9 7.99264 7.99264 9 6.75 9H0.75C0.335786 9 0 8.66421 0 8.25C0 7.83579 0.335786 7.5 0.75 7.5H6.75C7.16421 7.5 7.5 7.16421 7.5 6.75V0.75C7.5 0.335786 7.83579 0 8.25 0ZM15.75 0C16.1642 0 16.5 0.335786 16.5 0.75V6.75C16.5 7.16421 16.8358 7.5 17.25 7.5H23.25C23.6642 7.5 24 7.83579 24 8.25C24 8.66421 23.6642 9 23.25 9H17.25C16.0074 9 15 7.99264 15 6.75V0.75C15 0.335786 15.3358 0 15.75 0ZM0 15.75C0 15.3358 0.335786 15 0.75 15H6.75C7.99264 15 9 16.0074 9 17.25V23.25C9 23.6642 8.66421 24 8.25 24C7.83579 24 7.5 23.6642 7.5 23.25V17.25C7.5 16.8358 7.16421 16.5 6.75 16.5H0.75C0.335786 16.5 0 16.1642 0 15.75ZM15 17.25C15 16.0074 16.0074 15 17.25 15H23.25C23.6642 15 24 15.3358 24 15.75C24 16.1642 23.6642 16.5 23.25 16.5H17.25C16.8358 16.5 16.5 16.8358 16.5 17.25V23.25C16.5 23.6642 16.1642 24 15.75 24C15.3358 24 15 23.6642 15 23.25V17.25Z" })
	});
};
No.category = "UI and Keyboard";
var Po = "16px", Fo = ({ className: e, width: t = Po, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M6.35417 5.5H4C2.34315 5.5 1 6.84315 1 8.5C1 10.1569 2.34315 11.5 4 11.5H7C8.65685 11.5 10 10.1569 10 8.5C10 8.14936 9.93985 7.81278 9.82929 7.5H9C8.91376 7.5 8.83008 7.51092 8.75024 7.53144C8.90938 7.8184 9 8.14862 9 8.5C9 9.60457 8.10457 10.5 7 10.5H4C2.89543 10.5 2 9.60457 2 8.5C2 7.39543 2.89543 6.5 4 6.5H5.53513C5.75287 6.12359 6.03018 5.78596 6.35417 5.5Z" }), S("path", { d: "M9 5.5C7.34315 5.5 6 6.84315 6 8.5C6 8.85064 6.06015 9.18722 6.17071 9.5H7.26756C7.09739 9.20583 7 8.86429 7 8.5C7 7.39543 7.89543 6.5 9 6.5H12C13.1046 6.5 14 7.39543 14 8.5C14 9.60457 13.1046 10.5 12 10.5H10.4649C10.2471 10.8764 9.96982 11.214 9.64582 11.5H12C13.6569 11.5 15 10.1569 15 8.5C15 6.84315 13.6569 5.5 12 5.5H9Z" })]
	});
};
Fo.category = "UI and Keyboard";
var Io = "16px", Lo = ({ className: e, width: t = Io, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M4.715 6.54257L3.34324 7.91432C2.17167 9.0859 2.17167 10.9854 3.34324 12.157C4.51482 13.3285 6.41431 13.3285 7.58588 12.157L9.41431 10.3285C10.5859 9.15697 10.5859 7.25747 9.41431 6.0859C9.16638 5.83796 8.88584 5.64249 8.5865 5.4995L8.0001 6.0859C7.93912 6.14688 7.88766 6.21377 7.84573 6.28473C8.16116 6.37512 8.45874 6.54454 8.70721 6.793C9.48825 7.57405 9.48825 8.84038 8.70721 9.62143L6.87878 11.4499C6.09773 12.2309 4.8314 12.2309 4.05035 11.4499C3.2693 10.6688 3.2693 9.40248 4.05035 8.62143L4.84296 7.82883C4.73076 7.4087 4.68811 6.97387 4.715 6.54257Z" }), S("path", { d: "M6.58589 4.67168C5.41431 5.84326 5.41431 7.74275 6.58589 8.91432C6.83382 9.16226 7.11436 9.35773 7.4137 9.50072L8.18929 8.72513C7.86095 8.63744 7.55058 8.46481 7.29299 8.20722C6.51194 7.42617 6.51194 6.15984 7.29299 5.37879L9.12142 3.55036C9.90247 2.76931 11.1688 2.76931 11.9498 3.55036C12.7309 4.33141 12.7309 5.59774 11.9498 6.37879L11.1572 7.1714C11.2694 7.59152 11.3121 8.02635 11.2852 8.45766L12.657 7.0859C13.8285 5.91432 13.8285 4.01483 12.657 2.84326C11.4854 1.67168 9.58588 1.67168 8.41431 2.84326L6.58589 4.67168Z" })]
	});
};
Lo.category = "UI and Keyboard";
var Ro = "16px", zo = ({ className: e, width: t = Ro, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M7 2C7 2.55228 6.55228 3 6 3C5.44772 3 5 2.55228 5 2C5 1.44772 5.44772 1 6 1C6.55228 1 7 1.44772 7 2Z" }),
			S("path", { d: "M10 2C10 2.55228 9.55228 3 9 3C8.44772 3 8 2.55228 8 2C8 1.44772 8.44772 1 9 1C9.55228 1 10 1.44772 10 2Z" }),
			S("path", { d: "M7 5C7 5.55228 6.55228 6 6 6C5.44772 6 5 5.55228 5 5C5 4.44772 5.44772 4 6 4C6.55228 4 7 4.44772 7 5Z" }),
			S("path", { d: "M10 5C10 5.55228 9.55228 6 9 6C8.44772 6 8 5.55228 8 5C8 4.44772 8.44772 4 9 4C9.55228 4 10 4.44772 10 5Z" }),
			S("path", { d: "M7 8C7 8.55228 6.55228 9 6 9C5.44772 9 5 8.55228 5 8C5 7.44772 5.44772 7 6 7C6.55228 7 7 7.44772 7 8Z" }),
			S("path", { d: "M10 8C10 8.55228 9.55228 9 9 9C8.44772 9 8 8.55228 8 8C8 7.44772 8.44772 7 9 7C9.55228 7 10 7.44772 10 8Z" }),
			S("path", { d: "M7 11C7 11.5523 6.55228 12 6 12C5.44772 12 5 11.5523 5 11C5 10.4477 5.44772 10 6 10C6.55228 10 7 10.4477 7 11Z" }),
			S("path", { d: "M10 11C10 11.5523 9.55228 12 9 12C8.44772 12 8 11.5523 8 11C8 10.4477 8.44772 10 9 10C9.55228 10 10 10.4477 10 11Z" }),
			S("path", { d: "M7 14C7 14.5523 6.55228 15 6 15C5.44772 15 5 14.5523 5 14C5 13.4477 5.44772 13 6 13C6.55228 13 7 13.4477 7 14Z" }),
			S("path", { d: "M10 14C10 14.5523 9.55228 15 9 15C8.44772 15 8 14.5523 8 14C8 13.4477 8.44772 13 9 13C9.55228 13 10 13.4477 10 14Z" })
		]
	});
};
zo.category = "UI and Keyboard";
var Bo = "16px", Vo = ({ className: e, width: t = Bo, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M2 8C2.55228 8 3 8.44772 3 9C3 9.55228 2.55228 10 2 10C1.44772 10 1 9.55228 1 9C1 8.44772 1.44772 8 2 8Z" }),
			S("path", { d: "M2 5C2.55228 5 3 5.44772 3 6C3 6.55228 2.55228 7 2 7C1.44772 7 1 6.55228 1 6C1 5.44772 1.44772 5 2 5Z" }),
			S("path", { d: "M5 8C5.55228 8 6 8.44772 6 9C6 9.55228 5.55228 10 5 10C4.44772 10 4 9.55228 4 9C4 8.44772 4.44772 8 5 8Z" }),
			S("path", { d: "M5 5C5.55228 5 6 5.44772 6 6C6 6.55228 5.55228 7 5 7C4.44772 7 4 6.55228 4 6C4 5.44772 4.44772 5 5 5Z" }),
			S("path", { d: "M8 8C8.55228 8 9 8.44772 9 9C9 9.55228 8.55228 10 8 10C7.44772 10 7 9.55228 7 9C7 8.44772 7.44772 8 8 8Z" }),
			S("path", { d: "M8 5C8.55228 5 9 5.44772 9 6C9 6.55228 8.55228 7 8 7C7.44772 7 7 6.55228 7 6C7 5.44772 7.44772 5 8 5Z" }),
			S("path", { d: "M11 8C11.5523 8 12 8.44772 12 9C12 9.55228 11.5523 10 11 10C10.4477 10 10 9.55228 10 9C10 8.44772 10.4477 8 11 8Z" }),
			S("path", { d: "M11 5C11.5523 5 12 5.44772 12 6C12 6.55228 11.5523 7 11 7C10.4477 7 10 6.55228 10 6C10 5.44772 10.4477 5 11 5Z" }),
			S("path", { d: "M14 8C14.5523 8 15 8.44772 15 9C15 9.55228 14.5523 10 14 10C13.4477 10 13 9.55228 13 9C13 8.44772 13.4477 8 14 8Z" }),
			S("path", { d: "M14 5C14.5523 5 15 5.44772 15 6C15 6.55228 14.5523 7 14 7C13.4477 7 13 6.55228 13 6C13 5.44772 13.4477 5 14 5Z" })
		]
	});
};
Vo.category = "UI and Keyboard";
var Ho = "16px", Uo = ({ className: e, width: t = Ho, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65686 5 11 6.34315 11 8C11 9.65685 9.65686 11 8 11ZM8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z" }),
			S("path", { d: "M8.5 2.5C8.5 2.77614 8.27614 3 8 3C7.72386 3 7.5 2.77614 7.5 2.5C7.5 2.22386 7.72386 2 8 2C8.27614 2 8.5 2.22386 8.5 2.5Z" }),
			S("path", { d: "M8.5 13.5C8.5 13.7761 8.27614 14 8 14C7.72386 14 7.5 13.7761 7.5 13.5C7.5 13.2239 7.72386 13 8 13C8.27614 13 8.5 13.2239 8.5 13.5Z" }),
			S("path", { d: "M13.5 8.5C13.2239 8.5 13 8.27614 13 8C13 7.72386 13.2239 7.5 13.5 7.5C13.7761 7.5 14 7.72386 14 8C14 8.27614 13.7761 8.5 13.5 8.5Z" }),
			S("path", { d: "M2.5 8.5C2.22386 8.5 2 8.27614 2 8C2 7.72386 2.22386 7.5 2.5 7.5C2.77614 7.5 3 7.72386 3 8C3 8.27614 2.77614 8.5 2.5 8.5Z" }),
			S("path", { d: "M12.2426 4.46447C12.0474 4.65973 11.7308 4.65973 11.5355 4.46447C11.3403 4.26921 11.3403 3.95262 11.5355 3.75736C11.7308 3.5621 12.0474 3.5621 12.2426 3.75736C12.4379 3.95262 12.4379 4.26921 12.2426 4.46447Z" }),
			S("path", { d: "M4.46447 12.2426C4.26921 12.4379 3.95262 12.4379 3.75736 12.2426C3.5621 12.0474 3.5621 11.7308 3.75736 11.5355C3.95262 11.3403 4.26921 11.3403 4.46447 11.5355C4.65973 11.7308 4.65973 12.0474 4.46447 12.2426Z" }),
			S("path", { d: "M11.5355 12.2426C11.3403 12.0473 11.3403 11.7307 11.5355 11.5355C11.7308 11.3402 12.0474 11.3402 12.2426 11.5355C12.4379 11.7307 12.4379 12.0473 12.2426 12.2426C12.0474 12.4379 11.7308 12.4379 11.5355 12.2426Z" }),
			S("path", { d: "M3.75736 4.46442C3.5621 4.26915 3.5621 3.95257 3.75736 3.75731C3.95262 3.56205 4.26921 3.56205 4.46447 3.75731C4.65973 3.95257 4.65973 4.26915 4.46447 4.46442C4.26921 4.65968 3.95262 4.65968 3.75736 4.46442Z" })
		]
	});
};
Uo.category = "UI and Keyboard";
var Wo = "16px", Go = ({ className: e, width: t = Wo, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8C11 9.65685 9.65685 11 8 11ZM8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z" }),
			S("path", { d: "M8 0C8.27614 0 8.5 0.223858 8.5 0.5V2.5C8.5 2.77614 8.27614 3 8 3C7.72386 3 7.5 2.77614 7.5 2.5V0.5C7.5 0.223858 7.72386 0 8 0Z" }),
			S("path", { d: "M8 13C8.27614 13 8.5 13.2239 8.5 13.5V15.5C8.5 15.7761 8.27614 16 8 16C7.72386 16 7.5 15.7761 7.5 15.5V13.5C7.5 13.2239 7.72386 13 8 13Z" }),
			S("path", { d: "M16 8C16 8.27614 15.7761 8.5 15.5 8.5H13.5C13.2239 8.5 13 8.27614 13 8C13 7.72386 13.2239 7.5 13.5 7.5H15.5C15.7761 7.5 16 7.72386 16 8Z" }),
			S("path", { d: "M3 8C3 8.27614 2.77614 8.5 2.5 8.5H0.5C0.223858 8.5 -1.20706e-08 8.27614 0 8C1.20706e-08 7.72386 0.223858 7.5 0.5 7.5H2.5C2.77614 7.5 3 7.72386 3 8Z" }),
			S("path", { d: "M13.6569 2.34318C13.8521 2.53844 13.8521 2.85502 13.6569 3.05028L12.2426 4.4645C12.0474 4.65976 11.7308 4.65976 11.5355 4.4645C11.3403 4.26924 11.3403 3.95265 11.5355 3.75739L12.9497 2.34318C13.145 2.14792 13.4616 2.14792 13.6569 2.34318Z" }),
			S("path", { d: "M4.46446 11.5356C4.65973 11.7308 4.65973 12.0474 4.46446 12.2427L3.05025 13.6569C2.85499 13.8521 2.53841 13.8521 2.34314 13.6569C2.14788 13.4616 2.14788 13.145 2.34314 12.9498L3.75736 11.5356C3.95262 11.3403 4.2692 11.3403 4.46446 11.5356Z" }),
			S("path", { d: "M13.6569 13.6569C13.4616 13.8522 13.145 13.8522 12.9497 13.6569L11.5355 12.2427C11.3403 12.0474 11.3403 11.7308 11.5355 11.5356C11.7308 11.3403 12.0474 11.3403 12.2426 11.5356L13.6569 12.9498C13.8521 13.1451 13.8521 13.4616 13.6569 13.6569Z" }),
			S("path", { d: "M4.46447 4.46451C4.2692 4.65977 3.95262 4.65977 3.75736 4.46451L2.34315 3.0503C2.14788 2.85503 2.14788 2.53845 2.34315 2.34319C2.53841 2.14793 2.85499 2.14793 3.05025 2.34319L4.46447 3.7574C4.65973 3.95267 4.65973 4.26925 4.46447 4.46451Z" })
		]
	});
};
Go.category = "UI and Keyboard";
var Ko = "16px", qo = ({ className: e, width: t = Ko, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8Z" }),
			S("path", { d: "M8.5 2.5C8.5 2.77614 8.27614 3 8 3C7.72386 3 7.5 2.77614 7.5 2.5C7.5 2.22386 7.72386 2 8 2C8.27614 2 8.5 2.22386 8.5 2.5Z" }),
			S("path", { d: "M8.5 13.5C8.5 13.7761 8.27614 14 8 14C7.72386 14 7.5 13.7761 7.5 13.5C7.5 13.2239 7.72386 13 8 13C8.27614 13 8.5 13.2239 8.5 13.5Z" }),
			S("path", { d: "M13.5 8.5C13.2239 8.5 13 8.27614 13 8C13 7.72386 13.2239 7.5 13.5 7.5C13.7761 7.5 14 7.72386 14 8C14 8.27614 13.7761 8.5 13.5 8.5Z" }),
			S("path", { d: "M2.5 8.5C2.22386 8.5 2 8.27614 2 8C2 7.72386 2.22386 7.5 2.5 7.5C2.77614 7.5 3 7.72386 3 8C3 8.27614 2.77614 8.5 2.5 8.5Z" }),
			S("path", { d: "M12.2426 4.46447C12.0474 4.65973 11.7308 4.65973 11.5355 4.46447C11.3403 4.26921 11.3403 3.95262 11.5355 3.75736C11.7308 3.5621 12.0474 3.5621 12.2426 3.75736C12.4379 3.95262 12.4379 4.26921 12.2426 4.46447Z" }),
			S("path", { d: "M4.46446 12.2426C4.2692 12.4379 3.95262 12.4379 3.75736 12.2426C3.56209 12.0474 3.56209 11.7308 3.75736 11.5355C3.95262 11.3403 4.2692 11.3403 4.46446 11.5355C4.65972 11.7308 4.65972 12.0474 4.46446 12.2426Z" }),
			S("path", { d: "M11.5355 12.2426C11.3403 12.0473 11.3403 11.7307 11.5355 11.5355C11.7308 11.3402 12.0474 11.3402 12.2426 11.5355C12.4379 11.7307 12.4379 12.0473 12.2426 12.2426C12.0474 12.4379 11.7308 12.4379 11.5355 12.2426Z" }),
			S("path", { d: "M3.75736 4.46442C3.5621 4.26915 3.56209 3.95257 3.75736 3.75731C3.95262 3.56205 4.2692 3.56205 4.46446 3.75731C4.65973 3.95257 4.65973 4.26915 4.46446 4.46442C4.2692 4.65968 3.95262 4.65968 3.75736 4.46442Z" })
		]
	});
};
qo.category = "UI and Keyboard";
var Jo = "16px", Yo = ({ className: e, width: t = Jo, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8Z" }),
			S("path", { d: "M8 0C8.27614 0 8.5 0.223858 8.5 0.5V2.5C8.5 2.77614 8.27614 3 8 3C7.72386 3 7.5 2.77614 7.5 2.5V0.5C7.5 0.223858 7.72386 0 8 0Z" }),
			S("path", { d: "M8 13C8.27614 13 8.5 13.2239 8.5 13.5V15.5C8.5 15.7761 8.27614 16 8 16C7.72386 16 7.5 15.7761 7.5 15.5V13.5C7.5 13.2239 7.72386 13 8 13Z" }),
			S("path", { d: "M16 8C16 8.27614 15.7761 8.5 15.5 8.5H13.5C13.2239 8.5 13 8.27614 13 8C13 7.72386 13.2239 7.5 13.5 7.5H15.5C15.7761 7.5 16 7.72386 16 8Z" }),
			S("path", { d: "M3 8C3 8.27614 2.77614 8.5 2.5 8.5H0.5C0.223858 8.5 -1.20706e-08 8.27614 0 8C1.20706e-08 7.72386 0.223858 7.5 0.5 7.5H2.5C2.77614 7.5 3 7.72386 3 8Z" }),
			S("path", { d: "M13.6569 2.34318C13.8521 2.53844 13.8521 2.85502 13.6569 3.05028L12.2426 4.4645C12.0474 4.65976 11.7308 4.65976 11.5355 4.4645C11.3403 4.26924 11.3403 3.95265 11.5355 3.75739L12.9497 2.34318C13.145 2.14792 13.4616 2.14792 13.6569 2.34318Z" }),
			S("path", { d: "M4.46446 11.5356C4.65973 11.7308 4.65973 12.0474 4.46446 12.2427L3.05025 13.6569C2.85499 13.8521 2.53841 13.8521 2.34314 13.6569C2.14788 13.4616 2.14788 13.145 2.34314 12.9498L3.75736 11.5356C3.95262 11.3403 4.2692 11.3403 4.46446 11.5356Z" }),
			S("path", { d: "M13.6569 13.6569C13.4616 13.8522 13.145 13.8522 12.9497 13.6569L11.5355 12.2427C11.3403 12.0474 11.3403 11.7308 11.5355 11.5356C11.7308 11.3403 12.0474 11.3403 12.2426 11.5356L13.6569 12.9498C13.8521 13.1451 13.8521 13.4616 13.6569 13.6569Z" }),
			S("path", { d: "M4.46447 4.46451C4.2692 4.65977 3.95262 4.65977 3.75736 4.46451L2.34315 3.0503C2.14788 2.85503 2.14788 2.53845 2.34315 2.34319C2.53841 2.14793 2.85499 2.14793 3.05025 2.34319L4.46447 3.7574C4.65973 3.95267 4.65973 4.26925 4.46447 4.46451Z" })
		]
	});
};
Yo.category = "UI and Keyboard";
var Xo = "16px", Zo = ({ className: e, width: t = Xo, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M8.5 5.5C8.5 5.77614 8.27614 6 8 6C7.72386 6 7.5 5.77614 7.5 5.5C7.5 5.22386 7.72386 5 8 5C8.27614 5 8.5 5.22386 8.5 5.5Z" }),
			S("path", { d: "M13.5 11.5C13.2239 11.5 13 11.2761 13 11C13 10.7238 13.2239 10.5 13.5 10.5C13.7761 10.5 14 10.7238 14 11C14 11.2761 13.7761 11.5 13.5 11.5Z" }),
			S("path", { d: "M2 11C2 11.2761 2.22386 11.5 2.5 11.5C2.77614 11.5 3 11.2761 3 11C3 10.7238 2.77614 10.5 2.5 10.5C2.22386 10.5 2 10.7238 2 11Z" }),
			S("path", { d: "M12.2426 7.46447C12.0474 7.65973 11.7308 7.65973 11.5355 7.46447C11.3403 7.2692 11.3403 6.95262 11.5355 6.75736C11.7308 6.5621 12.0474 6.5621 12.2426 6.75736C12.4379 6.95262 12.4379 7.2692 12.2426 7.46447Z" }),
			S("path", { d: "M3.75736 6.75736C3.5621 6.95262 3.5621 7.2692 3.75736 7.46447C3.95262 7.65973 4.26921 7.65973 4.46447 7.46447C4.65973 7.2692 4.65973 6.95262 4.46447 6.75736C4.26921 6.5621 3.95262 6.5621 3.75736 6.75736Z" }),
			S("path", { d: "M8 7C5.79086 7 4 8.79086 4 11C4 11.2761 4.22386 11.5 4.5 11.5H11.5C11.7761 11.5 12 11.2761 12 11C12 8.79086 10.2091 7 8 7ZM8 8C9.4865 8 10.7205 9.08114 10.9585 10.5H5.04148C5.27952 9.08114 6.5135 8 8 8Z" })
		]
	});
};
Zo.category = "UI and Keyboard";
var Qo = "16px", $o = ({ className: e, width: t = Qo, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M8 3C8.27614 3 8.5 3.22386 8.5 3.5V5.5C8.5 5.77614 8.27614 6 8 6C7.72386 6 7.5 5.77614 7.5 5.5V3.5C7.5 3.22386 7.72386 3 8 3Z" }),
			S("path", { d: "M16 11C16 11.2761 15.7761 11.5 15.5 11.5H13.5C13.2239 11.5 13 11.2761 13 11C13 10.7239 13.2239 10.5 13.5 10.5H15.5C15.7761 10.5 16 10.7239 16 11Z" }),
			S("path", { d: "M2.5 11.5C2.77614 11.5 3 11.2761 3 11C3 10.7239 2.77614 10.5 2.5 10.5H0.5C0.223858 10.5 0 10.7239 0 11C0 11.2761 0.223858 11.5 0.5 11.5H2.5Z" }),
			S("path", { d: "M13.6569 5.34315C13.8521 5.53841 13.8521 5.85499 13.6569 6.05025L12.2426 7.46447C12.0474 7.65973 11.7308 7.65973 11.5355 7.46447C11.3403 7.2692 11.3403 6.95262 11.5355 6.75736L12.9497 5.34315C13.145 5.14788 13.4616 5.14788 13.6569 5.34315Z" }),
			S("path", { d: "M3.75736 7.46447C3.95262 7.65973 4.26921 7.65973 4.46447 7.46447C4.65973 7.2692 4.65973 6.95262 4.46447 6.75736L3.05025 5.34314C2.85499 5.14788 2.53841 5.14788 2.34315 5.34314C2.14789 5.53841 2.14789 5.85499 2.34315 6.05025L3.75736 7.46447Z" }),
			S("path", { d: "M8 7C5.79086 7 4 8.79086 4 11C4 11.2761 4.22386 11.5 4.5 11.5H11.5C11.7761 11.5 12 11.2761 12 11C12 8.79086 10.2091 7 8 7ZM8 8C9.4865 8 10.7205 9.08114 10.9585 10.5H5.04148C5.27952 9.08114 6.5135 8 8 8Z" })
		]
	});
};
$o.category = "UI and Keyboard";
var es = "16px", ts = ({ className: e, width: t = es, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M8.5 5.5C8.5 5.77614 8.27614 6 8 6C7.72386 6 7.5 5.77614 7.5 5.5C7.5 5.22386 7.72386 5 8 5C8.27614 5 8.5 5.22386 8.5 5.5Z" }),
			S("path", { d: "M13.5 11.5C13.2239 11.5 13 11.2761 13 11C13 10.7238 13.2239 10.5 13.5 10.5C13.7761 10.5 14 10.7238 14 11C14 11.2761 13.7761 11.5 13.5 11.5Z" }),
			S("path", { d: "M2 11C2 11.2761 2.22386 11.5 2.5 11.5C2.77614 11.5 3 11.2761 3 11C3 10.7238 2.77614 10.5 2.5 10.5C2.22386 10.5 2 10.7238 2 11Z" }),
			S("path", { d: "M12.2426 7.46447C12.0474 7.65973 11.7308 7.65973 11.5355 7.46447C11.3403 7.2692 11.3403 6.95262 11.5355 6.75736C11.7308 6.5621 12.0474 6.5621 12.2426 6.75736C12.4379 6.95262 12.4379 7.2692 12.2426 7.46447Z" }),
			S("path", { d: "M3.75736 6.75736C3.5621 6.95262 3.5621 7.2692 3.75736 7.46447C3.95262 7.65973 4.26921 7.65973 4.46447 7.46447C4.65973 7.2692 4.65973 6.95262 4.46447 6.75736C4.26921 6.5621 3.95262 6.5621 3.75736 6.75736Z" }),
			S("path", { d: "M8 7C5.79086 7 4 8.79086 4 11C4 11.2761 4.22386 11.5 4.5 11.5H11.5C11.7761 11.5 12 11.2761 12 11C12 8.79086 10.2091 7 8 7Z" })
		]
	});
};
ts.category = "UI and Keyboard";
var ns = "16px", rs = ({ className: e, width: t = ns, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M8 3C8.27614 3 8.5 3.22386 8.5 3.5V5.5C8.5 5.77614 8.27614 6 8 6C7.72386 6 7.5 5.77614 7.5 5.5V3.5C7.5 3.22386 7.72386 3 8 3Z" }),
			S("path", { d: "M16 11C16 11.2761 15.7761 11.5 15.5 11.5H13.5C13.2239 11.5 13 11.2761 13 11C13 10.7239 13.2239 10.5 13.5 10.5H15.5C15.7761 10.5 16 10.7239 16 11Z" }),
			S("path", { d: "M2.5 11.5C2.77614 11.5 3 11.2761 3 11C3 10.7239 2.77614 10.5 2.5 10.5H0.5C0.223858 10.5 0 10.7239 0 11C0 11.2761 0.223858 11.5 0.5 11.5H2.5Z" }),
			S("path", { d: "M13.6569 5.34315C13.8521 5.53841 13.8521 5.85499 13.6569 6.05025L12.2426 7.46447C12.0474 7.65973 11.7308 7.65973 11.5355 7.46447C11.3403 7.2692 11.3403 6.95262 11.5355 6.75736L12.9497 5.34315C13.145 5.14788 13.4616 5.14788 13.6569 5.34315Z" }),
			S("path", { d: "M3.75736 7.46447C3.95262 7.65973 4.26921 7.65973 4.46447 7.46447C4.65973 7.2692 4.65973 6.95262 4.46447 6.75736L3.05025 5.34314C2.85499 5.14788 2.53841 5.14788 2.34315 5.34314C2.14789 5.53841 2.14789 5.85499 2.34315 6.05025L3.75736 7.46447Z" }),
			S("path", { d: "M8 7C5.79086 7 4 8.79086 4 11C4 11.2761 4.22386 11.5 4.5 11.5H11.5C11.7761 11.5 12 11.2761 12 11C12 8.79086 10.2091 7 8 7Z" })
		]
	});
};
rs.category = "UI and Keyboard";
var is = "16px", as = ({ className: e, width: t = is, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M7.5 1V8H8.5V1H7.5Z" }), S("path", { d: "M3 8.81244C3 6.93059 4.03942 5.29082 5.57785 4.43714L5.09264 3.56274C3.24937 4.58557 2 6.55276 2 8.81244C2 12.1262 4.68629 14.8124 8 14.8124C11.3137 14.8124 14 12.1262 14 8.81244C14 6.59097 12.7925 4.65212 11.0004 3.61544L10.4996 4.48105C11.9954 5.34633 13 6.96237 13 8.81244C13 11.5739 10.7614 13.8124 8 13.8124C5.23858 13.8124 3 11.5739 3 8.81244Z" })]
	});
};
as.category = "UI and Keyboard";
var os = "16px", ss = ({ className: e, width: t = os, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M8.5379 1.02051C8.26256 0.999561 8.02236 1.20579 8.00142 1.48114C7.98047 1.75649 8.1867 1.99668 8.46205 2.01763C11.5596 2.25326 14 4.84194 14 8.00012C14 11.3138 11.3137 14.0001 7.99998 14.0001C4.84179 14.0001 2.25311 11.5597 2.01748 8.4622C1.99653 8.18685 1.75634 7.98062 1.48099 8.00156C1.20565 8.02251 0.999415 8.2627 1.02036 8.53805C1.29535 12.153 4.31493 15.0001 7.99998 15.0001C11.866 15.0001 15 11.8661 15 8.00012C15 4.31508 12.1528 1.2955 8.5379 1.02051Z" }), S("path", { d: "M7.09619 7.82856C7.29146 8.02383 7.60804 8.02383 7.8033 7.82856C7.99856 7.6333 7.99856 7.31672 7.8033 7.12146L2.70711 2.02526L5.47483 2.02527C5.75098 2.02527 5.97484 1.80141 5.97484 1.52527C5.97484 1.24912 5.75098 1.02526 5.47483 1.02526L1.5 1.02526C1.22386 1.02526 1 1.24912 1 1.52526V5.50014C1 5.77629 1.22386 6.00014 1.5 6.00014C1.77614 6.00014 2 5.77629 2 5.50014L2 2.73237L7.09619 7.82856Z" })]
	});
};
ss.category = "UI and Keyboard";
var cs = "16px", ls = ({ className: e, width: t = cs, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C6.46709 15 5.0506 14.5078 3.89797 13.6728C3.73067 13.5516 3.68245 13.2673 3.89632 13.0534L5.69664 11.2531C7.06755 12.2809 9.02097 12.1714 10.2678 10.9246L11.682 9.51041C11.7757 9.41664 11.8284 9.28946 11.8284 9.15685C11.8284 9.02425 11.7757 8.89707 11.682 8.8033L10.9745 8.09583L12.5339 6.53319C12.729 6.33772 12.7287 6.02114 12.5332 5.82608C12.3377 5.63102 12.0211 5.63135 11.8261 5.82681L10.2674 7.38872L8.85343 5.97475L10.4137 4.41343C10.6089 4.2181 10.6088 3.90152 10.4134 3.70632C10.2181 3.51113 9.90152 3.51124 9.70633 3.70657L8.14632 5.26764L7.43934 4.56066C7.24408 4.3654 6.9275 4.3654 6.73223 4.56066L5.31802 5.97487C4.07122 7.22167 3.96173 9.17509 4.98953 10.546L3.18921 12.3463C2.60945 12.9261 2.56967 13.9454 3.31129 14.4826C4.62884 15.4371 6.24943 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 8.27614 0.223858 8.5 0.5 8.5C0.776142 8.5 1 8.27614 1 8Z" })
	});
};
ls.category = "UI and Keyboard";
var us = "16px", ds = ({ className: e, width: t = us, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M3 0H13C14.1046 0 15 0.895431 15 2V5C15 6.10457 14.1046 7 13 7H3C1.89543 7 1 6.10457 1 5V2C1 0.89543 1.89543 0 3 0ZM3 1C2.44772 1 2 1.44772 2 2V5C2 5.55228 2.44772 6 3 6H13C13.5523 6 14 5.55228 14 5V2C14 1.44772 13.5523 1 13 1H3Z" }), S("path", { d: "M3 9H13C14.1046 9 15 9.89543 15 11V14C15 15.1046 14.1046 16 13 16H3C1.89543 16 1 15.1046 1 14V11C1 9.89543 1.89543 9 3 9ZM3 10C2.44772 10 2 10.4477 2 11V14C2 14.5523 2.44772 15 3 15H13C13.5523 15 14 14.5523 14 14V11C14 10.4477 13.5523 10 13 10H3Z" })]
	});
};
ds.category = "UI and Keyboard";
var fs = "16px", ps = ({ className: e, width: t = fs, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M3 4.5H13C14.1046 4.5 15 5.39543 15 6.5V9.5C15 10.6046 14.1046 11.5 13 11.5H3C1.89543 11.5 1 10.6046 1 9.5V6.5C1 5.39543 1.89543 4.5 3 4.5ZM3 5.5C2.44772 5.5 2 5.94772 2 6.5V9.5C2 10.0523 2.44772 10.5 3 10.5H13C13.5523 10.5 14 10.0523 14 9.5V6.5C14 5.94772 13.5523 5.5 13 5.5H3Z" }),
			S("path", { d: "M1 2C1 1.72386 1.22386 1.5 1.5 1.5H14.5C14.7761 1.5 15 1.72386 15 2C15 2.27614 14.7761 2.5 14.5 2.5H1.5C1.22386 2.5 1 2.27614 1 2Z" }),
			S("path", { d: "M1 14C1 13.7239 1.22386 13.5 1.5 13.5H14.5C14.7761 13.5 15 13.7239 15 14C15 14.2761 14.7761 14.5 14.5 14.5H1.5C1.22386 14.5 1 14.2761 1 14Z" })
		]
	});
};
ps.category = "UI and Keyboard";
var ms = "16px", hs = ({ className: e, width: t = ms, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M9.5 1.5C9.5 2.32843 8.82843 3 8 3C7.17157 3 6.5 2.32843 6.5 1.5C6.5 0.671573 7.17157 0 8 0C8.82843 0 9.5 0.671573 9.5 1.5Z" }), S("path", { d: "M6 5.5L1.46525 5.05816C1.19946 5.02493 1 4.79899 1 4.53113C1 4.23779 1.23779 4 1.53113 4H14.4689C14.7622 4 15 4.23779 15 4.53113C15 4.79899 14.8005 5.02493 14.5347 5.05816L10 5.5V9L10.4517 15.4201C10.4777 15.7323 10.2313 16 9.91807 16C9.67237 16 9.45819 15.8328 9.3986 15.5944L8.24254 9.97014C8.17941 9.71765 7.82059 9.71765 7.75746 9.97014L6.6014 15.5944C6.5418 15.8328 6.32763 16 6.08193 16C5.76867 16 5.52231 15.7323 5.54833 15.4201L6 9V5.5Z" })]
	});
};
hs.category = "UI and Keyboard";
var gs = "16px", _s = ({ className: e, width: t = gs, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [
			S("path", { d: "M8 4.14286C8.59173 4.14286 9.07143 3.66316 9.07143 3.07143C9.07143 2.47969 8.59173 2 8 2C7.40827 2 6.92857 2.47969 6.92857 3.07143C6.92857 3.66316 7.40827 4.14286 8 4.14286Z" }),
			S("path", { d: "M3.33232 5.61297L6.57143 5.92857V8.42857L6.24881 13.0143C6.23022 13.2373 6.40619 13.4286 6.62995 13.4286C6.80545 13.4286 6.95843 13.3091 7.001 13.1389L7.82676 9.12153C7.87185 8.94118 8.12815 8.94118 8.17324 9.12153L8.999 13.1389C9.04157 13.3091 9.19455 13.4286 9.37005 13.4286C9.59381 13.4286 9.76978 13.2373 9.7512 13.0143L9.42857 8.42857V5.92857L12.6677 5.61297C12.8575 5.58924 13 5.42785 13 5.23652C13 5.027 12.8301 4.85714 12.6206 4.85714H3.37938C3.16985 4.85714 3 5.027 3 5.23652C3 5.42785 3.14247 5.58924 3.33232 5.61297Z" }),
			S("path", { d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8Z" })
		]
	});
};
_s.category = "UI and Keyboard";
var vs = "16px", ys = ({ className: e, width: t = vs, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M4 2C4 0.89543 4.89543 0 6 0H14C15.1046 0 16 0.895431 16 2V10C16 11.1046 15.1046 12 14 12H6C4.89543 12 4 11.1046 4 10V2ZM6 1C5.44772 1 5 1.44772 5 2V10C5 10.5523 5.44772 11 6 11H14C14.5523 11 15 10.5523 15 10V2C15 1.44772 14.5523 1 14 1H6ZM2 5C1.44772 5 1 5.44772 1 6V14C1 14.5523 1.44772 15 2 15H10C10.5523 15 11 14.5523 11 14V13H12V14C12 15.1046 11.1046 16 10 16H2C0.89543 16 0 15.1046 0 14V6C0 4.89543 0.89543 4 2 4H3V5H2Z" })
	});
};
ys.category = "UI and Keyboard";
var bs = "16px", xs = ({ className: e, width: t = bs, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 16 16",
		children: S("path", { d: "M13.739 0H6.34106C5.17369 0 4.22735 0.89543 4.22735 2C3.05999 2 2.11365 2.89543 2.11365 4V14C2.11365 15.1046 3.05999 16 4.22735 16H11.6253C12.7927 16 13.739 15.1046 13.739 14C14.9064 14 15.8527 13.1046 15.8527 12V2C15.8527 0.89543 14.9064 0 13.739 0ZM13.739 13V4C13.739 2.89543 12.7927 2 11.6253 2H5.28421C5.28421 1.44772 5.75738 1 6.34106 1H13.739C14.3227 1 14.7959 1.44772 14.7959 2V12C14.7959 12.5523 14.3227 13 13.739 13ZM3.1705 4C3.1705 3.44772 3.64367 3 4.22735 3H11.6253C12.209 3 12.6822 3.44772 12.6822 4V14C12.6822 14.5523 12.209 15 11.6253 15H4.22735C3.64367 15 3.1705 14.5523 3.1705 14V4Z" })
	});
};
xs.category = "UI and Keyboard";
var Ss = "16px", Cs = ({ className: e, width: t = Ss, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: S("path", { d: "M3.5 2C4.32843 2 5 2.67157 5 3.5V5H3.5C2.67157 5 2 4.32843 2 3.5C2 2.67157 2.67157 2 3.5 2ZM6 5V3.5C6 2.11929 4.88071 1 3.5 1C2.11929 1 1 2.11929 1 3.5C1 4.88071 2.11929 6 3.5 6H5V10H3.5C2.11929 10 1 11.1193 1 12.5C1 13.8807 2.11929 15 3.5 15C4.88071 15 6 13.8807 6 12.5V11H10V12.5C10 13.8807 11.1193 15 12.5 15C13.8807 15 15 13.8807 15 12.5C15 11.1193 13.8807 10 12.5 10H11V6H12.5C13.8807 6 15 4.88071 15 3.5C15 2.11929 13.8807 1 12.5 1C11.1193 1 10 2.11929 10 3.5V5H6ZM10 6V10H6V6H10ZM11 5V3.5C11 2.67157 11.6716 2 12.5 2C13.3284 2 14 2.67157 14 3.5C14 4.32843 13.3284 5 12.5 5H11ZM11 11H12.5C13.3284 11 14 11.6716 14 12.5C14 13.3284 13.3284 14 12.5 14C11.6716 14 11 13.3284 11 12.5V11ZM5 11V12.5C5 13.3284 4.32843 14 3.5 14C2.67157 14 2 13.3284 2 12.5C2 11.6716 2.67157 11 3.5 11H5Z" })
	});
};
Cs.category = "UI and Keyboard";
var ws = "16px", Ts = ({ className: e, width: t = ws, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M1 2.5C1 2.22386 1.22386 2 1.5 2H5.29682C5.47979 2 5.64815 2.09994 5.73576 2.26057L11 13H14.5C14.7761 13 15 13.2239 15 13.5C15 13.7761 14.7761 14 14.5 14H10.7032C10.5202 14 10.3519 13.9001 10.2642 13.7394L5 3H1.5C1.22386 3 1 2.77614 1 2.5Z" }), S("path", { d: "M11 2.5C11 2.22386 11.2239 2 11.5 2H14.5C14.7761 2 15 2.22386 15 2.5C15 2.77614 14.7761 3 14.5 3H11.5C11.2239 3 11 2.77614 11 2.5Z" })]
	});
};
Ts.category = "UI and Keyboard";
var Es = "16px", Ds = ({ className: e, width: t = Es, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 16 16",
		children: [S("path", { d: "M1 13.5C1 13.7761 1.22386 14 1.5 14H5.29682C5.47979 14 5.64815 13.9001 5.73576 13.7394L11 3H14.5C14.7761 3 15 2.77614 15 2.5C15 2.22386 14.7761 2 14.5 2H10.7032C10.5202 2 10.3519 2.09994 10.2642 2.26057L5 13H1.5C1.22386 13 1 13.2239 1 13.5Z" }), S("path", { d: "M11 13.5C11 13.7761 11.2239 14 11.5 14H14.5C14.7761 14 15 13.7761 15 13.5C15 13.2239 14.7761 13 14.5 13H11.5C11.2239 13 11 13.2239 11 13.5Z" })]
	});
};
Ds.category = "UI and Keyboard";
var Os = (e) => S(G, Object.assign({}, e, { paths: ["M0.5 9.90002C0.632608 9.90002 0.759785 9.9527 0.853553 10.0465C0.947322 10.1402 1 10.2674 1 10.4V12.9C1 13.1652 1.10536 13.4196 1.29289 13.6071C1.48043 13.7947 1.73478 13.9 2 13.9H14C14.2652 13.9 14.5196 13.7947 14.7071 13.6071C14.8946 13.4196 15 13.1652 15 12.9V10.4C15 10.2674 15.0527 10.1402 15.1464 10.0465C15.2402 9.9527 15.3674 9.90002 15.5 9.90002C15.6326 9.90002 15.7598 9.9527 15.8536 10.0465C15.9473 10.1402 16 10.2674 16 10.4V12.9C16 13.4305 15.7893 13.9392 15.4142 14.3142C15.0391 14.6893 14.5304 14.9 14 14.9H2C1.46957 14.9 0.960859 14.6893 0.585786 14.3142C0.210714 13.9392 0 13.4305 0 12.9V10.4C0 10.2674 0.0526784 10.1402 0.146447 10.0465C0.240215 9.9527 0.367392 9.90002 0.5 9.90002Z", "M7.64602 11.854C7.69247 11.9006 7.74764 11.9375 7.80839 11.9627C7.86913 11.9879 7.93425 12.0009 8.00002 12.0009C8.06579 12.0009 8.13091 11.9879 8.19165 11.9627C8.2524 11.9375 8.30758 11.9006 8.35402 11.854L11.354 8.854C11.4479 8.76011 11.5007 8.63278 11.5007 8.5C11.5007 8.36722 11.4479 8.23989 11.354 8.146C11.2601 8.05211 11.1328 7.99937 11 7.99937C10.8672 7.99937 10.7399 8.05211 10.646 8.146L8.50002 10.293V1.5C8.50002 1.36739 8.44734 1.24021 8.35358 1.14645C8.25981 1.05268 8.13263 1 8.00002 1C7.86741 1 7.74024 1.05268 7.64647 1.14645C7.5527 1.24021 7.50002 1.36739 7.50002 1.5V10.293L5.35402 8.146C5.26013 8.05211 5.1328 7.99937 5.00002 7.99937C4.86725 7.99937 4.73991 8.05211 4.64602 8.146C4.55213 8.23989 4.49939 8.36722 4.49939 8.5C4.49939 8.63278 4.55213 8.76011 4.64602 8.854L7.64602 11.854Z"] }));
Os.category = "UI and Keyboard";
var ks = (e) => S(G, Object.assign({}, e, {
	paths: ["M1.2345 3.4845C1.26933 3.44958 1.31071 3.42187 1.35627 3.40297C1.40183 3.38406 1.45067 3.37433 1.5 3.37433C1.54932 3.37433 1.59817 3.38406 1.64372 3.40297C1.68928 3.42187 1.73066 3.44958 1.7655 3.4845L6 7.71975L10.2345 3.4845C10.2694 3.44963 10.3108 3.42198 10.3563 3.40311C10.4019 3.38424 10.4507 3.37453 10.5 3.37453C10.5493 3.37453 10.5981 3.38424 10.6437 3.40311C10.6892 3.42198 10.7306 3.44963 10.7655 3.4845C10.8004 3.51937 10.828 3.56076 10.8469 3.60631C10.8658 3.65187 10.8755 3.70069 10.8755 3.75C10.8755 3.79931 10.8658 3.84813 10.8469 3.89369C10.828 3.93924 10.8004 3.98063 10.7655 4.0155L6.2655 8.5155C6.23066 8.55042 6.18928 8.57813 6.14372 8.59703C6.09817 8.61594 6.04932 8.62567 6 8.62567C5.95067 8.62567 5.90183 8.61594 5.85627 8.59703C5.81072 8.57813 5.76933 8.55042 5.7345 8.5155L1.2345 4.0155C1.19958 3.98067 1.17187 3.93928 1.15296 3.89373C1.13406 3.84817 1.12433 3.79933 1.12433 3.75C1.12433 3.70068 1.13406 3.65183 1.15296 3.60628C1.17187 3.56072 1.19958 3.51933 1.2345 3.4845Z"],
	viewBox: "0 0 12 12"
}));
ks.category = "Chevrons";
var As = (e) => S(G, Object.assign({}, e, { paths: ["M7.64645 4.64645C7.84171 4.45118 8.15829 4.45118 8.35355 4.64645L14.3536 10.6464C14.5488 10.8417 14.5488 11.1583 14.3536 11.3536C14.1583 11.5488 13.8417 11.5488 13.6464 11.3536L8 5.70711L2.35355 11.3536C2.15829 11.5488 1.84171 11.5488 1.64645 11.3536C1.45118 11.1583 1.45118 10.8417 1.64645 10.6464L7.64645 4.64645Z"] }));
As.category = "Chevrons";
var K;
(function(e) {
	e.V1 = "v1", e.V2 = "v2";
})(K ||= {});
var js;
(function(e) {
	e.Button = "button", e.Submit = "submit", e.Reset = "reset";
})(js ||= {});
var q;
(function(e) {
	e.xs = "xs", e.sm = "sm", e.md = "md", e.lg = "lg", e.xl = "xl";
})(q ||= {});
var Ms;
(function(e) {
	e.Primary = "primary", e.Secondary = "secondary", e.Tertiary = "tertiary";
})(Ms ||= {});
var Ns;
(function(e) {
	e.Info = "info", e.Success = "success", e.Warning = "warning", e.Error = "error", e.Default = "default";
})(Ns ||= {});
var Ps;
(function(e) {
	e.Horizontal = "horizontal", e.Vertical = "vertical";
})(Ps ||= {});
var J;
(function(e) {
	e.Plain = "plain", e.Primary = "primary", e.Secondary = "secondary", e.Tertiary = "tertiary", e.Danger = "danger", e.Warning = "warning", e.Info = "info", e.Success = "success", e.DangerOutline = "danger-outline", e.TextLink = "textlink";
})(J ||= {});
var Fs;
(function(e) {
	e.Check = "check", e.Indeterminate = "indeterminate", e.Uncheck = "uncheck";
})(Fs ||= {});
var Is;
(function(e) {
	e.Default = "default", e.Critical = "critical", e.HighCritical = "high-critical";
})(Is ||= {});
var Ls;
(function(e) {
	e.Small = "small", e.Medium = "medium", e.Large = "large";
})(Ls ||= {});
var Rs;
(function(e) {
	e.Alert = "alert", e.Warning = "warning", e.Success = "success", e.Info = "info";
})(Rs ||= {});
var zs;
(function(e) {
	e.Inline = "inline", e.Block = "block";
})(zs ||= {});
var Bs;
(function(e) {
	e.Normal = "normal", e.Compact = "compact", e.InnerPaddingOnly = "innerPaddingOnly";
})(Bs ||= {});
var Vs;
(function(e) {
	e.Text = "text", e.Number = "number", e.Email = "email", e.Tel = "tel", e.Url = "url", e.Password = "password", e.Date = "date", e.DatetimeLocal = "datetime-local", e.Month = "month", e.Search = "search", e.Time = "time", e.Week = "week", e.Hidden = "hidden";
})(Vs ||= {});
var Hs;
(function(e) {
	e.Light = "light", e.Dark = "dark";
})(Hs ||= {});
var Us;
(function(e) {
	e.Primary = "primary", e.Secondary = "secondary";
})(Us ||= {});
var Ws;
(function(e) {
	e.Small = "small", e.Medium = "medium", e.Large = "large", e.XLarge = "x-large";
})(Ws ||= {});
var Gs;
(function(e) {
	e.Small = "small", e.Regular = "regular", e.Big = "big", e.Large = "large", e.Full = "full", e.FullScreen = "full-screen";
})(Gs ||= {});
var Ks;
(function(e) {
	e.Default = "default", e.Global = "global", e.Plain = "plain", e.Primary = "primary", e.Secondary = "secondary", e.Tertiary = "tertiary", e.Danger = "danger", e.Warning = "warning", e.Info = "info", e.Success = "success";
})(Ks ||= {});
var qs;
(function(e) {
	e.Left = "left", e.Center = "center", e.Right = "right";
})(qs ||= {});
var Y;
(function(e) {
	e.Round = "round", e.Square = "square";
})(Y ||= {});
var X;
(function(e) {
	e.Asc = "asc", e.Desc = "desc", e.None = "none";
})(X ||= {});
var Js;
(function(e) {
	e.Alpha = "alpha", e.Numeric = "numeric";
})(Js ||= {});
var Ys;
(function(e) {
	e.Horizontal = "horizontal", e.Vertical = "vertical";
})(Ys ||= {});
var Xs;
(function(e) {
	e.Scroll = "scroll", e.Wrap = "wrap";
})(Xs ||= {});
var Zs;
(function(e) {
	e.Top = "top", e.Right = "right", e.Bottom = "bottom", e.Left = "left";
})(Zs ||= {});
var Qs;
(function(e) {
	e.Middle = "middle", e.Top = "top", e.Bottom = "bottom", e.Left = "left", e.Right = "right";
})(Qs ||= {});
var $s;
(function(e) {
	e.Primary = "primary", e.Secondary = "secondary", e.Tertiary = "tertiary";
})($s ||= {});
var ec;
(function(e) {
	e.Left = "left", e.Right = "right";
})(ec ||= {});
var tc;
(function(e) {
	e.ArrowUp = "ArrowUp", e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.Escape = "Escape", e.Enter = "Enter", e.Space = "Space";
})(tc ||= {});
var nc;
(function(e) {
	e.Inside = "inside", e.Outside = "outside", e.Right = "right";
})(nc ||= {});
var rc;
(function(e) {
	e.XSmall = "x-small", e.Small = "small", e.Medium = "medium", e.Large = "large", e.XLarge = "x-large";
})(rc ||= {});
var ic;
(function(e) {
	e.Red = "#e94e2d", e.Blue = "#006de7", e.Green = "#3bb85d", e.Amber = "#ef9400", e.Gold = "#d1a33c", e.Black = "#000000", e.Grey = "#787a7a", e.White = "#ffffff";
})(ic ||= {});
var ac;
(function(e) {
	e.BGRed = "#fcedea", e.BGBlue = "#e5effa", e.BGGreen = "#ebf7ee", e.BGAmber = "#fef7ea", e.BGGold = "#f7ee83", e.BGBlack = "#ffffff", e.BGGrey = "#d3d3d3", e.BGWhite = "#000000";
})(ac ||= {});
var oc;
(function(e) {
	e.TopLeft = "topLeft", e.TopMiddle = "topMiddle", e.TopRight = "topRight", e.BottomLeft = "bottomLeft", e.BottomMiddle = "bottomMiddle", e.BottomRight = "bottomRight";
})(oc ||= {});
var sc;
(function(e) {
	e.Default = "default", e.Alternate = "alternate";
})(sc ||= {});
var cc;
(function(e) {
	e.Initial = "initial", e.Icon = "icon", e.Image = "image";
})(cc ||= {});
var lc;
(function(e) {
	e.Small = "small", e.Medium = "medium", e.Large = "large";
})(lc ||= {});
var uc;
(function(e) {
	e.Neutral = "neutral", e.Brand = "brand", e.Creative = "creative", e.Cloudy = "cloudy", e.Fresh = "fresh", e.Healthy = "healthy", e.Friendly = "friendly", e.Joyful = "joyful", e.Warm = "warm", e.Plain = "plain", e.Excited = "excited";
})(uc ||= {});
var dc;
(function(e) {
	e.small = "small", e.medium = "medium", e.large = "large";
})(dc ||= {});
var fc;
(function(e) {
	e.weak = "weak", e.strong = "strong", e.clear = "clear";
})(fc ||= {});
var pc;
(function(e) {
	e.Center = "center", e.Left = "left", e.Right = "right", e.None = "none";
})(pc ||= {});
var mc;
(function(e) {
	e.Default = "default", e.Dotted = "dotted", e.Dashed = "dashed";
})(mc ||= {});
var hc;
(function(e) {
	e.Single = "single", e.Double = "double";
})(hc ||= {});
var gc;
(function(e) {
	e.Small = "small", e.Large = "large";
})(gc ||= {});
var _c;
(function(e) {
	e.Success = "success", e.Error = "error", e.Info = "info", e.Warning = "warning";
})(_c ||= {});
var Z;
(function(e) {
	e.Date = "date", e.Numeric = "numeric", e.Alphanumeric = "alphanumeric", e.String = "string";
})(Z ||= {});
var vc = "16px", yc = ({ className: e, width: t = vc, height: n, color: r, isLight: i = !1 }) => {
	let a = r || (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n || "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 -960 960 960",
		children: S("path", { d: "M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z" })
	});
}, bc = {
	[q.xs]: "xs",
	[q.sm]: "sm",
	[q.md]: "md",
	[q.lg]: "lg",
	[q.xl]: "xl"
}, xc = ({ id: e, onClick: t, size: n = q.md, variant: r = J.Primary, type: i = js.Button, disabled: a = !1, fullWidth: o = !1, selected: s = !1, loading: c = !1, className: l = "", corner: u = Y.Square, isNotCapitalized: d = !1, "data-testid": f, leading: p = !1, trailing: m = !1, Icon: h = yc, iconColor: g = "#fff", children: _, href: v = "#" }) => {
	let y = ((e) => {
		switch (e) {
			case q.xs: return 14;
			case q.sm: return 18;
			case q.lg: return 24;
			case q.xl: return 32;
			case q.md:
			default: return 22;
		}
	})(n), b = [
		"abi-button",
		`abi-button-${u}`,
		`abi-button-${bc[n]}`,
		`abi-button-${r}`,
		o && "abi-cta-full-width",
		d && "abi-button-lowercase",
		s && "abi-button-selected",
		c && "abi-button-loading",
		l
	].filter(Boolean).join(" ");
	return r === "textlink" ? C("a", {
		id: e,
		onClick: a ? void 0 : t,
		href: a ? void 0 : v,
		className: b,
		"data-testid": f,
		children: [
			p && h && S("span", {
				className: "abi-button-icon",
				children: S(h, {
					width: y,
					height: y,
					color: g
				})
			}),
			S("span", { children: c ? "Loading..." : _ }),
			m && !p && h && S("span", {
				className: "abi-button-icon",
				children: S(h, {
					width: y,
					height: y,
					color: g
				})
			})
		]
	}) : C("button", {
		id: e,
		onClick: t,
		type: i,
		className: b,
		disabled: a,
		"data-testid": f,
		children: [
			p && h && S("span", {
				className: "abi-button-icon",
				children: S(h, {
					width: y,
					height: y,
					color: g
				})
			}),
			S("span", { children: c ? "Loading..." : _ }),
			m && !p && h && S("span", {
				className: "abi-button-icon",
				children: S(h, {
					width: y,
					height: y,
					color: g
				})
			})
		]
	});
}, Sc;
(function(e) {
	e.Informative = "informative", e.Positive = "positive", e.Attention = "attention", e.Negative = "negative", e.Neutral = "neutral";
})(Sc ||= {});
var Cc;
(function(e) {
	e.Low = "low", e.Medium = "medium", e.High = "high";
})(Cc ||= {});
var wc;
(function(e) {
	e.Inline = "inline", e.Sticky = "sticky", e.Toast = "toast";
})(wc ||= {});
var Tc;
(function(e) {
	e.Tight = "tight", e.Default = "default", e.Loose = "loose";
})(Tc ||= {});
var Ec = (e) => ({
	danger: J.Danger,
	warning: J.Warning,
	info: J.Info,
	success: J.Success
})[e] ?? J.Primary, Dc = ({ id: e, show: t = !1, size: n = Gs.Regular, variant: r = Ks.Default, onRequestClose: i, onClose: a, title: o, disableCloseButton: s = !1, disableOverlayClick: c = !1, shouldRenderInPortal: l = !1, height: u = "auto", customWidth: d = "", portalId: f = "root", className: p = "", backgroundType: h = "partial-black", backdropClassName: _, backdropZIndex: v, closeOnEsc: y = !0, withBottomCloseButton: x = !1, closeButtonInside: T = !1, isHeaderCentered: E = !1, isHeaderBorderBottom: D = !0, allRoundCorner: O = !0, isSlimScroll: k = !0, "data-testid": A, children: j }) => {
	let M = Ec(r), [N, P] = b(t);
	g(() => {
		P(t);
	}, [t]), g(() => {
		!N && i != null && i();
	}, [N]);
	let F = () => {
		s || (a == null ? P(!1) : a());
	}, I = m((e) => {
		y && e.key === "Escape" && (a == null ? P(!1) : a());
	}, []);
	g(() => (document.addEventListener("keydown", I), () => document.removeEventListener("keydown", I)), []);
	let L = S("div", {
		id: e,
		style: { zIndex: v },
		className: `abi-modal-container ${h} ${_ || ""}`,
		onClick: c ? void 0 : F,
		"aria-hidden": "true",
		"data-testid": A,
		children: C("div", {
			className: `abi-modal ${n} ${r} ${O ? "round-corner" : ""} ${p}`,
			style: {
				height: u,
				width: d
			},
			onClick: (e) => {
				e.stopPropagation();
			},
			"aria-hidden": "true",
			children: [
				C("header", {
					className: "abi-modal-header",
					children: [o && S("div", {
						className: `abi-modal-header-title ${E ? "title-center" : ""} ${D ? "border-bottom" : ""}`,
						children: o
					}), !s && S("button", {
						className: `abi-modal-close ${T ? "inside" : ""}`,
						type: "button",
						onClick: F,
						"aria-label": "Close",
						children: C("svg", {
							xmlns: "http://www.w3.org/2000/svg",
							viewBox: "0 0 50 50",
							width: T ? "10" : "12",
							height: T ? "10" : "12",
							overflow: "visible",
							stroke: "black",
							strokeWidth: "6",
							strokeLinecap: "round",
							children: [S("line", {
								x1: "0",
								y1: "0",
								x2: "50",
								y2: "50"
							}), S("line", {
								x1: "50",
								y1: "0",
								x2: "0",
								y2: "50"
							})]
						})
					})]
				}),
				S("div", {
					className: `abi-modal-content ${k ? "slim-scroll" : ""}`,
					children: j
				}),
				x && S("footer", {
					className: "abi-modal-footer",
					children: S(xc, {
						size: q.md,
						onClick: F,
						variant: M,
						children: "Close"
					})
				})
			]
		})
	});
	if (N) {
		let e = document.getElementById(f);
		return l && e != null ? w.createPortal(L, e) : L;
	}
	return null;
};
function Oc(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
var kc = p((e, t) => {
	let { id: n, label: r, value: i = "", required: a = !1, invalid: o = !1, disabled: s = !1, errorMessage: c = "", placeholder: l = "", className: u = "", maxLength: d = 524288, minLength: f = 0, onChange: p, onBlur: m, onFocus: h, fieldHeight: v, rows: b = 0, cols: x = 0, resize: w = !1, autoFocus: T = !1, autoSize: E = !1, readOnly: D = !1, labelWidth: O, withoutFloatingLabel: k = !1, isBorderLight: A = !1, isLabelLeft: j = !1, bottomBorderOnly: M = !1, "data-testid": N } = e, P = y(null);
	_(t, () => P.current);
	let F = () => {
		let e = P.current;
		E && e && (e.style.height = "inherit", e.style.height = `${e.scrollHeight}px`);
	};
	return g(() => {
		F();
	}, [E, i]), C("div", {
		className: `abi-textarea-container ${o ? "error " : ""}${w ? "" : "resize "}${s ? "abi-textarea-disabled " : ""}${k ? "without-floating-label " : "with-floating-label "}${j ? "abi-textarea-label-left " : ""}${M ? "abi-textarea-border-bottom " : ""}${A ? "border-light " : ""}${u}`,
		children: [r && C("label", {
			style: { width: `${O || "auto"}` },
			className: i || l ? "filled" : "",
			children: [
				r,
				" ",
				a && S("sup", { children: "*" })
			]
		}), C("div", {
			className: `abi-textarea-items-wrap ${E ? "auto-size" : ""}`,
			children: [S("textarea", {
				id: n,
				ref: P,
				required: !0,
				disabled: s,
				autoFocus: T,
				readOnly: D,
				maxLength: d,
				minLength: f,
				onChange: (e) => {
					p && p(e), F();
				},
				onBlur: m,
				onFocus: h,
				rows: b,
				cols: x,
				placeholder: l,
				style: { height: v },
				value: i,
				"data-testid": N
			}), o && c && S("span", {
				className: "error-msg",
				children: c
			})]
		})]
	});
});
kc.displayName = "ABITextarea";
var Ac = (e) => {
	let { id: t, align: n = qs.Center, className: r = "", page: i, totalItems: a, pageSize: o, onPageChange: s, onPageSizeChange: c, "data-testid": l } = e, u = Math.ceil(a / o);
	return S("div", {
		className: `abi-pagination ${n} ${r}`,
		id: t,
		"data-testid": l,
		children: C("ul", { children: [
			S("li", { children: S("button", {
				type: "button",
				onClick: () => s(0),
				disabled: i === 0,
				children: "First"
			}) }),
			S("li", { children: S("button", {
				type: "button",
				onClick: () => s(i - 1),
				disabled: i === 0,
				children: "Previous"
			}) }),
			S("li", { children: S("input", {
				type: "number",
				min: 1,
				max: u,
				value: i + 1,
				onChange: (e) => s(parseInt(e.target.value, 10) - 1)
			}) }),
			S("li", { children: S("button", {
				type: "button",
				onClick: () => s(i + 1),
				disabled: i >= u - 1,
				children: "Next"
			}) }),
			S("li", { children: S("button", {
				type: "button",
				onClick: () => s(u - 1),
				disabled: i >= u - 1,
				children: "Last"
			}) }),
			S("li", { children: C("p", { children: [
				"Page ",
				i + 1,
				" of ",
				u
			] }) }),
			C("li", { children: [S("input", {
				type: "number",
				min: 1,
				value: o,
				onChange: (e) => c(parseInt(e.target.value, 10))
			}), S("span", { children: "Page Size" })] })
		] })
	});
};
Ac.displayName = "ABIPaginationV1";
var jc = /*#__PURE__*/ Object.freeze({
	__proto__: null,
	default: Ac
}), Mc = "16px", Nc = ({ className: e, width: t = Mc, height: n, color: r }) => C("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	className: e,
	fill: r || "#FFFFFF",
	viewBox: "0 0 24 24",
	style: {
		width: typeof t == "number" ? `${t}px` : t,
		height: typeof n == "number" ? `${n}px` : n || "auto"
	},
	children: [S("path", { d: "M18.216 3.377a1.286 1.286 0 0 1 1.925 1.697l-.107.12L13.23 12l6.804 6.805c.464.464.5 1.193.107 1.697l-.107.121c-.463.464-1.193.5-1.697.107l-.121-.107-7.714-7.714a1.286 1.286 0 0 1-.107-1.697l.107-.121 7.714-7.714Z" }), S("path", { d: "M11.84 3.377a1.286 1.286 0 0 1 1.926 1.697l-.107.12L6.855 12l6.804 6.805c.464.464.5 1.193.107 1.697l-.107.121c-.463.464-1.193.5-1.697.107l-.121-.107-7.714-7.714a1.286 1.286 0 0 1-.107-1.697l.107-.121 7.714-7.714Z" })]
}), Pc = "16px", Fc = ({ className: e, width: t = Pc, height: n, color: r }) => S("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	className: e,
	fill: r || "#FFFFFF",
	viewBox: "0 0 24 24",
	style: {
		width: typeof t == "number" ? `${t}px` : t,
		height: typeof n == "number" ? `${n}px` : n || "auto"
	},
	children: S("path", { d: "M14.84 3.377a1.286 1.286 0 0 1 1.926 1.697l-.107.12L9.855 12l6.804 6.805c.464.464.5 1.193.107 1.697l-.107.121c-.463.464-1.193.5-1.697.107l-.121-.107-7.714-7.714a1.286 1.286 0 0 1-.107-1.697l.107-.121 7.714-7.714Z" })
}), Ic = "16px", Lc = ({ className: e, width: t = Ic, height: n, color: r }) => S("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	className: e,
	fill: r || "#FFFFFF",
	viewBox: "0 0 24 24",
	style: {
		width: typeof t == "number" ? `${t}px` : t,
		height: typeof n == "number" ? `${n}px` : n || "auto"
	},
	children: S("path", { d: "M7.127 3.377a1.286 1.286 0 0 1 1.697-.107l.12.107 7.715 7.714c.464.463.5 1.193.107 1.697l-.107.121-7.714 7.714a1.286 1.286 0 0 1-1.925-1.697l.107-.12L13.93 12 7.127 5.195a1.286 1.286 0 0 1-.107-1.697l.107-.121" })
}), Rc = "16px", zc = ({ className: e, width: t = Rc, height: n, color: r }) => C("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	className: e,
	fill: r || "#FFFFFF",
	viewBox: "0 0 24 24",
	style: {
		width: typeof t == "number" ? `${t}px` : t,
		height: typeof n == "number" ? `${n}px` : n || "auto"
	},
	children: [S("path", { d: "M5.945 3.377A1.286 1.286 0 0 0 4.02 5.074l.107.12L10.93 12l-6.804 6.805a1.286 1.286 0 0 0-.107 1.697l.107.121c.463.464 1.192.5 1.697.107l.12-.107 7.715-7.714c.464-.463.5-1.193.107-1.697l-.107-.121-7.714-7.714Z" }), S("path", { d: "M12.32 3.377a1.286 1.286 0 0 0-1.925 1.697l.107.12L17.306 12l-6.804 6.805a1.286 1.286 0 0 0-.107 1.697l.107.121c.463.464 1.192.5 1.697.107l.12-.107 7.715-7.714c.464-.463.5-1.193.107-1.697l-.107-.121-7.714-7.714Z" })]
}), Bc = [
	10,
	20,
	50,
	100
], Vc = (e, t, n) => [n === 0 ? 0 : (e - 1) * t + 1, Math.min(e * t, n)], Hc = ({ id: e = "", align: t = qs.Center, className: n = "", totalItems: r, defaultPage: i = 1, currentPage: a, defaultPageSize: o = 10, onPageChange: s, showItemsPerPage: c = !0, showQuantityIndicator: u = !0, maxPagesToShow: d = 5, disabled: f = !1, itemsPerPageOptions: p = Bc, onItemsPerPageChange: h, customQuantityIndicatorLabel: g, customItemsPerPageLabel: _ = "Items per page:", controlShape: y = Y.Square, "data-testid": b }) => {
	let x = p.length > 0 ? p : Bc, w = x.includes(o) ? o : x[0], T = a === void 0 ? Math.max(1, Math.floor(i)) : a, [E, D] = l.useState(w), O = v(() => Math.max(1, Math.ceil(r / E)), [r, E]), k = v(() => Vc(T, E, r), [
		T,
		E,
		r
	]), A = v(() => {
		let e = Math.min(d, O), t = Math.min(O - e + 1, Math.max(1, T - Math.floor(e / 2)));
		return Array.from({ length: e }, (e, n) => t + n);
	}, [
		T,
		O,
		d
	]), j = !f && T > 1, M = !f && T < O, N = m((e) => {
		s?.(Math.min(Math.max(1, e), O));
	}, [s, O]), P = m((e) => {
		let t = parseInt(e.target.value, 10);
		D(t), h?.(t), s?.(1);
	}, [h, s]);
	return S("div", {
		className: `pagination ${n}`,
		id: e,
		"data-testid": b,
		children: S("div", {
			className: `pagination-container ${t}`,
			children: C("div", {
				className: "pagination-main",
				children: [
					u && S("div", {
						className: "quantityIndicator",
						children: g ? g(...k, r) : r > 0 ? `${k[0].toLocaleString()} - ${k[1].toLocaleString()} of ${r.toLocaleString()}` : "0 items"
					}),
					c && S("div", {
						className: `itemsPerPage ${y} ${f ? "disabled" : ""}`,
						children: C("div", {
							className: "select-wrapper",
							children: [S("span", {
								className: "items-per-page-label",
								children: _
							}), S("select", {
								value: E,
								onChange: P,
								disabled: f,
								children: x.map((e) => S("option", {
									value: e,
									children: e
								}, e))
							})]
						})
					}),
					S("div", {
						className: `pagination-controls ${y}`,
						children: C("ul", {
							className: "controls",
							children: [
								S("li", {
									className: "control",
									children: S("button", {
										className: "controlButton",
										"data-type": "arrow",
										disabled: !j,
										onClick: () => N(1),
										"aria-label": "Go to first page",
										children: S(Nc, { color: "currentColor" })
									})
								}),
								S("li", {
									className: "control",
									children: S("button", {
										className: "controlButton",
										"data-type": "arrow",
										disabled: !j,
										onClick: () => N(T - 1),
										"aria-label": "Go to previous page",
										children: S(Fc, { color: "currentColor" })
									})
								}),
								A.map((t) => S("li", {
									className: "control",
									children: S("button", {
										className: "controlButton",
										"data-type": "number",
										"data-selected": t === T,
										onClick: () => N(t),
										"aria-label": `Go to page ${t}`,
										children: t
									})
								}, `pagination-${e ?? "default"}-page-${t}`)),
								S("li", {
									className: "control",
									children: S("button", {
										className: "controlButton",
										"data-type": "arrow",
										disabled: !M,
										onClick: () => N(T + 1),
										"aria-label": "Go to next page",
										children: S(Lc, { color: "currentColor" })
									})
								}),
								S("li", {
									className: "control",
									children: S("button", {
										className: "controlButton",
										"data-type": "arrow",
										disabled: !M,
										onClick: () => N(O),
										"aria-label": "Go to last page",
										children: S(zc, { color: "currentColor" })
									})
								})
							]
						})
					})
				]
			})
		})
	});
};
Hc.displayName = "ABIPaginationV2";
var Uc = /*#__PURE__*/ Object.freeze({
	__proto__: null,
	default: Hc
}), Wc = l.lazy(() => Promise.resolve().then(function() {
	return jc;
})), Gc = l.lazy(() => Promise.resolve().then(function() {
	return Uc;
})), Kc = (e) => {
	var { version: t = K.V1 } = e, n = Oc(e, ["version"]);
	return S(u, { children: t === K.V2 ? S(Gc, Object.assign({}, n)) : S(Wc, Object.assign({}, n)) });
};
Kc.displayName = "ABIPagination";
var qc = (e, t) => `${e}-${t}`, Jc = (e, t, n, r) => {
	if (!n) return {};
	let i = {};
	return e ? i = { width: typeof e == "number" ? `${e}px` : e } : t && r && (i = { minWidth: typeof t == "number" ? `${t}px` : t }), i;
}, Yc = (e) => {
	let { columns: t, data: n, title: r, dataStyle: i = !0, initialSort: a = {
		field: void 0,
		direction: X.None
	}, onSort: o, loadingComponent: s, loading: c = !1, loadingRows: l = 10, overrideCellPadding: u = !1, centerCells: d = !1, excludeTableHead: p = !1, basicTableStyle: m = !1, className: h, tableClassName: g, headerRowClassName: _, tableHeaderCorner: y = Y.Square, isTableBorder: x = !0, variant: w = sc.Default, isHorizontalScroll: T = !1, cellWidth: E, cellTextNoWrap: D = !1, "data-testid": O } = e, [k, A] = b(a), j = (e, t) => `${i ? "data-style " : ""}${d ? "center-cells " : ""}${u ? "" : "with-padding "}${t ?? ""} ${e ?? ""} `, M = (e, t, n, r) => {
		let i = Reflect.get(e, n), a = Reflect.get(t, n);
		return r ? String(i?.content).localeCompare(String(a?.content)) : String(a?.content).localeCompare(String(i?.content));
	}, N = (e, t, n, r) => {
		let i = Reflect.get(e, n), a = Reflect.get(t, n);
		return r ? Number(i?.content) - Number(a?.content) : Number(a?.content) - Number(i?.content);
	}, P = v(() => {
		let { field: e, direction: r } = k;
		if (o == null && e != null && r !== X.None) {
			let i = [...n], a = t.find((t) => t.accessor === e);
			if (a?.sortType === Js.Alpha || a?.sortType === Js.Numeric) return i.sort((t, n) => {
				let i = r === X.Asc;
				return Object.prototype.hasOwnProperty.call(t.row, e) && Object.prototype.hasOwnProperty.call(n.row, e) ? a.sortType === Js.Alpha ? M(t.row, n.row, e, i) : N(t.row, n.row, e, i) : 0;
			});
		}
		return n;
	}, [
		n,
		k,
		t,
		o
	]), F = (e) => {
		let t = X.None;
		k.field === e ? k.direction === X.None ? t = X.Asc : k.direction === X.Asc && (t = X.Desc) : t = X.Asc, o ? o({
			field: e,
			direction: t
		}) : A({
			field: e,
			direction: t
		});
	}, I = {
		[X.Asc]: " ↑",
		[X.Desc]: " ↓",
		[X.None]: ""
	};
	return S("div", {
		className: `abi-table-wrap abi-table-${w} ${m ? "simple-table" : ""} ${T ? "scrollable-table" : ""} ${h ?? ""} ${D ? "cell-nowrap" : ""}`,
		children: C("table", {
			className: `abi-table-top-${y} ${x ? "abi-table-with-border" : ""} ${g ?? ""}`,
			"data-testid": O,
			children: [
				r && !p && S("caption", {
					className: "header",
					children: r
				}),
				!p && S("thead", { children: S("tr", {
					className: `abi-table-header-${y} ${_ ?? ""}`,
					children: !r && t.map((e, n) => C("th", {
						className: `${e.sortType === void 0 ? "header no-sort" : "header"} ${n === 0 ? "first-col" : ""} ${n === t.length - 1 ? "last-col" : ""} ${d ? "center-cells " : ""} ${e.className ?? ""}`,
						onClick: () => {
							e.sortType !== void 0 && F(e.accessor);
						},
						style: Jc(e.width, E, !p, T),
						children: [e.header, k.field === e.accessor && e.sortType !== void 0 && S("span", {
							className: "sort-icon",
							children: I[k.direction]
						})]
					}, e.accessor))
				}) }),
				S("tbody", { children: c ? Array.from({ length: l }).map((e, n) => S("tr", { children: t.map((e, t) => S("td", { children: s }, qc("skeleton-cell", t))) }, qc("skeleton-row", n))) : P.map((e, n) => S("tr", {
					className: `${i ? "data-style" : ""} ${e.rowClassName ?? ""} ${e.onRowClicked ? "hover-style" : ""}`,
					"data-testid": e.rowTestId,
					onClick: e.onRowClicked,
					children: t.map((t) => e.row[t.accessor] && f("td", Object.assign({}, e.row[t.accessor]?.tdProps, {
						className: j(e.row[t.accessor]?.tdProps?.className, e.row[t.accessor]?.className),
						key: t.accessor,
						style: Jc(t.width, E, p, T),
						"data-testid": e.row[t.accessor]?.cellTestId
					}), e.row[t.accessor]?.content))
				}, e.rowKey ?? qc("data-row", n))) }),
				S("tfoot", { children: S("tr", { className: "footer" }) })
			]
		})
	});
};
Yc.displayName = "ABITableV1";
var Xc = /*#__PURE__*/ Object.freeze({
	__proto__: null,
	default: Yc
}), Zc = "data:image/svg+xml,%3csvg focusable='false' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'%3e%3c/path%3e%3c/svg%3e", Qc = "data:image/svg+xml,%3csvg focusable='false' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'%3e%3c/path%3e%3c/svg%3e", $c = 2, el = (e, t) => {
	let n;
	return (...r) => {
		clearTimeout(n), n = setTimeout(() => {
			e(...r);
		}, t);
	};
}, tl = (e, t) => `${e}-${t}`, nl = (e) => {
	let { id: t, corner: n = Y.Round, className: r = "", placeholder: i, suggestions: a = [], selectedValue: o = "", onChange: s = () => null, onFilterChange: c = () => null, suggestionTimeout: l = 3e3, onchangeTimeout: u = 300, "data-testid": d, allowSuggestionsOnly: f, maxResultRows: p, disabled: h = !1, searchIcon: _ = !1, label: v, values: y = [{
		value: "string",
		label: "string",
		hidden: !1
	}], hiddenOption: x, required: w = !1, isLabelLeft: T = !1, filter: E = !1, isBorderLight: D = !1, bottomBorderOnly: O = !1, suggestionListZIndex: k } = e, [A, j] = b(o), [M, N] = b([]), [P, F] = b(!1), [I, L] = b(""), R = m(el((e) => {
		s(e);
	}, u), [s]);
	g(() => {
		j(o);
	}, [o]), g(() => {
		let e;
		return !P && M.length > 0 && (e = setTimeout(() => {
			N([]);
		}, l)), () => {
			clearTimeout(e);
		};
	}, [M, P]);
	let z = (e) => {
		let t = e.target.value;
		j(t), R(t), t.length > 0 && a.length > 0 ? N(a.filter((e) => e.toLowerCase().includes(t.toLowerCase()))) : N([]);
	}, ee = (e) => {
		P || N([]), f && a.length > 0 && (a.includes(e) || j(""));
	}, B = (e) => {
		j(e), N([]), s(e), ee(e);
	}, V = () => {
		h || (j(""), N([]), s(""));
	};
	return C("div", {
		className: "abi-search-bar-container " + (O ? "abi-search-border-bottom " : `abi-${n} `) + `${h ? "abi-search-bar-disabled " : ""}${T ? "abi-search-label-left " : ""}${D ? "border-light " : ""} ${r}`,
		children: [v && C("label", {
			className: "abi-search-bar-label",
			htmlFor: t,
			children: [
				v,
				" ",
				v && w && S("sup", { children: "*" })
			]
		}), C("div", {
			id: t,
			className: "abi-search-bar",
			children: [
				E && S("div", {
					className: `abi-select-wrapper ${n === "round" ? "round" : "square"}`,
					children: S("select", {
						value: I,
						onChange: (e) => {
							let t = e.target.value;
							L(t), c && c(t);
						},
						children: y.map((e) => S("option", {
							disabled: e.disabled,
							hidden: e.value === x,
							value: e.value || e.label,
							children: e.label
						}, e.key || e.value))
					})
				}),
				_ && S("span", {
					"aria-hidden": "true",
					className: h ? "search-icon-disabled" : "",
					onClick: V,
					onKeyDown: V,
					children: S("img", {
						src: Zc,
						alt: "search"
					})
				}),
				S("input", {
					type: "text",
					value: A,
					onChange: z,
					placeholder: i,
					onFocus: () => {
						F(!0);
					},
					onKeyDown: (e) => {
						e.key === "Enter" && M.length > 0 && B(M[0]);
					},
					onBlur: (e) => ee(e.target.value),
					"data-testid": d,
					disabled: h
				}),
				A.length > 0 && S("span", {
					"aria-hidden": "true",
					className: h ? "search-icon-disabled" : "",
					onClick: V,
					onKeyDown: V,
					children: S("img", {
						src: Qc,
						alt: "cancel"
					})
				}),
				!_ && A.length === 0 && S("span", {
					"aria-hidden": "true",
					className: h ? "search-icon-disabled" : "",
					onClick: V,
					onKeyDown: V,
					children: S("img", {
						src: Zc,
						alt: "search"
					})
				}),
				M.length > 0 && S("ul", {
					"aria-hidden": "true",
					className: "suggestion-list",
					style: {
						height: p ? ((e) => {
							let t = `${M.length * $c}rem`, n = `${e * $c}rem`;
							return M.length > e ? n : t;
						})(p) : void 0,
						zIndex: k || void 0
					},
					onMouseEnter: () => {
						F(!0);
					},
					onMouseLeave: () => {
						F(!1);
					},
					children: M.map((e, t) => S("li", {
						"aria-hidden": "true",
						onClick: () => {
							B(e);
						},
						onKeyDown: (t) => {
							t.key === "Enter" && B(e);
						},
						children: e
					}, tl("suggestion-list", t)))
				})
			]
		})]
	});
}, rl = (e, t) => {
	let [n, r] = b(""), i = (e, t) => {
		let n = 0, r = e.toLowerCase(), i = t.toLowerCase();
		for (let e of r) if (e === i[n] && (n++, n === i.length)) return !0;
		return !1;
	};
	return {
		searchTerm: n,
		setSearchTerm: r,
		filteredData: v(() => e ? n ? e.filter((e) => {
			let r = t(e);
			return i(r, n);
		}) : e : [], [
			e,
			n,
			t
		])
	};
}, il = "16px", al = ({ className: e, width: t = il, height: n, color: r, isLight: i = !1 }) => {
	let a = r || (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n || "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 -960 960 960",
		children: S("path", { d: "M479.858-160Q460-160 446-174.142q-14-14.141-14-34Q432-228 446.142-242q14.141-14 34-14Q500-256 514-241.858q14 14.141 14 34Q528-188 513.858-174q-14.141 14-34 14Zm0-272Q460-432 446-446.142q-14-14.141-14-34Q432-500 446.142-514q14.141-14 34-14Q500-528 514-513.858q14 14.141 14 34Q528-460 513.858-446q-14.141 14-34 14Zm0-272Q460-704 446-718.142q-14-14.141-14-34Q432-772 446.142-786q14.141-14 34-14Q500-800 514-785.858q14 14.141 14 34Q528-732 513.858-718q-14.141 14-34 14Z" })
	});
}, ol = "16px", sl = ({ className: e, width: t = ol, height: n, color: r, isLight: i = !1 }) => {
	let a = r || (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n || "auto"
		},
		className: e,
		viewBox: "0 0 13 13",
		fill: a,
		children: S("path", {
			d: "M7.35715 9.08071L7.35715 10.9663L6.41434 11.9091L4.05732 9.55211L1.22889 12.3805L0.28608 12.3805L0.28608 11.4377L3.11451 8.6093L0.757484 6.25228L1.70029 5.30947L3.58591 5.30947L6.88574 2.00964L6.41434 1.53824L7.35715 0.595428L12.0712 5.30947L11.1284 6.25228L10.657 5.78088L7.35715 9.08071Z",
			fill: "#1F1F1F"
		})
	});
}, cl = "16px", ll = ({ className: e, width: t = cl, height: n, color: r, isLight: i = !1 }) => {
	let a = r || (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n || "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 13 13",
		children: S("path", { d: "M1 3.5L4.33333 0L7.66667 3.5L6.73333 4.4975L5 2.6775L5 13.3H3.66667L3.66667 2.6775L1.93333 4.4975L1 3.5ZM6.33333 10.5L7.26667 9.5025L9 11.3225V0.7L10.3333 0.7L10.3333 11.3225L12.0667 9.5025L13 10.5L9.66667 14L6.33333 10.5Z" })
	});
}, ul = "16px", dl = ({ className: e, width: t = ul, height: n, color: r, isLight: i = !1 }) => {
	let a = r || (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n || "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 -960 960 960",
		children: S("path", { d: "M400-240v-80h160v80H400ZM240-440v-80h480v80H240ZM120-640v-80h720v80H120Z" })
	});
}, fl = "16px", pl = ({ className: e, width: t = fl, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 24 24",
		children: S("path", { d: "M0 2.25C0 1.00736 1.00736 0 2.25 0H21.75C22.9926 0 24 1.00736 24 2.25V21.75C24 22.9926 22.9926 24 21.75 24H2.25C1.00736 24 0 22.9926 0 21.75V2.25ZM2.25 1.5C1.83579 1.5 1.5 1.83579 1.5 2.25V21.75C1.5 22.1642 1.83579 22.5 2.25 22.5H7.5V1.5H2.25ZM15 22.5V1.5H9V22.5H15ZM16.5 22.5H21.75C22.1642 22.5 22.5 22.1642 22.5 21.75V2.25C22.5 1.83579 22.1642 1.5 21.75 1.5H16.5V22.5Z" })
	});
};
function ml(e, t) {
	let n;
	return (r) => {
		clearTimeout(n), n = setTimeout(() => e(r), t);
	};
}
var hl = ({ onPin: e, onSort: t, onHide: n, onFilter: r, onOpenFilter: i, onCloseFilter: a, isPinned: o, isSorted: s, sortDirection: c, columnData: l, isFilterActive: u, currentFilters: d = [], showMoreIcon: f = !0, isLocked: p = !1 }) => {
	let [h, _] = b(!1), [v, w] = b([]), T = y(null), E = y(null), D = y(null), O = y(null), { setSearchTerm: k, filteredData: A } = rl(l, (e) => e), j = m(ml((e) => {
		k(e);
	}, 300), [k]);
	g(() => {
		u ? (w(d), _(!0)) : (w([]), k(""));
	}, [
		u,
		d,
		k
	]), g(() => {
		let e = (e) => {
			T.current && !T.current.contains(e.target) && (_(!1), u && a());
		};
		return document.addEventListener("mousedown", e), () => document.removeEventListener("mousedown", e);
	}, [u, a]), g(() => {
		O.current && (O.current.indeterminate = v.length > 0 && v.length < l.length);
	}, [v, l.length]), g(() => {
		let e = (e) => {
			if (!e) return;
			let t = e.closest(".abi-table-container");
			if (!t) return;
			let n = e.getBoundingClientRect(), r = t.getBoundingClientRect();
			if (n.left < r.left) {
				let t = r.left - n.left;
				e.style.transform = `translateX(${t}px)`;
			} else if (n.right > r.right) {
				let t = r.right - n.right;
				e.style.transform = `translateX(${t}px)`;
			} else e.style.transform = "translateX(0)";
		};
		return h && (u && D.current ? e(D.current) : !u && E.current && e(E.current)), () => {
			E.current && (E.current.style.transform = "translateX(0)"), D.current && (D.current.style.transform = "translateX(0)");
		};
	}, [h, u]);
	let M = () => {
		r(v), _(!1), a();
	}, N = () => {
		w([]), k("");
	}, P = (e) => {
		w((t) => t.includes(e) ? t.filter((t) => t !== e) : [...t, e]);
	}, F = () => {
		w((e) => e.length === l.length ? [] : [...l]);
	}, I = () => {
		u || _((e) => !e);
	}, L = () => s ? c === "asc" ? "Sort Descending" : "Clear Sort" : "Sort Ascending", R = A.sort(), z = l.length > 0 && v.length === l.length;
	return C("div", {
		className: "dropdown",
		ref: T,
		children: [f && S("button", {
			className: "dropdown-toggle",
			onClick: I,
			onKeyDown: (e) => e.key === "Enter" && I(),
			"aria-label": "Open column options",
			"aria-expanded": h,
			children: S(al, { color: "currentColor" })
		}), h && f && C(x, { children: [!u && C("div", {
			className: "dropdown-menu",
			ref: E,
			role: "menu",
			children: [
				C("button", {
					className: "dropdown-item",
					onClick: () => {
						e(), _(!1);
					},
					onKeyDown: (t) => t.key === "Enter" && (e(), _(!1)),
					role: "menuitem",
					children: [S(sl, {
						color: "currentColor",
						height: 14,
						width: 14
					}), S("span", { children: o ? "Unpin Column" : "Pin Column" })]
				}),
				C("button", {
					className: "dropdown-item",
					onClick: () => {
						t(), _(!1);
					},
					onKeyDown: (e) => e.key === "Enter" && (t(), _(!1)),
					role: "menuitem",
					children: [S(ll, {
						color: "currentColor",
						height: 14,
						width: 14
					}), S("span", { children: L() })]
				}),
				!p && C("button", {
					className: "dropdown-item",
					onClick: () => {
						n(), _(!1);
					},
					onKeyDown: (e) => e.key === "Enter" && (n(), _(!1)),
					role: "menuitem",
					children: [S(pl, {
						color: "currentColor",
						height: 14,
						width: 14
					}), S("span", { children: "Hide Column" })]
				}),
				C("button", {
					className: "dropdown-item",
					onClick: () => {
						i(), _(!0);
					},
					onKeyDown: (e) => e.key === "Enter" && (i(), _(!0)),
					role: "menuitem",
					children: [S(dl, {
						color: "currentColor",
						height: 14,
						width: 14
					}), S("span", { children: "Filter Column" })]
				})
			]
		}), u && S("div", {
			className: "dropdown-menu",
			ref: D,
			role: "menu",
			children: C("div", {
				className: "filter-dropdown",
				children: [
					S("div", {
						className: "filter-search",
						children: S(nl, {
							placeholder: "Search",
							onChange: j,
							suggestions: [],
							searchIcon: !0,
							isBorderLight: !0,
							corner: Y.Square
						})
					}),
					C("div", {
						className: "filter-options",
						"aria-label": "Filter options",
						children: [R.length > 0 && C("div", {
							className: "filter-option",
							"aria-label": "Select all",
							children: [S("input", {
								type: "checkbox",
								id: "filter-all",
								ref: O,
								checked: z,
								onChange: F,
								"aria-label": "Select all options"
							}), S("label", {
								htmlFor: "filter-all",
								children: "Select all"
							})]
						}), R.length > 0 ? R.map((e) => C("div", {
							className: "filter-option",
							"aria-label": `Select ${e}`,
							children: [S("input", {
								type: "checkbox",
								id: `filter-${e}`,
								checked: v.includes(e),
								onChange: () => P(e),
								"aria-label": `Select ${e}`
							}), S("div", {
								className: "text-wrapper",
								children: S("label", {
									htmlFor: `filter-${e}`,
									children: e
								})
							})]
						}, e)) : S("div", {
							className: "no-options",
							children: "No options found"
						})]
					}),
					C("div", {
						className: "filter-actions",
						children: [S(xc, {
							variant: J.Secondary,
							onClick: N,
							size: q.sm,
							className: "clear-button",
							children: "Clear"
						}), S(xc, {
							variant: J.Primary,
							onClick: M,
							size: q.sm,
							className: "apply-button",
							children: "Apply"
						})]
					})
				]
			})
		})] })]
	});
}, gl = ({ id: e, type: t = Us.Primary, size: n = Ws.Medium, "data-testid": r, className: i }) => {
	let a = v(() => {
		let e = [];
		for (let t = 0; t < 8; t++) e.push(S("div", {}, `spinner-${Math.random().toString(36).slice(2, 11)}`));
		return e;
	}, []);
	return S("div", {
		id: e,
		className: `abi-loading-spinner ${i || ""}`,
		"data-size": n,
		"data-testid": r,
		children: S("div", {
			className: "loading-spinner",
			"data-type": t,
			"data-size": n,
			children: a
		})
	});
}, _l = "16px", vl = ({ className: e, width: t = _l, height: n, color: r, isLight: i = !1 }) => {
	let a = r || (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n || "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 -960 960 960",
		children: S("path", { d: "M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" })
	});
}, yl = ({ message: e, type: t, duration: n, icon: r = S(vl, {
	width: "20px",
	height: "20px",
	color: "#fff"
}), onClose: i, id: a, "data-testid": o, className: s = "" }) => {
	let [c, l] = b(100), [u, d] = b(!1);
	return g(() => {
		let e = setInterval(() => {
			l((e) => Math.max(e - 1, 0));
		}, n / 100), t = setTimeout(() => {
			d(!0), setTimeout(i, 500);
		}, n);
		return () => {
			clearInterval(e), clearTimeout(t);
		};
	}, [n, i]), C("div", {
		className: `abi-toast-container toast-${t} ${u ? "hide" : ""} ${s}`,
		id: a,
		"data-testid": o,
		children: [
			C("div", {
				className: "toast-content",
				children: [r && S("span", {
					className: "toast-icon",
					children: r
				}), S("span", {
					className: "toast-message",
					children: e
				})]
			}),
			S("button", {
				className: "toast-close-button",
				onClick: () => d(!0),
				children: "×"
			}),
			S("div", {
				className: "toast-progress",
				style: { width: `${c}%` }
			})
		]
	});
}, Q;
(function(e) {
	e.AllData = "allData", e.PageRows = "pageRows", e.SelectedRows = "selectedRows";
})(Q ||= {});
var bl;
(function(e) {
	e.CSV = "csv", e.Excel = "excel";
})(bl ||= {});
var xl = [
	{
		value: Q.AllData,
		label: "All Data",
		disabled: !1
	},
	{
		value: Q.PageRows,
		label: "Page Rows",
		disabled: !1
	},
	{
		value: Q.SelectedRows,
		label: "Selected Rows",
		disabled: !0
	}
], Sl = [{
	value: bl.CSV,
	label: ".csv"
}, {
	value: bl.Excel,
	label: ".xlsx"
}], Cl = ({ data: e, columns: t, filename: n = "table-export", paginatedData: r = [], selectedRows: i = [] }) => {
	let [a, o] = b(!1), [s, c] = b(!1), [l, u] = b(bl.CSV), [d, f] = b(Q.AllData), p = () => {
		o((e) => !e);
	}, m = (e) => {
		let t = [Object.keys(e[0]).join(","), ...e.map((e) => Object.values(e).map((e) => typeof e == "string" ? `"${e.replace(/"/g, "\"\"")}"` : e).join(","))].join("\n"), r = new Blob([t], { type: "text/csv;charset=utf-8;" }), i = document.createElement("a"), a = URL.createObjectURL(r);
		i.setAttribute("href", a), i.setAttribute("download", `${n}.${l}`), i.style.visibility = "hidden", document.body.appendChild(i), i.click(), document.body.removeChild(i);
	}, h = (e) => {
		let t = [Object.keys(e[0]).join("	"), ...e.map((e) => Object.values(e).map((e) => typeof e == "string" ? e.replace(/\t/g, " ") : e).join("	"))].join("\n"), r = new Blob([t], { type: "application/vnd.ms-excel" }), i = document.createElement("a"), a = URL.createObjectURL(r);
		i.setAttribute("href", a), i.setAttribute("download", `${n}.${l}`), i.style.visibility = "hidden", document.body.appendChild(i), i.click(), document.body.removeChild(i);
	}, g = () => {
		if (!d || !l) {
			c(!0), o(!1);
			return;
		}
		if (e.length === 0) {
			c(!0), o(!1);
			return;
		}
		let n = t.map((e) => ({
			label: typeof e.title == "string" ? e.title : e.dataIndex,
			key: e.dataIndex
		})), a = e.map((e) => {
			let t = {};
			return n.forEach((n) => {
				t[n.label] = e[n.key];
			}), t;
		});
		if (d === Q.PageRows) a = r;
		else if (d === Q.SelectedRows && (a = i.map((e) => {
			let t = {};
			return n.forEach((n) => {
				t[n.label] = e[n.key];
			}), t;
		}), a.length === 0)) {
			c(!0), o(!1);
			return;
		}
		l === bl.CSV ? m(a) : l === bl.Excel && h(a), o(!1);
	}, _ = d === Q.SelectedRows && i.length === 0, v = xl.map((e) => e.value === Q.SelectedRows ? Object.assign(Object.assign({}, e), { disabled: i.length === 0 }) : e);
	return C("div", {
		className: "export-wrapper",
		children: [
			C("button", {
				className: "export-button",
				onClick: p,
				"aria-label": "Export options",
				children: ["Export", S(ks, {
					height: 12,
					width: 12,
					color: "currentColor"
				})]
			}),
			a && C("div", {
				className: "export-dropdown",
				children: [
					C("div", {
						className: "dropdown-section",
						children: [S("span", {
							className: "dropdown-label",
							children: "Data to export"
						}), S("select", {
							className: "export-option",
							onChange: (e) => f(e.target.value),
							value: d,
							children: v.map((e) => S("option", {
								value: e.value,
								disabled: e.disabled,
								children: e.label
							}, e.value))
						})]
					}),
					C("div", {
						className: "dropdown-section",
						children: [S("span", {
							className: "dropdown-label",
							children: "Filetype"
						}), S("select", {
							className: "export-option",
							onChange: (e) => u(e.target.value),
							value: l,
							children: Sl.map((e) => S("option", {
								value: e.value,
								children: e.label
							}, e.value))
						})]
					}),
					S("div", {
						className: "export-action",
						children: C("button", {
							className: "export-button export-button--download",
							onClick: g,
							disabled: _,
							children: ["Download", S(Os, {
								height: 16,
								width: 16,
								color: "currentColor"
							})]
						})
					})
				]
			}),
			s && S(yl, {
				message: "No data available to export",
				type: _c.Warning,
				duration: 3e3,
				onClose: () => c(!1)
			})
		]
	});
}, wl = ({ columns: e, hiddenColumnKeys: t, onToggleColumnVisibility: n }) => {
	let [r, i] = b(!1), a = y(null);
	return g(() => {
		let e = (e) => {
			a.current && !a.current.contains(e.target) && i(!1);
		};
		return document.addEventListener("mousedown", e), () => document.removeEventListener("mousedown", e);
	}, []), C("div", {
		className: "tune-dropdown",
		ref: a,
		children: [S("button", {
			className: "tune-toggle",
			onClick: () => i(!r),
			"aria-label": "Toggle column visibility",
			children: S(pl, {
				height: 14,
				width: 14,
				color: "currentColor"
			})
		}), r && S("div", {
			className: "tune-menu",
			children: e.map((e) => C("div", {
				className: "tune-option",
				children: [S("input", {
					type: "checkbox",
					checked: !t.includes(e.key),
					onChange: (t) => !e.isLocked && n(e.key, t.target.checked),
					disabled: e.isLocked,
					className: e.isLocked ? "disabled" : ""
				}), S("label", { children: e.title })]
			}, e.key))
		})]
	});
}, Tl = "16px", El = ({ className: e, width: t = Tl, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 24 24",
		children: [
			S("path", { d: "M5.41344 20.3922C5.14566 20.6313 4.71149 20.6313 4.4437 20.3922L1.70084 17.9433C1.43305 17.7042 1.43305 17.3165 1.70084 17.0774C1.96863 16.8383 2.4028 16.8383 2.67059 17.0774L4.24286 18.4812L4.24286 5.51905L2.67059 6.92286C2.4028 7.16196 1.96863 7.16196 1.70084 6.92286C1.43305 6.68376 1.43305 6.29611 1.70084 6.05701L4.4437 3.60803C4.71149 3.36894 5.14566 3.36894 5.41344 3.60803L8.1563 6.05701C8.42409 6.29611 8.42409 6.68376 8.1563 6.92286C7.88851 7.16196 7.45434 7.16196 7.18655 6.92286L5.61428 5.51905L5.61429 18.4812L7.18655 17.0774C7.45434 16.8383 7.88851 16.8383 8.1563 17.0774C8.42409 17.3165 8.42409 17.7042 8.1563 17.9433L5.41344 20.3922Z" }),
			S("rect", {
				x: "10.0723",
				y: "3.42871",
				width: "12.4286",
				height: "1.71429",
				rx: "0.857143"
			}),
			S("rect", {
				x: "10.0723",
				y: "18.8574",
				width: "12.4286",
				height: "1.71429",
				rx: "0.857143"
			})
		]
	});
}, Dl = "16px", Ol = ({ className: e, width: t = Dl, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 24 24",
		children: [
			S("path", { d: "M5.41344 20.3922C5.14566 20.6313 4.71149 20.6313 4.4437 20.3922L1.70084 17.9433C1.43305 17.7042 1.43305 17.3165 1.70084 17.0774C1.96863 16.8383 2.4028 16.8383 2.67059 17.0774L4.24286 18.4812L4.24286 5.51905L2.67059 6.92286C2.4028 7.16196 1.96863 7.16196 1.70084 6.92286C1.43305 6.68376 1.43305 6.29611 1.70084 6.05701L4.4437 3.60803C4.71149 3.36894 5.14566 3.36894 5.41344 3.60803L8.1563 6.05701C8.42409 6.29611 8.42409 6.68376 8.1563 6.92286C7.88851 7.16196 7.45434 7.16196 7.18655 6.92286L5.61428 5.51905L5.61429 18.4812L7.18655 17.0774C7.45434 16.8383 7.88851 16.8383 8.1563 17.0774C8.42409 17.3165 8.42409 17.7042 8.1563 17.9433L5.41344 20.3922Z" }),
			S("rect", {
				x: "10.0723",
				y: "3.42871",
				width: "12.4286",
				height: "1.71429",
				rx: "0.857143"
			}),
			S("rect", {
				x: "10.0723",
				y: "8.57178",
				width: "12.4286",
				height: "1.71429",
				rx: "0.857143"
			}),
			S("rect", {
				x: "10.0723",
				y: "13.7144",
				width: "12.4286",
				height: "1.71429",
				rx: "0.857143"
			}),
			S("rect", {
				x: "10.0723",
				y: "18.8574",
				width: "12.4286",
				height: "1.71429",
				rx: "0.857143"
			})
		]
	});
}, kl = "16px", Al = ({ className: e, width: t = kl, height: n, color: r, isLight: i = !1 }) => {
	let a = r ?? (i ? "#FFFFFF" : "#000000");
	return C("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n ?? "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 0 24 24",
		children: [
			S("path", { d: "M5.41344 20.3922C5.14566 20.6313 4.71149 20.6313 4.4437 20.3922L1.70084 17.9433C1.43305 17.7042 1.43305 17.3165 1.70084 17.0774C1.96863 16.8383 2.4028 16.8383 2.67059 17.0774L4.24286 18.4812L4.24286 5.51905L2.67059 6.92286C2.4028 7.16196 1.96863 7.16196 1.70084 6.92286C1.43305 6.68376 1.43305 6.29611 1.70084 6.05701L4.4437 3.60803C4.71149 3.36894 5.14566 3.36894 5.41344 3.60803L8.1563 6.05701C8.42409 6.29611 8.42409 6.68376 8.1563 6.92286C7.88851 7.16196 7.45434 7.16196 7.18655 6.92286L5.61428 5.51905L5.61429 18.4812L7.18655 17.0774C7.45434 16.8383 7.88851 16.8383 8.1563 17.0774C8.42409 17.3165 8.42409 17.7042 8.1563 17.9433L5.41344 20.3922Z" }),
			S("rect", {
				x: "10.0723",
				y: "4.28809",
				width: "12.4259",
				height: "1.71",
				rx: "0.855"
			}),
			S("rect", {
				x: "10.2891",
				y: "11.1465",
				width: "12.2118",
				height: "1.71",
				rx: "0.855"
			}),
			S("rect", {
				x: "10.0723",
				y: "18.002",
				width: "12.4259",
				height: "1.71",
				rx: "0.855"
			})
		]
	});
}, $;
(function(e) {
	e.Low = "low", e.Medium = "medium", e.High = "high";
})($ ||= {});
var jl = ({ columns: e, data: t, "data-testid": n, className: r = "", showSearch: i = !1, showCheckbox: a = !1, showPagination: o = !0, defaultPageSize: s = 10, itemsPerPageOptions: c = [
	5,
	10,
	20,
	50
], showExport: u = !1, loader: d = !1, showRowDensity: f = !1, showFullScreen: p = !1, expandable: h, onRowClick: _, loadingComponent: y }) => {
	let [x, w] = b([]), [T, E] = b([]), [D, O] = b([]), [k, A] = b(null), [j, M] = b({}), [N, P] = b(1), [F, I] = b(s), [L, R] = b(null), [z, ee] = b($.Medium), [B, V] = b(!1), [te, ne] = b([]);
	g(() => {
		let e = () => {
			V(!!document.fullscreenElement);
		};
		return document.addEventListener("fullscreenchange", e), () => {
			document.removeEventListener("fullscreenchange", e);
		};
	}, []);
	let H = v(() => Ml(e.map((e) => Object.assign(Object.assign({}, e), { width: e.width ?? 150 })).filter((e) => !D.includes(e.key)), T), [
		e,
		T,
		D
	]), { setSearchTerm: re, filteredData: ie } = rl(t, Nl), ae = m(ml((e) => {
		re(e);
	}, 300), [re]), oe = v(() => Pl(t, e), [t, e]), U = v(() => Fl(ie, j, k, e), [
		ie,
		j,
		k,
		e
	]), se = v(() => o ? Kl(U, N, F) : U, [
		U,
		N,
		F,
		o
	]);
	g(() => {
		P(1);
	}, [U.length]);
	let ce = Math.ceil(U.length / F);
	g(() => {
		N > ce && ce > 0 && P(ce);
	}, [
		N,
		ce,
		F,
		U.length
	]);
	let le = (e) => {
		w((t) => t.includes(e) ? t.filter((t) => t !== e) : [...t, e]);
	}, ue = () => {
		w((e) => e.length === U.length ? [] : U.map((e) => e.key));
	}, de = (e) => {
		E((t) => t.includes(e) ? t.filter((t) => t !== e) : [...t, e]);
	}, fe = (e) => {
		A((t) => !t || t.key !== e ? {
			key: e,
			direction: "asc"
		} : t.direction === "asc" ? {
			key: e,
			direction: "desc"
		} : null);
	}, pe = (e) => {
		O((t) => [...t, e]);
	}, W = {
		clear: (e) => {
			M((t) => {
				let n = Object.assign({}, t);
				return delete n[e], n;
			}), R(null), document.querySelector(".table-scroll-container")?.classList.remove("filter-active");
		},
		apply: (e) => (t) => {
			M((n) => Object.assign(Object.assign({}, n), { [e]: t })), P(1), R(null), document.querySelector(".table-scroll-container")?.classList.remove("filter-active");
		},
		open: (e) => {
			R(e), document.querySelector(".table-scroll-container")?.classList.add("filter-active");
		},
		close: () => {
			R(null), document.querySelector(".table-scroll-container")?.classList.remove("filter-active");
		}
	}, me = () => {
		ee((e) => e === $.Low ? $.Medium : e === $.Medium ? $.High : $.Low);
	}, he = () => {
		switch (z) {
			case $.Low: return S(Ol, {
				height: 14,
				width: 14
			});
			case $.Medium: return S(Al, {
				height: 14,
				width: 14
			});
			case $.High: return S(El, {
				height: 14,
				width: 14
			});
			default: return S(Al, {
				height: 14,
				width: 14
			});
		}
	}, ge = () => {
		let e = document.querySelector(".abi-table-container");
		e && (document.fullscreenElement ? document.exitFullscreen().catch((e) => console.error(e)) : e.requestFullscreen().catch((e) => console.error(e)));
	}, _e = () => S(B ? No : jo, {
		height: 14,
		width: 14
	}), ve = (e) => {
		ne((t) => t.includes(e) ? t.filter((t) => t !== e) : [...t, e]);
	}, ye = U.length > 0 && x.length === U.length, be = x.length > 0 && x.length < U.length, xe = i || u || a && x.length > 0 || f || p || D.length > 0;
	return C("div", {
		className: `abi-table-container ${r} ${f ? `density-${z}` : "density-medium"} ${B ? "fullscreen" : ""} ${a ? "" : "no-checkbox"}`,
		"data-testid": n,
		children: [
			xe && C("div", {
				className: "table-header-actions",
				children: [S("div", {
					className: "left-actions",
					children: i && S(nl, {
						placeholder: "Search",
						onChange: ae,
						suggestions: [],
						searchIcon: !0,
						className: "search-bar",
						isBorderLight: !0,
						corner: Y.Square
					})
				}), C("div", {
					className: "right-actions",
					children: [
						D.length > 0 && S(wl, {
							columns: e,
							hiddenColumnKeys: D,
							onToggleColumnVisibility: (e, t) => {
								O((n) => t ? n.filter((t) => t !== e) : [...n, e]);
							}
						}),
						a && x.length > 0 && S("span", {
							className: "selected-rows-count",
							children: `${x.length} row${x.length === 1 ? "" : "s"} selected`
						}),
						f && S("button", {
							className: "density-toggle",
							onClick: me,
							"aria-label": `Toggle density (current: ${z})`,
							children: he()
						}),
						p && S("button", {
							className: "fullscreen-toggle",
							onClick: ge,
							"aria-label": `Toggle fullscreen (current: ${B ? "exit" : "enter"})`,
							children: _e()
						}),
						u && S(Cl, {
							data: t,
							columns: H,
							filename: `report-${(/* @__PURE__ */ new Date()).toISOString().slice(0, 10)}`,
							paginatedData: se,
							selectedRows: x.map((e) => t.find((t) => t.key === e) ?? {})
						})
					]
				})]
			}),
			S("div", {
				className: `table-scroll-container ${se.length === 0 ? "no-data" : ""}`,
				children: C("table", {
					className: "abi-table",
					children: [S("thead", { children: C("tr", { children: [
						a && S("th", {
							className: "checkbox-column",
							children: S("input", {
								type: "checkbox",
								checked: ye,
								ref: (e) => e && (e.indeterminate = be),
								onChange: ue
							})
						}),
						h && S("th", { className: "expand-column" }),
						H.length > 0 ? H.map((e) => {
							let t = T.includes(e.key);
							return S("th", {
								className: `${e.className || ""} ${t ? "pinned-column" : ""} ${L === e.dataIndex ? "filter-active" : ""}`,
								style: Object.assign({ width: e.width ?? "auto" }, t && { left: `${T.indexOf(e.key) * 50 + (a ? 50 : 0) + (h ? 40 : 0)}px` }),
								children: C("div", {
									className: "th-content",
									children: [S("span", {
										className: "title-wrapper",
										children: e.title
									}), C("div", {
										className: "icons-wrapper",
										role: "toolbar",
										tabIndex: 0,
										children: [
											t && S("button", {
												className: `action-icon-wrapper ${t ? "active" : ""}`,
												onClick: () => de(e.key),
												onKeyDown: (t) => t.key === "Enter" && de(e.key),
												"aria-label": "Toggle pin column",
												children: S(sl, {
													color: "currentColor",
													className: "action-icon",
													height: 14
												})
											}),
											k?.key === e.dataIndex && S("button", {
												className: `action-icon-wrapper ${k?.key === e.dataIndex ? "active" : ""}`,
												onClick: () => fe(e.dataIndex),
												onKeyDown: (t) => t.key === "Enter" && fe(e.dataIndex),
												"aria-label": "Toggle sort",
												children: S(ll, { height: 12 })
											}),
											j[e.dataIndex]?.length > 0 && S("button", {
												className: `action-icon-wrapper ${j[e.dataIndex]?.length > 0 ? "active" : ""}`,
												onClick: () => W.clear(e.dataIndex),
												onKeyDown: (t) => t.key === "Enter" && W.clear(e.dataIndex),
												"aria-label": "Clear filter",
												children: S(dl, { height: 16 })
											}),
											S(hl, {
												onPin: () => de(e.key),
												onSort: () => fe(e.dataIndex),
												onHide: () => pe(e.key),
												onFilter: W.apply(e.dataIndex),
												onOpenFilter: () => W.open(e.dataIndex),
												onCloseFilter: W.close,
												isPinned: t,
												isSorted: k?.key === e.dataIndex,
												sortDirection: k?.direction,
												columnData: oe[e.dataIndex] ?? [],
												isFilterActive: L === e.dataIndex,
												currentFilters: j[e.dataIndex] ?? [],
												showMoreIcon: e.showMoreIcon ?? !0,
												isLocked: e.isLocked ?? !1
											})
										]
									})]
								})
							}, e.key);
						}) : S("th", {
							className: "empty-header",
							colSpan: e.length ?? 1,
							children: "No Columns Available"
						})
					] }) }), S("tbody", { children: d ? S("tr", {
						className: "loading-row",
						children: S("td", {
							colSpan: e.length + +!!a + +!!h,
							children: S("div", {
								className: "spinner-container",
								children: y ?? S(gl, {
									size: Ws.Large,
									type: Us.Primary,
									className: "table-spinner"
								})
							})
						})
					}) : H.length === 0 ? Array.from({ length: F }, (t, n) => C("tr", {
						className: "empty-row",
						children: [
							a && S("td", { className: "checkbox-column" }),
							h && S("td", { className: "expand-column" }),
							S("td", {
								className: "empty-cell",
								colSpan: e.length ?? 1
							})
						]
					}, `empty-${n}`)) : se.length === 0 ? S("tr", {
						className: "no-data-row",
						children: S("td", {
							colSpan: H.length + +!!a + +!!h,
							className: "no-data",
							children: "No Data Available"
						})
					}) : se.map((e, t) => {
						let n = te.includes(e.key), r = (h?.rowExpandable)?.call(h, e) ?? !0;
						return C(l.Fragment, { children: [C("tr", {
							className: x.includes(e.key) ? "highlighted-row" : "",
							onClick: (n) => {
								_ && !(n.target instanceof HTMLInputElement) && !(n.target instanceof HTMLButtonElement) && n.target instanceof Element && !n.target.closest(".expand-button") && !n.target.closest(".checkbox-column") && _(e, t, n);
							},
							style: _ ? { cursor: "pointer" } : void 0,
							children: [
								a && S("td", {
									className: "checkbox-column",
									children: S("input", {
										type: "checkbox",
										checked: x.includes(e.key),
										onChange: () => le(e.key)
									})
								}),
								h && S("td", {
									className: "expand-column",
									children: r ? S("button", {
										className: "expand-button",
										onClick: () => ve(e.key),
										"aria-label": n ? "Collapse row" : "Expand row",
										children: S(n ? As : ks, {
											height: 24,
											width: 24,
											color: "#000000"
										})
									}) : S("span", { "aria-label": "This row cannot be expanded" })
								}),
								H.map((n) => {
									let r = T.includes(n.key);
									return S("td", {
										className: r ? "pinned-column" : "",
										style: Object.assign({ width: n.width ?? "auto" }, r && { left: `${T.indexOf(n.key) * 50 + (a ? 50 : 0) + (h ? 40 : 0)}px` }),
										children: n.render ? n.render(e[n.dataIndex], e, t) : String(e[n.dataIndex] ?? "")
									}, n.key);
								})
							]
						}), n && r && h && S("tr", {
							className: "expanded-row",
							children: S("td", {
								colSpan: H.length + +!!a + +!!h,
								children: S("div", {
									className: "expanded-content",
									children: h.expandedRowRender(e, t)
								})
							})
						})] }, e.key ?? t);
					}) })]
				})
			}),
			o && U.length > 0 && !d && S("div", {
				className: "pagination-wrapper",
				children: S(Kc, {
					version: K.V2,
					totalItems: U.length,
					currentPage: N,
					onPageChange: P,
					defaultPageSize: s,
					showItemsPerPage: !0,
					showQuantityIndicator: !0,
					itemsPerPageOptions: c,
					onItemsPerPageChange: I,
					maxPagesToShow: 5,
					controlShape: Y.Square
				}, U.length)
			})
		]
	});
};
function Ml(e, t) {
	let n = e.filter((e) => t.includes(e.key)), r = e.filter((e) => !t.includes(e.key));
	return [...t.map((e) => n.find((t) => t.key === e)).filter((e) => e !== void 0), ...r];
}
function Nl(e) {
	return Object.values(e).map((e) => String(e ?? "")).join(" ");
}
function Pl(e, t) {
	let n = {};
	return t.forEach((t) => {
		let r = e.map((e) => String(e[t.dataIndex] ?? ""));
		n[t.dataIndex] = [...new Set(r)].filter((e) => e !== "");
	}), n;
}
function Fl(e, t, n, r) {
	let i = [...e];
	return i = Il(i, t), n && (i = Ll(i, n, r)), i;
}
function Il(e, t) {
	let n = [...e];
	return Object.entries(t).forEach(([e, t]) => {
		t?.length && (n = n.filter((n) => t.map((e) => e.toLowerCase()).includes(String(n[e] || "").toLowerCase())));
	}), n;
}
function Ll(e, t, n) {
	let r = n.find((e) => e.dataIndex === t.key)?.sortType ?? Z.String;
	return [...e].sort((e, n) => Gl(e[t.key], n[t.key], t.direction, r));
}
function Rl(e) {
	return !isNaN(e.getTime());
}
function zl(e) {
	if (typeof e == "string" || typeof e == "number") {
		let t = new Date(e);
		return Rl(t) ? t : null;
	}
	return null;
}
var Bl = (e, t, n) => {
	let r = zl(e), i = zl(t);
	return r && i ? n === "asc" ? r.getTime() - i.getTime() : i.getTime() - r.getTime() : r ? n === "asc" ? -1 : 1 : i ? n === "asc" ? 1 : -1 : 0;
}, Vl = (e, t, n) => {
	let r = Number(e), i = Number(t);
	return !isNaN(r) && !isNaN(i) ? n === "asc" ? r - i : i - r : 0;
}, Hl = (e, t, n) => {
	let r = String(e).replace(/[^a-zA-Z0-9]/g, "").toLowerCase(), i = String(t).replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
	return n === "asc" ? r.localeCompare(i) : i.localeCompare(r);
}, Ul = (e, t, n) => {
	let r = String(e).toLowerCase(), i = String(t).toLowerCase();
	return n === "asc" ? r.localeCompare(i) : i.localeCompare(r);
}, Wl = {
	[Z.Date]: Bl,
	[Z.Numeric]: Vl,
	[Z.Alphanumeric]: Hl,
	[Z.String]: Ul
};
function Gl(e, t, n, r = Z.String) {
	return e == null && t == null ? 0 : e == null ? n === "asc" ? -1 : 1 : t == null ? n === "asc" ? 1 : -1 : (Wl[r] || Ul)(e, t, n);
}
function Kl(e, t, n) {
	let r = (t - 1) * n;
	return e.slice(r, r + n);
}
jl.displayName = "ABITableV2";
var ql = /*#__PURE__*/ Object.freeze({
	__proto__: null,
	get RowDensity() {
		return $;
	},
	default: jl
}), Jl = l.lazy(() => Promise.resolve().then(function() {
	return Xc;
})), Yl = l.lazy(() => Promise.resolve().then(function() {
	return ql;
})), Xl = (e) => S(u, {
	fallback: null,
	children: e.version === K.V2 ? S(Yl, Object.assign({}, e)) : S(Jl, Object.assign({}, e))
});
Xl.displayName = "ABITable";
var Zl = l.lazy(() => Promise.resolve().then(function() {
	return ru;
})), Ql = l.lazy(() => Promise.resolve().then(function() {
	return su;
})), $l = (e) => S(u, {
	fallback: null,
	children: e.version === K.V2 ? S(Ql, Object.assign({}, e)) : S(Zl, Object.assign({}, e))
});
$l.displayName = "ABIChip";
var eu = "16px", tu = ({ className: e, width: t = eu, height: n, color: r, isLight: i = !1 }) => {
	let a = r || (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n || "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 -960 960 960",
		children: S("path", { d: "m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" })
	});
}, nu = ({ id: e, label: t, className: n = "", onDelete: r, "data-testid": i, icon: a, disabled: o = !1 }) => C("div", {
	id: e,
	className: `abi-chip ${o ? "abi-chip-disabled" : ""} ${n}`,
	"data-testid": i,
	children: [
		a && S("span", {
			className: "abi-chip-icon",
			children: a
		}),
		S("span", { children: t }),
		S("button", {
			onClick: r,
			className: "abi-chip-close-button",
			disabled: o,
			children: S(tu, {
				color: "var(--color-feedback-danger-300)",
				width: "1.35rem"
			})
		})
	]
});
nu.displayName = "ABIChipV1";
var ru = /*#__PURE__*/ Object.freeze({
	__proto__: null,
	default: nu
}), iu = "16px", au = ({ className: e, width: t = iu, height: n, color: r, isLight: i = !1 }) => {
	let a = r || (i ? "#FFFFFF" : "#000000");
	return S("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			width: typeof t == "number" ? `${t}px` : t,
			height: typeof n == "number" ? `${n}px` : n || "auto"
		},
		className: e,
		fill: a,
		viewBox: "0 -960 960 960",
		children: S("path", { d: "M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" })
	});
}, ou = ({ id: e, label: t, onDelete: n, onClick: r, "data-testid": i, disabled: a = !1, icon: o, className: s, onSelectChange: c }) => {
	let [l, u] = b(!1), [d, f] = b(!1), p = () => {
		if (a) return;
		let e = !l;
		u(e), c?.(e), r?.();
	}, m = (e) => {
		a || (u(!1), c?.(!1), n?.(e));
	};
	return C("button", {
		id: e,
		className: `abi-chip-container 
    ${a ? "chip--disabled" : ""} 
    ${l ? "chip--selected" : ""} 
    ${o ? "chip--with-icon" : ""} 
    ${d ? "chip--hovered" : ""} 
    ${s ?? ""}`,
		onClick: p,
		onMouseEnter: () => f(!0),
		onMouseLeave: () => f(!1),
		"data-testid": i,
		disabled: a,
		type: "button",
		children: [
			o && S("span", {
				className: "chip-icon",
				children: o
			}),
			l && !d && S("span", {
				className: "chip-checkmark",
				children: S(au, { color: l && d ? "var(--color-feedback-danger-400)" : "var(--color-feedback-info-400)" })
			}),
			t && S("span", {
				className: "chip-label",
				children: t
			}),
			l && d && S("button", {
				"data-testid": i,
				onClick: (e) => {
					e.stopPropagation(), m(e);
				},
				className: "chip-close-button",
				disabled: a,
				type: "button",
				children: S(tu, { color: "var(--color-feedback-danger-400)" })
			})
		]
	});
};
ou.displayName = "ABIChipV2";
var su = /*#__PURE__*/ Object.freeze({
	__proto__: null,
	ABIChipV2: ou,
	default: ou
}), cu;
(function(e) {
	e.Inside = "inside", e.Outside = "outside";
})(cu ||= {}), lc.Small, lc.Medium, lc.Large;
var lu;
(function(e) {
	e.Black = "black", e.Red = "red", e.Orange = "orange", e.Yellow = "yellow", e.Lime = "lime", e.ElectricLime = "electric-lime", e.Green = "green", e.Mint = "mint", e.Cyan = "cyan", e.Purple = "purple", e.Blue = "blue", e.Pink = "pink", e.Magenta = "magenta", e.Brown = "brown";
})(lu ||= {});
var uu;
(function(e) {
	e.Tight = "tight", e.Default = "default", e.Loose = "loose";
})(uu ||= {});
var du;
(function(e) {
	e.Static = "static", e.Clickable = "clickable";
})(du ||= {});
var fu;
(function(e) {
	e.Small = "small", e.Medium = "medium", e.Large = "large";
})(fu ||= {}), fu.Small, fu.Medium, fu.Large;
var pu;
(function(e) {
	e.Small = "small", e.Medium = "medium", e.Large = "large";
})(pu ||= {});
var mu;
(function(e) {
	e.Inside = "inside", e.Outside = "outside", e.Hidden = "hidden";
})(mu ||= {});
var hu;
(function(e) {
	e.InProgress = "inprogress", e.Success = "success", e.Error = "error";
})(hu ||= {});
var gu;
(function(e) {
	e.Vertical = "vertical", e.Horizontal = "horizontal";
})(gu ||= {});
var _u;
(function(e) {
	e.Main = "main", e.Secondary = "secondary";
})(_u ||= {});
//#endregion
//#region src/utils.ts
var vu = (e) => new Date((/* @__PURE__ */ new Date()).toLocaleString("en-US", { timeZone: e })), yu = /* @__PURE__ */ function(e) {
	return e.LOGOUT = "logout", e.SHOW_MODAL = "showModal", e;
}({}), bu = [
	{
		hour: 6,
		startMinute: 55,
		endMinute: 60,
		action: "showModal"
	},
	{
		hour: 14,
		startMinute: 55,
		endMinute: 60,
		action: "showModal"
	},
	{
		hour: 21,
		startMinute: 55,
		endMinute: 60,
		action: "showModal"
	},
	{
		hour: 2,
		startMinute: 55,
		endMinute: 60,
		action: "logout"
	}
], xu = ({ children: e, msalInstance: t, enableTimeout: n, modalDisplayTime: r = 300 * 1e3, continueSessionTime: i = 3600 * 1e3 }) => {
	let { t: a } = T(), [o, c] = b(!1), l = y(null), u = y(null), [d, f] = b(null), p = s("b12949ad-9779-4019-8671-eabc65320efb", "cef04b19-7776-4a94-b89b-375c77a8f936", h(L));
	t ??= p;
	let _ = n, v = m(() => {
		t.logoutRedirect({ postLogoutRedirectUri: null }).catch((e) => {
			console.error("Error during scheduled logout activity: ", e);
		}), console.info("Scheduled Logout Completed");
	}, [t]), w = Intl.DateTimeFormat().resolvedOptions().timeZone, E = m(() => {
		let e = vu(w), t = e.getHours(), n = e.getMinutes(), i = bu.filter((e) => e.action === yu.SHOW_MODAL), a = bu.filter((e) => e.action === yu.LOGOUT), o = (e, t, n) => t === e.hour && n >= e.startMinute && n < e.endMinute, s = i.some((e) => o(e, t, n)), l = a.some((e) => o(e, t, n));
		s ? (c(!0), f(new Date(e.getTime() + r))) : l && v();
	}, [
		w,
		r,
		v
	]), D = m(() => {
		c(!1);
		let e = new Date(Date.now() + i);
		f(e);
	}, [i]), O = m(() => {
		v();
	}, [v]);
	return g(() => {
		if (_) {
			if (d) {
				let e = d.getTime() - Date.now() - r;
				u.current && clearTimeout(u.current), u.current = setTimeout(() => c(!0), e), o && l.current && clearTimeout(l.current), o && (l.current = setTimeout(v, r));
			}
			return () => {
				l.current && clearTimeout(l.current), u.current && clearTimeout(u.current);
			};
		}
	}, [
		d,
		r,
		o,
		v,
		_
	]), g(() => {
		if (!_) return;
		let e = setInterval(E, 1e3 * 60);
		return () => clearInterval(e);
	}, [E, _]), /* @__PURE__ */ C(x, { children: [e, o && /* @__PURE__ */ C(Dc, {
		show: !0,
		isHeaderBorderBottom: !1,
		allRoundCorner: !0,
		variant: Ks.Default,
		title: a("authModal.title"),
		disableOverlayClick: !0,
		disableCloseButton: !0,
		closeOnEsc: !1,
		className: "session-timeout-modal",
		"data-testid": "session-timeout-modal",
		children: [/* @__PURE__ */ S("div", {
			className: "message-area",
			children: a("authModal.description")
		}), /* @__PURE__ */ C("div", {
			className: "button-area",
			children: [/* @__PURE__ */ S(xc, {
				onClick: O,
				size: q.md,
				variant: J.DangerOutline,
				isNotCapitalized: !0,
				"data-testid": "sign-out-now-button",
				children: a("authModal.signOut")
			}), /* @__PURE__ */ S(xc, {
				onClick: D,
				size: q.md,
				isNotCapitalized: !0,
				"data-testid": "continue-session-button",
				children: a("authModal.continue")
			})]
		})]
	})] });
}, Su = () => {
	let e = h(F);
	if (!e) throw Error("useGetToken must be used within a MsalTokenProvider");
	return e.getToken;
}, Cu = /* @__PURE__ */ function(e) {
	return e.AppAllAdmin = "App.All.Admin", e;
}({}), wu = /* @__PURE__ */ function(e) {
	return e.ZoneSupplyApprover = "App.BrewingSpecials.ZoneSupplyApprover", e.ZoneSupplyUser = "App.BrewingSpecials.ZoneSupplyUser", e.BreweryUser = "App.BrewingSpecials.BreweryUser", e.BreweryConfidentialUser = "App.BrewingSpecials.ConfidentialUser", e;
}({}), Tu = /* @__PURE__ */ function(e) {
	return e.HopsRecipeAdmin = "App.BrewingRecipes.HopRecipeAdmin", e.HopsRecipeEditor = "App.BrewingRecipes.HopRecipeEditor", e.HopsRecipeViewer = "App.BrewingRecipes.HopRecipeViewer", e;
}({}), Eu = /* @__PURE__ */ function(e) {
	return e.LiveDotsConfigurationEditor = "App.LiveDotsConfiguration.Editor", e.KpiCalcAdmin = "App.KPICalc.Admin", e.KpiCalcEditor = "App.KPICalc.Editor", e;
}({}), Du = /* @__PURE__ */ function(e) {
	return e.SparePartsUser = "App.SpareParts.User", e;
}({}), Ou = /* @__PURE__ */ function(e) {
	return e.CdcManagementViewer = "App.CdcManagement.Viewer", e.CdcManagementAdmin = "App.CdcManagement.Admin", e;
}({}), ku = /* @__PURE__ */ function(e) {
	return e.KpiTreeAdmin = "App.KPITree.Admin", e.KpiTreeUser = "App.KPITree.User", e;
}({}), Au = /* @__PURE__ */ function(e) {
	return e.UtilityOperator = "App.BlockedBeer.UtilityOperator", e.BreweryMasterAdmin = "App.BlockedBeer.BreweryMasterAdmin", e.SupportAdmin = "App.BlockedBeer.SupportAdmin", e.MasterZoneQaAdmin = "App.BlockedBeer.MasterZoneQaAdmin", e.OperationsAdmin = "App.BlockedBeer.OperationsAdmin", e.QualityAnalyst = "App.BlockedBeer.QualityAnalyst", e.QualityAnalystAdmin = "App.BlockedBeer.QualityAnalystAdmin", e.ReworkOperator = "App.BlockedBeer.ReworkOperator", e.WarehouseAdmin = "App.BlockedBeer.WarehouseAdmin", e;
}({});
//#endregion
export { xu as AutoLogoutHandler, Au as BlockedBeerRoles, o as BrowserCacheLocation, Ou as CdcManagementRoles, Eu as DotsRoles, e as EventType, Cu as GenericRoles, t as InteractionType, ku as KpiTreeRoles, E as MsalRoleContext, D as MsalRoleProvider, F as MsalTokenContext, I as MsalTokenProvider, O as PermissionContext, k as PermissionProvider, Tu as RecipesRoles, ee as RequireAuth, Du as SparePartsRoles, wu as SpecialsRoles, L as UserContext, R as UserProvider, M as useBreweryPermission, Su as useGetToken, a as useMsal, s as useMsalInstance, A as usePermission, N as usePermissionChecker, P as withPermission };

//# sourceMappingURL=index.js.map